import { Component, ElementRef, OnInit, HostListener, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, ValidatorFn, AbstractControl,NgModel } from '@angular/forms';
import { IUserDetails } from '../../models/user.model';
import { UserService } from '../../services/user.service';
import { ConfirmPasswordValidator } from "../../../shared/validators";
import { RegisterService } from '../../services/register.service';
import { LocalStorageService } from 'ngx-webstorage';
import { IRegister, OnshoreQuery, IStateCount, ReferenceQuery, OffshoreQuery } from '../../models/register.model';
import { ConfirmationService, ConfirmEventType, LazyLoadEvent, MenuItem, MessageService, PrimeNGConfig } from 'primeng/api';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedService, DataService } from '../../../shared/services';
import { VMSConstants } from '../../../shared/constants/vms-constants';
import { VerifyVendorNameValidator, VerifyVendorNamePreventSqlComments } from "../vendor-name-validator";
import { ILookupCategory } from '../../../shared/models/lookup.model';
import { ICountry } from '../../../applicant/models';
import { CompanyService } from '../../../users/services/company.service';
import { StateName } from '../../../shared/enums/StateName';
import { DialogService } from 'primeng/dynamicdialog';
import SignaturePad from "signature_pad";
import { jsPDF } from "jspdf";
import { LookupCategory } from '../../../shared/enums/EnumsVMS';
import { DatePipe } from '@angular/common';
import { DocViewerDialogComponent } from '../../../doc-viewer/doc-viewer-dialog/doc-viewer-dialog.component';
var htmlToPdfmake = require("html-to-pdfmake");
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { DomSanitizer } from '@angular/platform-browser';
(<any>pdfMake).vfs = pdfFonts?.pdfMake?.vfs;
(<any>pdfMake).fonts = {
  leckerli: {
    normal: `${window.location.origin}/assets/fonts/leckerli-one-v16-latin-regular.ttf`,
    bold: `${window.location.origin}/assets/fonts/leckerli-one-v16-latin-regular.ttf`,
    italics: `${window.location.origin}/assets/fonts/leckerli-one-v16-latin-regular.ttf`,
    bolditalics: `${window.location.origin}/assets/fonts/leckerli-one-v16-latin-regular.ttf`
  },
  cedarvillecursiveFont: {
    normal: `${window.location.origin}/assets/fonts/Cedarville-Cursive.ttf`,
    bold: `${window.location.origin}/assets/fonts/Cedarville-Cursive.ttf`,
    italics: `${window.location.origin}/assets/fonts/Cedarville-Cursive.ttf`,
    bolditalics: `${window.location.origin}/assets/fonts/Cedarville-Cursive.ttf`
  },
  Roboto: {
    normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
    bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
    italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
    bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
  }
}
@Component({
  selector: 'app-vendor-register-profile',
  templateUrl: './vendor-register-profile.component.html',
  styleUrls: ['./vendor-register-profile.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]
})
export class VendorRegisterProfileComponent implements OnInit {
  customvalue: any;
  registerProfileForm: FormGroup;
  myForm: FormGroup;
  loading = false;
  submitted = false;
  currentUser;
  RoleArray: any = ['Super Admin', 'Admin', 'Employee'];
  activeRoute: any;
  userName: string;
  taxIdNumber: string;
  taxIdNumberLength: number;
  state: string;
  vendorName: string;
  isVendorAvailability: boolean = false;
  states: any;
  stateId: any = 0;
  public selectedStateId: Array<any> = [];
  selectedState: string;
  categoryName;
  businessCertifications;
  businessCertificationIds;
  businessCertificationEditIds;
  selectedCountryIds;
  selectedCountriesEditIds;
  refArraySize: boolean = true;
  hbArraySize: boolean = true;
  public businessCertIds: Array<any> = [];
  public selectedCountries: Array<any> = [];
  companyId: number = 0;
  userId: number = 0;
  selectedItems;
  selectedCountriesVisa;
  countries: ICountry[];
  isSaveAvailable: boolean = false;
  vendorNameAvail: any;
  taxIdAvail: any;
  vendorEmail: any;
  vendorEmailAvail: any;
  adminEmailId:any;
  adminEmail: any;
  adminEmailAvail: any;
  disableVendorName: boolean = false;
  disableVendorEmail: boolean = false;
  disabled: boolean = true;
  zipCode: any;
  businessCertificationValid: boolean = true;
  selectedCountryValid: boolean = false;
  isSqlComments: boolean = false;
  isSqlCommentsOnFirstName: boolean = false;
  isSqlCommentsOnMiddleName: boolean = false;
  isSqlCommentsOnLastName: boolean = false;
  onShoreFields: OnshoreQuery[];
  offShoreFields: OffshoreQuery[];
  onReferenceFields: ReferenceQuery[];
  clientNameList;
  selectedClientIds;
  ClientIds;
  selectedClientValid: boolean = true;
  public CliIds: Array<any> = [];
  selectedClientItems;
  ClientEditIds;
  uploadedFile: File;
  uploadedDDFile: File;
  W9formUploadedPath: string;
  splittedW9formUploadedPath: string[];
  pdfSrc;
  //showPreview: boolean = false;
  DDUploadedPath: string;
  splittedDDUploadedPath: string[];
  DDpdfSrc;
  showDDPreview: boolean = false;
  w9fileuploadmessage: any;
  isw9fileShowsuccessmsg: boolean = false;
  w9FormFileExtension: string;
  w9FormDownload: String;
  isDDfileShowsuccessmsg: boolean = false;
  DDfileuploadmessage: string;
  DDFileExtension: string;
  isMSAfileShowsuccessmsg: boolean = false;
  MSAfileuploadmessage: string;
  MSAFileExtension: string;
  MSAUploadedPath: string;
  splittedMSAUploadedPath: string[];
  MSApdfSrc;
  showMSAPreview: boolean = false;
  uploadedMSAFile: File;
  selectCountryVisa;
  stateCount: IStateCount[] = [];
  removeEmpty = [];
  Alabama = 0;
  Alaska = 0;
  Arizona = 0;
  Arkansas = 0;
  California = 0;
  Colorado = 0;
  Connecticut = 0;
  Delaware = 0;
  Florida = 0;
  Georgia = 0;
  Hawaii = 0;
  Idaho = 0;
  Illinois = 0;
  Indiana = 0;
  Iowa = 0;
  Kansas = 0;
  Kentucky = 0;
  Louisiana = 0;
  Maine = 0;
  Maryland = 0;
  Massachusetts = 0;
  Michigan = 0;
  Minnesota = 0;
  Mississippi = 0;
  Missouri = 0;
  Montana = 0;
  Nebraska = 0;
  Nevada = 0;
  NewHampshire = 0;
  NewJersey = 0;
  NewMexico = 0;
  NewYork = 0;
  NorthCarolina = 0;
  NorthDakota = 0;
  Ohio = 0;
  Oklahoma = 0;
  Oregon = 0;
  Pennsylvania = 0;
  RhodeIsland = 0;
  SouthCarolina = 0;
  SouthDakota = 0;
  Tennessee = 0;
  Texas = 0;
  Utah = 0;
  Vermont = 0;
  Virginia = 0;
  Washington = 0;
  WestVirginia = 0;
  Wisconsin = 0;
  Wyoming = 0;
  entityTypeId: any;
  entityTypeEnable: boolean = true;
  entityTypes: ILookupCategory;
  entityDescription: string;
  public selectedEntityTypeId: Array<any> = [];
  public selectedClientRegistrationId: Array<any> = [];
  forIndividual: boolean = false;
  showOffShoreFields: boolean = false;
  showOPT: boolean = false;
  showTNVisa: boolean = false;
  isShowCertificateofInsurance = false;
  w9FormFileName: string;
  showW9FormFile: boolean = false;
  ddAuthorizationFileName: string;
  showDDAuthorizationFile: boolean = false;
  msaFileName: string;
  showMsaFile: boolean = false;
  uploadedInsuranceFile: File;
  isInsurancefileShowsuccessmsg: boolean = false;
  Insurancefileuploadmessage: string;
  showInsuranceFile: boolean = false;
  InsuranceFileExtension: string;
  InsuranceUploadedPath: string;
  splittedInsuranceUploadedPath: string[];
  InsurancepdfSrc;
  showInsurancePreview: boolean = false;
  insuranceFileName: string;
  glEffectiveDate: Date;
  glExpiryDate: Date;
  alEffectiveDate: Date;
  alExpiryDate: Date;
  ulEffectiveDate: Date;
  ulExpiryDate: Date;
  wcEffectiveDate: Date;
  wcExpiryDate: Date;
  plEffectiveDate: Date;
  plExpiryDate: Date;
  w9FormValid: boolean = true;
  ddAuthorizationValid: boolean = true;
  msaValid: boolean = true;
  coiValid: boolean = true;
  entityTypeEdit: string;
  saveModal: boolean = false;
  submitModal: boolean = false;
  isOwnerPhoneUniqueNumbers: boolean = false;
  isOwnerAlternatePhoneUniqueNumbers: boolean = false;
  isRecruitingPhoneUniqueNumbers: boolean = false;
  isRecruitingAlternatePhoneUniqueNumbers: boolean = false;
  isAccountingPhoneUniqueNumbers: boolean = false;
  isAccountingAlternatePhoneUniqueNumbers: boolean = false;
  isFinancialPhoneUniqueNumbers: boolean = false;
  isFinancialAlternatePhoneUniqueNumbers: boolean = false;
  isOwnerPhoneNumberValid: boolean = false;
  isOwnerAlternatePhoneNumberValid: boolean = false;
  isRecruitingPhoneNumberValid: boolean = false;
  isRecruitingAlternatePhoneNumberValid: boolean = false;
  isAccountingPhoneNumberValid: boolean = false;
  isAccountingAlternatePhoneNumberValid: boolean = false;
  isFinancialPhoneNumberValid: boolean = false;
  isFinancialAlternatePhoneNumberValid: boolean = false;
  isUserPhoneUniqueNumbers: boolean = false;
  isUserPhoneNumberValid: boolean = false;
  isVendorPhoneUniqueNumbers: boolean = false;
  isVendorPhoneNumberValid: boolean = false;
  isFaxUniqueNumbers: boolean = false;
  isFaxNumberValid: boolean = false;
  isOnshorePhoneUniqueNumbers: boolean = false;
  isOnshorePhoneNumberValid: boolean = false;
  isReferencePhoneNumberValid: boolean = false;
  emailEntityInvalid: boolean = false;
  emailInvalid: boolean = false;
  phoneNumber: string;
  phoneExtDisabled: boolean = true;
  vendorPhoneExtDisabled: boolean = true;
  lastYear: any;
  last2YearBefore: any;
  last3YearBefore: any;
  lastYearValue: any;
  last2YearBeforeValue: any;
  last3YearBeforeValue: any;
  allowedEmailList = ['gmail', 'yahoo', 'hotmail', 'hubspot', 'sendinblue', 'protonmail', 'outlook', 'zoho', 'aol', 'mail', 'gmx', 'icloud', 'yandex'];
  w9FileDocUrl: string = "https://dvmsstorage.blob.core.windows.net/applicant-document-files/APP000009834/";
  ddFileDocUrl: string = "https://dvmsstorage.blob.core.windows.net/applicant-document-files/APP000009834/";
  coiFileDocUrl: string = "https://dvmsstorage.blob.core.windows.net/applicant-document-files/APP000009834/";
  msaFileDocUrl: string = "https://dvmsstorage.blob.core.windows.net/applicant-document-files/APP000009834/";
  showW9FormFilePreview: boolean = false;
  showDDFormFilePreview: boolean = false;
  showMSAFormFilePreview: boolean = false;
  showCOIFormFilePreview: boolean = false;
  showW9FormFilePreviewEnable: boolean = false;
  showDDFormFilePreviewEnable: boolean = false;
  showMSAFormFilePreviewEnable: boolean = false;
  showCOIFormFilePreviewEnable: boolean = false;
  emailId;
  minExpDate: Date;
  loadClient: boolean = false;
  insuranceFileDisplayName;
  w9FileDisplayName;
  ddAuthorizationFileDisplayName;
  msaFileDisplayName;
  clientListForRegistration;
  clientIdOnRegistration;
  selectedClientValidOnRegistration: boolean = true;
  paymentTerms:ILookupCategory;
  paymentTermsId: any;
  public selectedPaymentTermsId:Array<any> = [];
  isPaymentTermsEnable:boolean =true;
  msaTooltipMsg: string = "This document requires your signature.Please download the given document,complete the necessary information, sign it, and upload it back to us";
 
  ipAddress: string;
////////////////////msa signing///start/////
title = 'signature-pad';
@ViewChild("canvas", { static: true }) canvas!: ElementRef;
sig!: SignaturePad;
public color: string = '#2889e9';
penColor = 'rgba(0,0,0,1)';
@ViewChild('printPdf') printPdf!: ElementRef;
signForm!: FormGroup;
yPosition: number = 15
text: any;
hrSign = 'data:image/png;base64,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';
currentDate;
taxIdOnMSADoc;
vendorNameOnMSADoc;
addressOnMSADoc;
address2OnMSADoc;
cityOnMSADoc;
stateOnMSADoc;
zipCodeOnMSADoc;
showMSAAccordion = false;
net30WithFeeOnMSADoc;
net45WithoutFeeOnMSADoc;
showGenerateButton: boolean = false;
pdfFile;
path: string = "../../../../../assets/img/first.png";
alttext: string="first image";
//text2test;
//@ViewChild('text2Container') text2Container: ElementRef;
//@ViewChild('content', {static: false}) content: ElementRef;
isSignatureTab:boolean = true;
isTextTab:boolean = false;
isImageUploadTab:boolean = false;
imageUploadedPath: string;
splittedImageUploadedPath: string[];
fileToUpload: any;
imageFile: string;
imageUrl: any;
defaultImage = "pi pi-user";
uploadImage: any = "";
imgBase64Path;
uploadedFileMSA: File;
net30WithFee:boolean= true;
net45WithoutFee:boolean=true;
dateOnDoc;
nameOnDocLength;
templateName;
msaTemplate;
logoOnMSA ='data:image/png;base64,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';
blobFile;
paymentTermsIdOnMSADoc;
////////////////////msa signing////////end////////
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private registerService: RegisterService,
    private userService: UserService,
    private storage: LocalStorageService,
    private messageService: MessageService,
    private spinner: NgxSpinnerService,
    private sharedService: SharedService,
    private dataService: DataService,
    private companyService: CompanyService,
    private confirmationService: ConfirmationService,
    public datePipe: DatePipe,
    private dialogService: DialogService,
  ) {
   // this.currentUser = this.storage.retrieve('currentuser');
    this.countries = [
      { name: 'USA', code: 'USA' },
      { name: 'India', code: 'IN' },
      { name: 'Pakistan', code: 'PAK' },
      { name: 'Istanbul', code: 'IST' },
      { name: 'Paris', code: 'PRS' }
    ];
  }

  ngOnInit(): void {
    this.getStates();
    this.reactiveForm();
    this.getBusinessCertifications();
    this.getClientNames();
    this.getSelectedCountryVisa();
    this.getEntityType();
    this.getPaymentTerms();
    this.getClientListForRegistration();
    this.lastYear = ((new Date()).getFullYear() - 1);
    this.last2YearBefore = ((new Date()).getFullYear() - 2);
    this.last3YearBefore = ((new Date()).getFullYear() - 3);
    this.adminEmailId=undefined;

    //used to get the user ip address
    this.getIpAddress();
    //msa document signing/////////////////////
    this.currentDate = new Date();
    this.dateOnDoc = this.sharedService.getAgreementDateFormat(this.currentDate);
    
    this.signForm = this.formBuilder.group({
      vendorName: new FormControl(''),
      name: new FormControl('', [Validators.required]),
      title: new FormControl('', [Validators.required]),
      signText: new FormControl(''),
    });
    this.sig = new SignaturePad(this.canvas.nativeElement, {
      penColor: this.penColor, minWidth: 1,
      maxWidth: 2
    });
    //msa doc signing end////////////////
    const param = this.route.snapshot.paramMap.get('userName');
    this.minExpDate = new Date();
    if (param) {
      this.userName = param;
    }
    if (this.userName != undefined) {
      this.registerService.GetRegisteredProfile(this.userName).subscribe((value: IRegister) => { 
        console.log(value);
        this.vendorNameOnMSADoc = value.vendorName;
        if (value.taxIdNumber!= null && value.taxIdNumber != "")
        {
            var taxIdStart = value.taxIdNumber.substring(0, 2);
            var taxIdEnd = value.taxIdNumber.substring(2, 7);
            this.taxIdOnMSADoc = taxIdStart + "-" + taxIdEnd;
        }
        //this.taxIdOnMSADoc = value.taxIdNumber;
        this.addressOnMSADoc = value.addressLine1;
        this.address2OnMSADoc = value.addressLine2;
        this.cityOnMSADoc = value.city;
        this.zipCodeOnMSADoc = value.zipCode;
        this.stateOnMSADoc = value.selectedState.stateName;
        this.adminEmailId = value.adminEmailId;
        if (value.referenceFields.length > 0) {
          for (var d = 0; d < value.referenceFields.length; d++) {
            if (value.referenceFields[d].refRevenue != null) {
              value.referenceFields[d].refRevenueView = value.referenceFields[d].refRevenue.toFixed(2);
            }
          }
        }
        if (value.companyRevenueLastYear != null || value.companyRevenueLastYear != undefined) {
          var firstYear = value.companyRevenueLastYear.split("-", 2);
          this.lastYear = firstYear[0];
          this.lastYearValue = firstYear[1];
        }
        if (value.companyRevenue2YearsBefore != null || value.companyRevenue2YearsBefore != undefined) {
          var secondYear = value.companyRevenue2YearsBefore.split("-", 2);
          this.last2YearBefore = secondYear[0];
          this.last2YearBeforeValue = secondYear[1];
        }
        if (value.companyRevenue3YearsBefore != null || value.companyRevenue3YearsBefore != undefined) {
          var thirdYear = value.companyRevenue3YearsBefore.split("-", 2);
          this.last3YearBefore = thirdYear[0];
          this.last3YearBeforeValue = thirdYear[1];
        }
        setTimeout(() => {
          this.registerService.GetSelectedBusinessCertifications(value.businessCertificationIds).subscribe((data: any) => {
            //this.selectedItems = "You may select multiple certifications";

            if (data.length == 0) {
              this.businessCertificationValid = true;
            }
            else {
              this.businessCertificationValid = false;
              for (var i = 0; i < data.length; i++) {
                for (var j = 0; j < this.businessCertifications.length; j++) {
                  if (data[i].description == this.businessCertifications[j].description) {
                    this.businessCertIds.push(this.businessCertifications[j]);
                    this.selectedItems = this.selectedItems + this.businessCertifications[j].description;
                    if (this.businessCertificationEditIds == undefined) {
                      this.businessCertificationEditIds = this.businessCertifications[j].lookupId;
                    }
                    else {
                      this.businessCertificationEditIds = this.businessCertificationEditIds + ',' + this.businessCertifications[j].lookupId;
                    }
                  }
                }
              }
            }
          }),
            this.registerService.GetSelectedCountryVisa(value.tnVisaCountries).subscribe((data: any) => {
              if (data.length == 0) {
                //this.selectedCountryValid = true;
              }
              else {
                this.selectedCountryValid = false;
                for (var i = 0; i < data.length; i++) {
                  for (var j = 0; j < this.selectCountryVisa.length; j++) {
                    if (data[i].description == this.selectCountryVisa[j].description) {
                      this.selectedCountries.push(this.selectCountryVisa[j]);
                      this.selectedCountriesVisa = this.selectedCountriesVisa + this.selectCountryVisa[j].description;
                      if (this.selectedCountriesEditIds == undefined) {
                        this.selectedCountriesEditIds = this.selectCountryVisa[j].lookupId;
                      }
                      else {
                        this.selectedCountriesEditIds = this.selectedCountriesEditIds + ',' + this.selectCountryVisa[j].lookupId;
                      }
                    }
                  }
                }
              }
            }),
            setTimeout(() => {
              this.registerService.GetSelectedClientIds(value.clientIds).subscribe((data: any) => {
                if (data.length == 0) {
                  this.selectedClientValid = true;
                }
                else {
                  this.selectedClientValid = false;
                  for (var i = 0; i < data.length; i++) {
                    for (var j = 0; j < this.clientNameList.length; j++) {
                      if (data[i].companyName == this.clientNameList[j].companyName) {
                        this.CliIds.push(this.clientNameList[j]);
                        this.selectedClientItems = this.selectedClientItems + this.clientNameList[j].companyName;
                        if (this.ClientEditIds == undefined) {
                          this.ClientEditIds = this.clientNameList[j].companyId;
                        }
                        else {
                          this.ClientEditIds = this.ClientEditIds + ',' + this.clientNameList[j].companyId;
                        }
                      }
                    }
                  }
                }
              });
            }, 3000);
          this.stateCount = value.stateCount;

          for (var i = 0; i < this.stateCount.length; i++) {
            if (this.stateCount[i].stateName == 'Alabama') {
              this.Alabama = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Alaska') {
              this.Alaska = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Arizona') {
              this.Arizona = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Arkansas') {
              this.Arkansas = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'California') {
              this.California = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Colorado') {
              this.Colorado = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Connecticut') {
              this.Connecticut = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Delaware') {
              this.Delaware = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Florida') {
              this.Florida = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Georgia') {
              this.Georgia = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Alaska') {
              this.Alaska = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Hawaii') {
              this.Hawaii = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Idaho') {
              this.Idaho = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Illinois') {
              this.Illinois = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Indiana') {
              this.Indiana = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Iowa') {
              this.Iowa = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Kansas') {
              this.Kansas = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Kentucky') {
              this.Kentucky = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Louisiana') {
              this.Louisiana = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Maine') {
              this.Maine = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Maryland') {
              this.Maryland = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Massachusetts') {
              this.Massachusetts = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Michigan') {
              this.Michigan = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Minnesota') {
              this.Minnesota = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Mississippi') {
              this.Mississippi = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Missouri') {
              this.Missouri = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Montana') {
              this.Montana = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Maryland') {
              this.Maryland = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Nebraska') {
              this.Nebraska = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Nevada') {
              this.Nevada = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'New Hampshire') {
              this.NewHampshire = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'New Jersey') {
              this.NewJersey = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'New Mexico') {
              this.NewMexico = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'New York') {
              this.NewYork = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'North Carolina') {
              this.NorthCarolina = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'North Dakota') {
              this.NorthDakota = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Ohio') {
              this.Ohio = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Oklahoma') {
              this.Oklahoma = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Oregon') {
              this.Oregon = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Pennsylvania') {
              this.Pennsylvania = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Rhode Island') {
              this.RhodeIsland = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'South Carolina') {
              this.SouthCarolina = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'South Dakota') {
              this.SouthDakota = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Tennessee') {
              this.Tennessee = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Texas') {
              this.Texas = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Utah') {
              this.Utah = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Vermont') {
              this.Vermont = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Virginia') {
              this.Virginia = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Washington') {
              this.Washington = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'West Virginia') {
              this.WestVirginia = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Wisconsin') {
              this.Wisconsin = this.stateCount[i].count;
            }
            else if (this.stateCount[i].stateName == 'Wyoming') {
              this.Wyoming = this.stateCount[i].count;
            }

          }
          this.isSaveAvailable = true;
          this.disableVendorName = true;
          this.disableVendorEmail = true;
          this.companyId = value.companyId;
          this.userId = value.userId;
          this.businessCertificationIds = value.businessCertificationIds;
          this.stateId = value.stateId;
          this.selectedStateId = value.selectedState;
          this.onShoreFields = value.onshoreFields;
          if (value.offshoreFields.length > 0) {
            this.showOffShoreFields = true;
          }
          this.offShoreFields = value.offshoreFields;
          this.onReferenceFields = value.referenceFields;
          this.enableZipCodeExt();
          this.phoneExtDisabled = false;
          this.W9formUploadedPath = value.w9FormFileUrl;
          if (value.w9FormFileUrl == '' || value.w9FormFileUrl == null || value.w9FormFileUrl == '') {
            this.w9FormValid = true;
            this.showW9FormFilePreviewEnable = false;
          }
          else {
            this.w9FormValid = false;
            this.showW9FormFilePreviewEnable = true;
          }
          if (value.ddAuthorizationFileUrl == '' || value.ddAuthorizationFileUrl == null || value.ddAuthorizationFileUrl == '') {
            this.ddAuthorizationValid = true;
            this.showDDFormFilePreviewEnable = false;
          }
          else {
            this.ddAuthorizationValid = false;
            this.showDDFormFilePreviewEnable = true;
          }
          if (value.insuranceFileUrl == '' || value.insuranceFileUrl == null || value.insuranceFileUrl == '') {
            this.coiValid = true;
            this.showCOIFormFilePreviewEnable = false;
          }
          else {
            this.coiValid = false;
            this.showCOIFormFilePreviewEnable = true;
          }
          if (value.msaFileUrl == '' || value.msaFileUrl == null || value.msaFileUrl == '') {
            this.msaValid = true;
            this.showMSAFormFilePreviewEnable = false;
          }
          else {
            this.msaValid = false;
            this.showMSAFormFilePreviewEnable = true;
          }

          if (value.zipCode != null || value.zipCode != undefined) {
            this.disabled = false;
          }
          if (this.W9formUploadedPath != null && this.W9formUploadedPath != "") {
            this.splittedW9formUploadedPath = this.W9formUploadedPath.split("/");
          }
          this.DDUploadedPath = value.ddAuthorizationFileUrl;
          if (this.DDUploadedPath != null && this.DDUploadedPath != "") {
            this.splittedDDUploadedPath = this.DDUploadedPath.split("/");
          }
          this.MSAUploadedPath = value.msaFileUrl;
          if (this.MSAUploadedPath != null && this.MSAUploadedPath != "") {
            this.splittedMSAUploadedPath = this.MSAUploadedPath.split("/");
          }
          //this.addOnshoreFields();
          this.registerService.getEntityType(value.entityTypeId).subscribe((data: any) => {
            this.selectedEntityTypeId = data;
            this.entityTypeEdit = data.description;
            this.entityTypeId = value.entityTypeId;
            setTimeout(() => {
              this.getEntityTypeOnChangeEdit();
            }, 2000);
          });
          if (value.paymentTermsId != null) {
          this.companyService.getPaymentTerms(value.paymentTermsId).subscribe((data:any) =>{
            this.selectedPaymentTermsId = data;
            this.paymentTermsId = value.paymentTermsId;
            this.paymentTermsIdOnMSADoc = value.paymentTermsId;
            if(value.paymentTermsId ==1)
            {
              this.net30WithFeeOnMSADoc = 'No';
              this.net45WithoutFeeOnMSADoc ='Yes';
              this.net30WithFee = false;
              this.net45WithoutFee = true;
            }
            else if(value.paymentTermsId ==2)
            {
               this.net45WithoutFeeOnMSADoc = 'No';
               this.net30WithFeeOnMSADoc ='Yes';
               this.net30WithFee = true;
               this.net45WithoutFee = false;
            }
            this.isPaymentTermsEnable = false;
          });
        }
          if (value.clientIdOnRegistration != null) {
            this.registerService.getClientListForRegistration(value.clientIdOnRegistration).subscribe((data: any) => {
              this.selectedClientRegistrationId = data;
              this.selectedClientValidOnRegistration = false;
            });
          }
          if (value.isOPTStudents == true) {
            this.showOPT = true;
          }
          else if (value.isOPTStudents == false) {
            this.showOPT = false;
          }
          if (value.isSupportTNVisa == true) {
            this.showTNVisa = true;
          }
          else if (value.isSupportTNVisa == false) {
            this.showTNVisa = false;
          }
          if (value.w9FormFileUrl != null && value.w9FormFileUrl != '') {
            this.w9FormFileName = value.w9FormFileUrl;
            this.w9FileDisplayName = value.w9FormFileUrl.split('\\').pop().split('/').pop();
            this.showW9FormFile = true;
            this.getW9FormFile();
          }
          if (value.ddAuthorizationFileUrl != null && value.ddAuthorizationFileUrl != '') {
            this.ddAuthorizationFileName = value.ddAuthorizationFileUrl;
            this.ddAuthorizationFileDisplayName = value.ddAuthorizationFileUrl.split('\\').pop().split('/').pop();
            this.showDDAuthorizationFile = true;
            this.getDDAuthorizationFile();
          }
          if (value.msaFileUrl != null && value.msaFileUrl != '') {
            this.msaFileName = value.msaFileUrl;
            this.msaFileDisplayName = value.msaFileUrl.split('\\').pop().split('/').pop();
            this.showMsaFile = true;
            this.getMSAFile();
          }
          if (value.insuranceFileUrl != null && value.insuranceFileUrl != '') {
            this.insuranceFileName = value.insuranceFileUrl;
            this.insuranceFileDisplayName = value.insuranceFileUrl.split('\\').pop().split('/').pop();
            this.showInsuranceFile = true;
            this.getInsuranceFile();
          }

          this.glEffectiveDate = value.glEffDate != null ? new Date(value.glEffDate) : null;
          this.glExpiryDate = value.glExpDate != null ? new Date(value.glExpDate) : null;
          this.alEffectiveDate = value.alEffDate != null ? new Date(value.alEffDate) : null;
          this.alExpiryDate = value.alExpDate != null ? new Date(value.alExpDate) : null;
          this.ulEffectiveDate = value.ulEffDate != null ? new Date(value.ulEffDate) : null;
          this.ulExpiryDate = value.ulExpDate != null ? new Date(value.ulExpDate) : null;
          this.wcEffectiveDate = value.wcEffDate != null ? new Date(value.wcEffDate) : null;
          this.wcExpiryDate = value.wcExpDate != null ? new Date(value.wcExpDate) : null;;
          this.plEffectiveDate = value.plEffDate != null ? new Date(value.plEffDate) : null;
          this.plExpiryDate = value.plExpDate != null ? new Date(value.plExpDate) : null;
          if (value.vendorPhoneNumber == null || value.vendorPhoneNumber == undefined || value.vendorPhoneNumber == '') {
            this.vendorPhoneExtDisabled = true;
          }
          else {
            this.vendorPhoneExtDisabled = false;
          }
          this.clientIdOnRegistration = value.clientIdOnRegistration;
          setTimeout(() => {
            this.registerProfileForm = this.formBuilder.group({
              companyId: new FormControl(value.companyId),
              vendorName: new FormControl(value.vendorName, [Validators.required]),
              verifyVendorName: new FormControl(value.vendorName),
              vendorShortName: new FormControl(value.vendorShortName),
              vendorEmailId: new FormControl(value.vendorEmailId, [Validators.required]),
              vendorPhoneNumber: new FormControl(value.vendorPhoneNumber, [Validators.required]),
              vendorPhoneExtNumber: new FormControl(value.vendorPhoneExtNumber, [Validators.pattern(VMSConstants.phoneExtValidator)]),
              faxNumber: new FormControl(value.faxNumber),
              addressLine1: new FormControl(value.addressLine1, [Validators.required]),
              addressLine2: new FormControl(value.addressLine2),
              webAddress: new FormControl(value.webAddress, [Validators.pattern(VMSConstants.urlRegex)]),
              taxIdNumber: new FormControl(value.taxIdNumber),
              city: new FormControl(value.city),
              zipCode: new FormControl(value.zipCode, [Validators.required, Validators.pattern(VMSConstants.zipcodeValidator)]),
              zipCodeExt: new FormControl(value.zipCodeExt, [Validators.pattern(VMSConstants.zipcodeExtValidator)]),
              companyEstablishment: new FormControl(value.companyEstablishment),
              companysKeyCapabilities: new FormControl(value.companysKeyCapabilities, [this.editorMaxLength(10000)]),
              corporateHistory: new FormControl(value.corporateHistory, [this.editorMaxLength(10000)]),
              awardsAndCertifications: new FormControl(value.awardsAndCertifications, [this.editorMaxLength(5000)]),
              isEVerifyRegistered: new FormControl(value.isEVerifyRegistered),
              isOfferACAAct: new FormControl(value.isOfferACAAct),
              leadership: new FormControl(value.leadership, [this.editorMaxLength(10000)]),
              ownerName: new FormControl(value.ownerName),
              ownerTitle: new FormControl(value.ownerTitle),
              ownerEmail: new FormControl(value.ownerEmail),
              ownerPhone: new FormControl(value.ownerPhone),
              ownerAlternatePhone: new FormControl(value.ownerAlternatePhone),
              recruitingName: new FormControl(value.recruitingName),
              recruitingTitle: new FormControl(value.recruitingTitle),
              recruitingEmail: new FormControl(value.recruitingEmail, [Validators.pattern(VMSConstants.emailValidator)]),
              recruitingPhone: new FormControl(value.recruitingPhone),
              recruitingAlternatePhone: new FormControl(value.recruitingAlternatePhone),
              financialName: new FormControl(value.financialName),
              financialTitle: new FormControl(value.financialTitle),
              financialEmail: new FormControl(value.financialEmail, [Validators.pattern(VMSConstants.emailValidator)]),
              financialPhone: new FormControl(value.financialPhone),
              financialAlternatePhone: new FormControl(value.financialAlternatePhone),
              accountingName: new FormControl(value.accountingName),
              accountingTitle: new FormControl(value.accountingTitle),
              accountingEmail: new FormControl(value.accountingEmail, [Validators.pattern(VMSConstants.emailValidator)]),
              accountingPhone: new FormControl(value.accountingPhone),
              accountingAlternatePhone: new FormControl(value.accountingAlternatePhone),
              firstName: new FormControl(value.firstName, [Validators.required]),
              middleName: new FormControl(value.middleName),
              lastName: new FormControl(value.lastName, [Validators.required]),
              adminEmailId: new FormControl(value.adminEmailId, [Validators.required]),
              //phoneNumber: new FormControl(value.phoneNumber,[Validators.required]),
              phoneNumber: new FormControl(value.phoneNumber, [Validators.required]),
              extNumber: new FormControl(value.extNumber, [Validators.pattern(VMSConstants.phoneExtValidator)]),
              companyRevenueLastYear: new FormControl(this.lastYearValue),
              companyRevenue2YearsBefore: new FormControl(this.last2YearBeforeValue),
              companyRevenue3YearsBefore: new FormControl(this.last3YearBeforeValue),
              noofW2Employees: new FormControl(value.noofW2Employees),
              noofC2CConsultant: new FormControl(value.noofC2CConsultant),
              isOPTStudents: new FormControl(value.isOPTStudents),
              offShoreToggle: new FormControl(this.showOffShoreFields),
              noofOPTCandidatesAvailable: new FormControl(value.noofOPTCandidatesAvailable),
              oPTTechnologyTrain: new FormControl(value.optTechnologyTrain),
              isSupportTNVisa: new FormControl(value.isSupportTNVisa),
              noofTNVisaCandidates: new FormControl(value.noofTNVisaCandidates),
              availableCandidateBench: new FormControl(value.availableCandidateBench, [this.editorMaxLength(1000)]),
              alabama: new FormControl(this.Alabama),
              alaska: new FormControl(this.Alaska),
              arizona: new FormControl(this.Arizona),
              arkansas: new FormControl(this.Arkansas),
              california: new FormControl(this.California),
              colorado: new FormControl(this.Colorado),
              connecticut: new FormControl(this.Connecticut),
              delaware: new FormControl(this.Delaware),
              florida: new FormControl(this.Florida),
              georgia: new FormControl(this.Georgia),
              hawaii: new FormControl(this.Hawaii),
              idaho: new FormControl(this.Idaho),
              illinois: new FormControl(this.Illinois),
              indiana: new FormControl(this.Indiana),
              iowa: new FormControl(this.Iowa),
              kansas: new FormControl(this.Kansas),
              kentucky: new FormControl(this.Kentucky),
              louisiana: new FormControl(this.Louisiana),
              maine: new FormControl(this.Maine),
              maryland: new FormControl(this.Maryland),
              massachusetts: new FormControl(this.Massachusetts),
              michigan: new FormControl(this.Michigan),
              minnesota: new FormControl(this.Minnesota),
              mississippi: new FormControl(this.Mississippi),
              missouri: new FormControl(this.Missouri),
              montana: new FormControl(this.Montana),
              nebraska: new FormControl(this.Nebraska),
              nevada: new FormControl(this.Nevada),
              newHampshire: new FormControl(this.NewHampshire),
              newJersey: new FormControl(this.NewJersey),
              newMexico: new FormControl(this.NewMexico),
              newYork: new FormControl(this.NewYork),
              northCarolina: new FormControl(this.NorthCarolina),
              northDakota: new FormControl(this.NorthDakota),
              ohio: new FormControl(this.Ohio),
              oklahoma: new FormControl(this.Oklahoma),
              oregon: new FormControl(this.Oregon),
              pennsylvania: new FormControl(this.Pennsylvania),
              rhodeIsland: new FormControl(this.RhodeIsland),
              southCarolina: new FormControl(this.SouthCarolina),
              southDakota: new FormControl(this.SouthDakota),
              tennessee: new FormControl(this.Tennessee),
              texas: new FormControl(this.Texas),
              utah: new FormControl(this.Utah),
              vermont: new FormControl(this.Vermont),
              virginia: new FormControl(this.Virginia),
              washington: new FormControl(this.Washington),
              westVirginia: new FormControl(this.WestVirginia),
              wisconsin: new FormControl(this.Wisconsin),
              wyoming: new FormControl(this.Wyoming),
              glEffDate: new FormControl(this.glEffectiveDate),
              glExpDate: new FormControl(this.glExpiryDate),
              alEffDate: new FormControl(this.alEffectiveDate),
              alExpDate: new FormControl(this.alExpiryDate),
              ulEffDate: new FormControl(this.ulEffectiveDate),
              ulExpDate: new FormControl(this.ulExpiryDate),
              wcEffDate: new FormControl(this.wcEffectiveDate),
              wcExpDate: new FormControl(this.wcExpiryDate),
              plEffDate: new FormControl(this.plEffectiveDate,),
              plExpDate: new FormControl(this.plExpiryDate),
              comments: new FormControl(value.comments),
              onshoreFields: new FormArray(value.onshoreFields.map(onshore => this.formBuilder.group({
                contactName: [onshore.contactName],
                phone: [onshore.phone],
                officeCityState: [onshore.officeCityState],
                address: [onshore.address],
              }))),
              offshoreFields: new FormArray(value.offshoreFields.map(offshore => this.formBuilder.group({
                address: [offshore.address],
                city: [offshore.city],
                state: [offshore.state],
                country: [offshore.country],
              }))),
              referenceFields: new FormArray(value.referenceFields.map(reference => this.formBuilder.group({
                refClientName: [reference.refClientName],
                refContactName: [reference.refContactName],
                refContactTitle: [reference.refContactTitle],
                refContactEmail: [reference.refContactEmail],
                refContactPhoneNumber: [reference.refContactPhoneNumber],
                refIndustry: [reference.refIndustry],
                refDurationOfPartnership: [reference.refDurationOfPartnership],
                refServicesProvided: [reference.refServicesProvided],
                refRevenue: [reference.refRevenueView],
              }))),
            });
            if (value.onshoreFields.length == 0) {
              this.addOnshoreFields();
            }
            if (value.referenceFields.length == 0) {
              this.addReference();
            }
           
          }, 500);
        }, 500);
      });
    }
    this.getTemplate();
    
  }
  getTemplate()
  {
    this.templateName='MSA Company Edit';
    this.registerService.GetRegistrationTemplate(this.templateName).subscribe((data:any)=>{
      console.log(data);
      this.msaTemplate =data.description;
      //console.log(this.msaTemplate);
    });
  }
  reactiveForm() {
    this.registerProfileForm = this.formBuilder.group({
      vendorName: [''],
      verifyVendorName: [''],
      vendorShortName: [''],
      vendorEmailId: ['', [Validators.required, Validators.pattern(VMSConstants.emailValidator)]],
      vendorPhoneNumber: [''],
      vendorPhoneExtNumber: ['', [Validators.pattern(VMSConstants.phoneExtValidator)]],
      faxNumber: [''],
      addressLine1: [''],
      addressLine2: [''],
      webAddress: [''],
      taxIdNumber: [''],
      city: [''],
      zipCode: ['', [Validators.required, Validators.pattern(VMSConstants.zipcodeValidator)]],
      zipCodeExt: ['', [Validators.pattern(VMSConstants.zipcodeExtValidator)]],
      companyEstablishment: [''],
      companysKeyCapabilities: ['', this.editorMaxLength(10000)],
      corporateHistory: ['', this.editorMaxLength(10000)],
      awardsAndCertifications: ['', this.editorMaxLength(5000)],
      isEVerifyRegistered: [false],
      isOfferACAAct: [false],
      leadership: ['', this.editorMaxLength(10000)],
      ownerName: [''],
      ownerTitle: [''],
      ownerEmail: ['', [Validators.pattern(VMSConstants.emailValidator)]],
      ownerPhone: [''],
      ownerAlternatePhone: [''],
      recruitingName: [''],
      recruitingTitle: [''],
      recruitingEmail: ['', [Validators.pattern(VMSConstants.emailValidator)]],
      recruitingPhone: [''],
      recruitingAlternatePhone: [''],
      financialName: [''],
      financialTitle: [''],
      financialEmail: [''],
      financialPhone: [''],
      financialAlternatePhone: [''],
      accountingName: [''],
      accountingTitle: [''],
      accountingEmail: ['', [Validators.pattern(VMSConstants.emailValidator)]],
      accountingPhone: [''],
      accountingAlternatePhone: [''],
      firstName: [''],
      middleName: [''],
      lastName: [''],
      adminEmailId: [''],
      phoneNumber: [''],
      extNumber: ['', [Validators.pattern(VMSConstants.phoneExtValidator)]],
      companyRevenueLastYear: [''],
      companyRevenue2YearsBefore: [''],
      companyRevenue3YearsBefore: [''],
      noofW2Employees: [''],
      noofC2CConsultant: [''],
      isOPTStudents: [false],
      offShoreToggle: [false],
      noofOPTCandidatesAvailable: [''],
      oPTTechnologyTrain: [''],
      isSupportTNVisa: [false],
      noofTNVisaCandidates: [''],
      availableCandidateBench: ['', this.editorMaxLength(1000)],
      alabama: ['0'],
      alaska: ['0'],
      arizona: ['0'],
      arkansas: ['0'],
      california: ['0'],
      colorado: ['0'],
      connecticut: ['0'],
      delaware: ['0'],
      florida: ['0'],
      georgia: ['0'],
      hawaii: ['0'],
      idaho: ['0'],
      illinois: ['0'],
      indiana: ['0'],
      iowa: ['0'],
      kansas: ['0'],
      kentucky: ['0'],
      louisiana: ['0'],
      maine: ['0'],
      maryland: ['0'],
      massachusetts: ['0'],
      michigan: ['0'],
      minnesota: ['0'],
      mississippi: ['0'],
      missouri: ['0'],
      montana: ['0'],
      nebraska: ['0'],
      nevada: ['0'],
      newHampshire: ['0'],
      newJersey: ['0'],
      newMexico: ['0'],
      newYork: ['0'],
      northCarolina: ['0'],
      northDakota: ['0'],
      ohio: ['0'],
      oklahoma: ['0'],
      oregon: ['0'],
      pennsylvania: ['0'],
      rhodeIsland: ['0'],
      southCarolina: ['0'],
      southDakota: ['0'],
      tennessee: ['0'],
      texas: ['0'],
      utah: ['0'],
      vermont: ['0'],
      virginia: ['0'],
      washington: ['0'],
      westVirginia: ['0'],
      wisconsin: ['0'],
      wyoming: ['0'],
      glEffDate: [],
      glExpDate: [],
      alEffDate: [],
      alExpDate: [],
      ulEffDate: [],
      ulExpDate: [],
      wcEffDate: [],
      wcExpDate: [],
      plEffDate: [],
      plExpDate: [],
      comments: [''],
      onshoreFields: new FormArray([
        this.formBuilder.group({
          contactName: new FormControl(''),
          phone: new FormControl(''),
          officeCityState: new FormControl(''),
          address: new FormControl(''),
        })
      ]),
      offshoreFields: new FormArray([
        this.formBuilder.group({
          address: new FormControl(''),
          city: new FormControl(''),
          state: new FormControl(''),
          country: new FormControl(''),
        })
      ]),
      referenceFields: new FormArray([this.formBuilder.group({
        refClientName: new FormControl(''),
        refContactName: new FormControl(''),
        refContactTitle: new FormControl(''),
        refContactEmail: new FormControl('', [Validators.pattern(VMSConstants.emailValidator)]),
        refContactPhoneNumber: new FormControl(''),
        refIndustry: new FormControl(''),
        refDurationOfPartnership: new FormControl(''),
        refServicesProvided: new FormControl(''),
        refRevenue: new FormControl(''),
      })]),
    });
  }

  get onshoreFields(): FormArray {
    return this.registerProfileForm.get("onshoreFields") as FormArray;
  }

  addOnshoreFields() {
    if (this.registerProfileForm.get("onshoreFields").value.length > 1) {
      this.hbArraySize = false;
    }
    let onshoreFields = this.registerProfileForm.get("onshoreFields") as FormArray;
    let newOnshoreFields = this.formBuilder.group({
      contactName: new FormControl(''),
      phone: new FormControl(''),
      officeCityState: new FormControl(''),
      address: new FormControl(''),
    });
    onshoreFields.push(newOnshoreFields);
  }
  removeOnshoreFields(i: number) {

    if (i == 0) {
      this.messageService.add({ severity: 'info', summary: 'Info', detail: 'One Headquaters/Branches is Mandatory' });
    }
    else {
      if (this.onShoreFields != undefined) {
        if (i < this.onShoreFields.length) {
          this.registerService.deleteOnShoreDetails(this.onShoreFields[i].onshoreCompanyDetailsId).subscribe((data: any) => {

          });
        }
      }
      let arr = this.registerProfileForm.get("onshoreFields") as FormArray;
      arr.removeAt(i);
      if (i <= 2) {
        this.hbArraySize = true;
      }
    }


    // if (this.onShoreFields != undefined) {
    //   if (i < this.onShoreFields.length) {
    //     this.registerService.deleteOnShoreDetails(this.onShoreFields[i].onshoreCompanyDetailsId).subscribe((data: any) => {
    //     });
    //   }
    // }
    // let arr = this.registerProfileForm.get("onshoreFields") as FormArray;
    // arr.removeAt(i);
  }

  get offshoreFields(): FormArray {
    return this.registerProfileForm.get("offshoreFields") as FormArray;
  }

  addOffshoreFields() {
    let offshoreFields = this.registerProfileForm.get("offshoreFields") as FormArray;
    let newOffshoreFields = this.formBuilder.group({
      address: new FormControl(''),
      city: new FormControl(''),
      state: new FormControl(''),
      country: new FormControl(''),
    });
    offshoreFields.push(newOffshoreFields);
  }
  removeOffshoreFields(i: number) {
    if (this.offShoreFields != undefined) {
      if (i < this.offShoreFields.length) {
        this.registerService.deleteOffShoreDetails(this.offShoreFields[i].offshoreCompanyDetailsId).subscribe((data: any) => {
        });
      }
    }
    let arr = this.registerProfileForm.get("offshoreFields") as FormArray;
    arr.removeAt(i);
  }

  get referenceFields(): FormArray {
    return this.registerProfileForm.get("referenceFields") as FormArray;
  }
  addReference() {
    if (this.registerProfileForm.get("referenceFields").value.length > 1) {
      this.refArraySize = false;
    }
    let referenceFields = this.registerProfileForm.get("referenceFields") as FormArray;
    let newReferenceFields = this.formBuilder.group({
      refClientName: new FormControl(''),
      refContactName: new FormControl(''),
      refContactTitle: new FormControl(''),
      refContactEmail: new FormControl(''),
      refContactPhoneNumber: new FormControl(''),
      refIndustry: new FormControl(''),
      refDurationOfPartnership: new FormControl(''),
      refServicesProvided: new FormControl(''),
      refRevenue: new FormControl(''),
    });
    referenceFields.push(newReferenceFields);
  }

  removeReferenceFields(i: number) {
    if (i == 0) {
      this.messageService.add({ severity: 'info', summary: 'Info', detail: 'One Reference Details is Mandatory' });
    }
    else {
      if (this.onReferenceFields != undefined) {
        if (i < this.onReferenceFields.length) {
          this.registerService.deleteOnReferenceDetails(this.onReferenceFields[i].referenceCompanyDetailsId).subscribe((data: any) => {

          });
        }
      }
      let arr = this.registerProfileForm.get("referenceFields") as FormArray;
      arr.removeAt(i);
      if (i <= 2) {
        this.refArraySize = true;
      }
    }
  }
  getStates() {
    this.sharedService.getStates().subscribe((data: any) => {
      this.states = data;
    });
  }

  getStateOnChange(event) {
    this.stateId = event.value.stateId;
    this.stateOnMSADoc = event.value.stateName;
    this.onVendorAvailabilityCheck();
  }

  getBusinessCertifications() {
    this.categoryName = 'Business Certifications'
    this.sharedService.getLookupCategory(this.categoryName).subscribe((data: any) => {
      this.businessCertifications = data;
    });
  }


  getBusinessCertificationsOnChange(event) {
    if (this.businessCertIds.length == 0) {
      //this.selectedItems = '“You may select multiple certifications.”';
      this.businessCertificationValid = true;
      this.businessCertificationIds = '';
      this.businessCertificationEditIds = '';
    }
    else {
      this.businessCertificationValid = false;
    }
    if (this.userName != undefined) {
      if (this.businessCertificationEditIds != '' || this.businessCertificationEditIds != undefined) {
        this.businessCertificationEditIds = '';
        for (var m = 0; m < event.value.length; m++) {
          this.businessCertificationEditIds = this.businessCertificationEditIds + ',' + event.value[m].lookupId + ',';
        }

      }
      else {
        if (event.value.length == 1) {
          this.businessCertificationEditIds = event.value[0].lookupId;
        }
        else {

          this.businessCertificationEditIds = "";
          for (var k = 0; k < event.value.length; k++) {
            this.businessCertificationEditIds = this.businessCertificationEditIds + ',' + event.value[k].lookupId + ',';
          }
        }

      }
    }
    else {
      if (event.value.length == 1) {
        this.businessCertificationIds = event.value[0].lookupId;
      }
      else {
        this.businessCertificationIds = "";
        for (var k = 0; k < event.value.length; k++) {
          this.businessCertificationIds = this.businessCertificationIds + ',' + event.value[k].lookupId + ',';
        }
      }
    }
  }

  getSelectedCountryVisa() {
    this.categoryName = 'Visa Support Countries'
    this.sharedService.getLookupCategory(this.categoryName).subscribe((data: any) => {
      this.selectCountryVisa = data;
    });
  }
  getSelectecdCountryVisaOnChange(event) {
    if (this.selectedCountries.length == 0) {
      this.selectedCountriesVisa = undefined;
      this.selectedCountryValid = true;
      this.selectedCountryIds = '';
      this.selectedCountriesEditIds = '';
    }
    else {
      this.selectedCountryValid = false;
    }

    if (this.userName != undefined) {
      if (this.selectedCountriesEditIds != '' || this.selectedCountriesEditIds != undefined) {
        this.selectedCountriesEditIds = '';
        for (var m = 0; m < event.value.length; m++) {
          this.selectedCountriesEditIds = this.selectedCountriesEditIds + ',' + event.value[m].lookupId + ',';
        }

      }
      else {
        if (event.value.length == 1) {
          this.selectedCountriesEditIds = event.value[0].lookupId;
        }
        else {

          this.selectedCountriesEditIds = "";
          for (var k = 0; k < event.value.length; k++) {
            this.selectedCountriesEditIds = this.selectedCountriesEditIds + ',' + event.value[k].lookupId + ',';
          }
        }

      }
    }
    else {
      if (event.value.length == 1) {
        this.selectedCountryIds = event.value[0].lookupId;
      }
      else {
        this.selectedCountryIds = "";
        for (var k = 0; k < event.value.length; k++) {
          this.selectedCountryIds = this.selectedCountryIds + ',' + event.value[k].lookupId + ',';
        }
      }
    }
  }

  getClientNames() {
    this.registerService.getClientNames().subscribe((data: any) => {
      this.loadClient = true;
      this.clientNameList = data;
    });
  }

  getClientOnChange(event) {
    if (this.CliIds.length == 0) {
      this.selectedClientItems = undefined;
      this.selectedClientValid = true;
      this.ClientIds = '';
      this.ClientEditIds = '';
    }
    else {
      this.selectedClientValid = false;
    }
    if (this.userName != undefined) {
      if (this.ClientEditIds != '' || this.ClientEditIds != undefined) {
        this.ClientEditIds = '';
        for (var m = 0; m < event.value.length; m++) {
          this.ClientEditIds = this.ClientEditIds + ',' + event.value[m].companyId + ',';
        }

      }
      else {
        if (event.value.length == 1) {
          this.ClientEditIds = event.value[0].companyId;
        }
        else {

          this.ClientEditIds = "";
          for (var k = 0; k < event.value.length; k++) {
            this.ClientEditIds = this.ClientEditIds + ',' + event.value[k].companyId + ',';
          }
        }

      }
    }
    else {
      if (event.value.length == 1) {
        this.selectedClientIds = event.value[0].companyId;
      }
      else {
        this.selectedClientIds = "";
        for (var k = 0; k < event.value.length; k++) {
          if (this.selectedClientIds == "") {
            this.selectedClientIds = event.value[k].companyId;
          }
          else {
            this.selectedClientIds = this.selectedClientIds + ',' + +event.value[k].companyId;
          }
        }
      }
    }
  }

  preventSqlComments(event) {
    let avoidString: Array<string> = ['DELETE', 'ADD', 'UPDATE', 'TABLE', 'INSERT'];
    let name = event.target.value.toUpperCase();
    if (avoidString.includes(name)) {
      this.isSqlComments = true;
    }
    else {
      this.isSqlComments = false;
    }
  }

  preventSqlCommentsOnFirstName(event) {
    let avoidString: Array<string> = ['DELETE', 'ADD', 'UPDATE', 'TABLE', 'INSERT'];
    let name = event.target.value.toUpperCase();
    if (avoidString.includes(name)) {
      this.isSqlCommentsOnFirstName = true;
    }
    else {
      this.isSqlCommentsOnFirstName = false;
    }
  }

  preventSqlCommentsOnMiddleName(event) {
    let avoidString: Array<string> = ['DELETE', 'ADD', 'UPDATE', 'TABLE', 'INSERT'];
    let name = event.target.value.toUpperCase();
    if (avoidString.includes(name)) {
      this.isSqlCommentsOnMiddleName = true;
    }
    else {
      this.isSqlCommentsOnMiddleName = false;
    }
  }

  preventSqlCommentsOnLastName(event) {
    let avoidString: Array<string> = ['DELETE', 'ADD', 'UPDATE', 'TABLE', 'INSERT'];
    let name = event.target.value.toUpperCase();
    if (avoidString.includes(name)) {
      this.isSqlCommentsOnLastName = true;
    }
    else {
      this.isSqlCommentsOnLastName = false;
    }
  }

  onlyNumbers($event) {
    let regex: RegExp = new RegExp(/^[0-9]{1,}$/g);
    let specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowRight', 'ArrowLeft'];
    if (specialKeys.indexOf($event.key) !== -1) {
      return;
    } else {
      if (regex.test($event.key)) {
        return true;
      } else {
        return false;
      }
    }
  }

  onlyNumberWithDecimal($event) {
    let regex: RegExp = new RegExp(/^[0-9]{1,}$/g);
    let specialKeys: Array<string> = ['.', 'Backspace', 'Tab', 'End', 'Home', 'ArrowRight', 'ArrowLeft'];
    if (specialKeys.indexOf($event.key) !== -1) {
      return;
    } else {
      if (regex.test($event.key)) {
        return true;
      } else {
        return false;
      }
    }
  }

  // referenceFields(){
  //   return this.registerForm.get("referenceFields") as FormArray
  // }
  // newReferenceFields(): FormGroup {
  //   return this.formBuilder.group(
  //     {

  //     }
  //   )

  // }
  // addReferenceField(){

  // }
  onSaveRegisterProfile({ value }: { value: IRegister }) {
    this.emailId = value.vendorEmailId;
    console.log(value);
    if (this.companyId == undefined || this.companyId == 0) {
      this.confirmationService.confirm({
        //message: '<center>Please verify the email entered on the company profile is</center><center>'+' '+this.emailId.bold()+'.</center><center> You cannot change this email address after the save.</center><center>Select <strong>YES</strong> to continue or <strong>NO </strong>to go back and edit the email address',
        message: '<center>Please verify that the email </center><center>' + ' ' + this.emailId.bold() + '</center><center> entered in the company profile is correct.You cannot change this address after the save.</center><center> Select <strong>Yes</strong> to continue or <strong>No </strong>to stay on this page.',
        accept: () => {
          this.emailId = value.vendorEmailId;
          this.stateCount.splice(0, this.stateCount.length);
          if (value.onshoreFields.length >= 1) {
            this.removeEmpty = [];
            for (var i = 0; i <= value.onshoreFields.length - 1; i++) {
              if (value.onshoreFields[i].contactName == '' &&
                value.onshoreFields[i].phone == '' &&
                value.onshoreFields[i].officeCityState == '' &&
                value.onshoreFields[i].address == '')
                this.removeEmpty.push(i);
            }
            for (var i = 0; i <= this.removeEmpty.length - 1; i++) {
              value.onshoreFields.splice(this.removeEmpty[i], 1);
            }
          }

          if (value.onshoreFields.length >= 1) {
            for (var k = 0; k <= value.onshoreFields.length - 1; k++) {
              value.onshoreFields[k].contactName = (value.onshoreFields[k].contactName === null) ? value.onshoreFields[k].contactName : value.onshoreFields[k].contactName.trim();
              value.onshoreFields[k].phone = (value.onshoreFields[k].phone === null) ? value.onshoreFields[k].phone : value.onshoreFields[k].phone.trim();
              value.onshoreFields[k].officeCityState = (value.onshoreFields[k].officeCityState === null) ? value.onshoreFields[k].officeCityState : value.onshoreFields[k].officeCityState.trim();
              value.onshoreFields[k].address = (value.onshoreFields[k].address === null) ? value.onshoreFields[k].address : value.onshoreFields[k].address.trim();
            }
          }

          if (value.offshoreFields.length >= 1) {
            this.removeEmpty.splice(0, this.removeEmpty.length);
            for (var i = 0; i <= value.offshoreFields.length - 1; i++) {
              if (value.offshoreFields[i].address == '' &&
                value.offshoreFields[i].city == '' &&
                value.offshoreFields[i].state == '' &&
                value.offshoreFields[i].country == '')
                this.removeEmpty.push(i);
            }
            for (var i = this.removeEmpty.length - 1; i >= 0; i--) {
              value.offshoreFields.splice(this.removeEmpty[i], 1);
            }
          }

          if (value.offshoreFields.length >= 1) {
            for (var k = 0; k <= value.offshoreFields.length - 1; k++) {
              value.offshoreFields[k].address = (value.offshoreFields[k].address === null) ? value.offshoreFields[k].address : value.offshoreFields[k].address.trim();
              value.offshoreFields[k].city = (value.offshoreFields[k].city === null) ? value.offshoreFields[k].city : value.offshoreFields[k].city.trim();
              value.offshoreFields[k].state = (value.offshoreFields[k].state === null) ? value.offshoreFields[k].state : value.offshoreFields[k].state.trim();
              value.offshoreFields[k].country = (value.offshoreFields[k].country === null) ? value.offshoreFields[k].country : value.offshoreFields[k].country.trim();
            }
          }
          if (value.referenceFields.length >= 1) {
            this.removeEmpty = [];
            for (var i = 0; i <= value.referenceFields.length - 1; i++) {
              var vrefRevenue;
              if( value.referenceFields[i].refRevenue != null)
              {
                vrefRevenue= value.referenceFields[i].refRevenue.toString();
              }
              else
              {
                vrefRevenue= value.referenceFields[i].refRevenue;
              }
              if (value.referenceFields[i].refClientName == '' &&
                value.referenceFields[i].refContactName == '' &&
                value.referenceFields[i].refContactTitle == '' &&
                value.referenceFields[i].refContactEmail == '' &&
                value.referenceFields[i].refContactPhoneNumber == '' &&
                value.referenceFields[i].refIndustry == '' &&
                value.referenceFields[i].refDurationOfPartnership == '' &&
                value.referenceFields[i].refServicesProvided == '' &&
                vrefRevenue == '' || null) {
                vrefRevenue = undefined;
                this.removeEmpty.push(i);
              }
            }
            for (var i = 0; i <= this.removeEmpty.length - 1; i++) {
              value.referenceFields.splice(this.removeEmpty[i], 1);
            }
          }
          if (value.referenceFields.length >= 1) {
            for (var k = 0; k <= value.referenceFields.length - 1; k++) {
              value.referenceFields[k].refClientName = (value.referenceFields[k].refClientName === null || value.referenceFields[k].refClientName === '') ? value.referenceFields[k].refClientName : value.referenceFields[k].refClientName.trim();
              value.referenceFields[k].refContactName = (value.referenceFields[k].refContactName === null || value.referenceFields[k].refContactName === '') ? value.referenceFields[k].refContactName : value.referenceFields[k].refContactName.trim();
              value.referenceFields[k].refContactTitle = (value.referenceFields[k].refContactTitle === null || value.referenceFields[k].refContactTitle === '') ? value.referenceFields[k].refContactTitle : value.referenceFields[k].refContactTitle.trim();
              value.referenceFields[k].refContactEmail = (value.referenceFields[k].refContactEmail === null || value.referenceFields[k].refContactEmail === '') ? value.referenceFields[k].refContactEmail : value.referenceFields[k].refContactEmail.trim();
              value.referenceFields[k].refContactPhoneNumber = (value.referenceFields[k].refContactPhoneNumber === null || value.referenceFields[k].refContactPhoneNumber === '') ? value.referenceFields[k].refContactPhoneNumber : value.referenceFields[k].refContactPhoneNumber.trim();
              value.referenceFields[k].refIndustry = (value.referenceFields[k].refIndustry === null || value.referenceFields[k].refIndustry === '') ? value.referenceFields[k].refIndustry : value.referenceFields[k].refIndustry.trim();
              value.referenceFields[k].refDurationOfPartnership = (value.referenceFields[k].refDurationOfPartnership === null || value.referenceFields[k].refDurationOfPartnership === '') ? value.referenceFields[k].refDurationOfPartnership : value.referenceFields[k].refDurationOfPartnership.trim();
              value.referenceFields[k].refServicesProvided = (value.referenceFields[k].refServicesProvided === null || value.referenceFields[k].refServicesProvided === '') ? value.referenceFields[k].refServicesProvided : value.referenceFields[k].refServicesProvided.trim();
              //value.referenceFields[k].refServicesProvided = (value.referenceFields[k].refRevenue === null || value.referenceFields[k].refRevenue === undefined) ? value.referenceFields[k].refRevenue  : value.referenceFields[k].refRevenue.trim();
            }
          }
          value.vendorName = (value.vendorName === null) ? value.vendorName : value.vendorName.trim();
          value.verifyVendorName = (value.verifyVendorName === null) ? value.vendorName : value.verifyVendorName.trim();
          value.vendorShortName = (value.vendorShortName === null) ? value.vendorShortName : value.vendorShortName.trim();
          value.vendorEmailId = (value.vendorEmailId === null) ? value.vendorEmailId : value.vendorEmailId.trim();
          value.addressLine1 = (value.addressLine1 === null ||value.addressLine1 == undefined) ? value.addressLine1 : value.addressLine1.trim();
          value.addressLine2 = (value.addressLine2 === null ||value.addressLine2 == undefined) ? value.addressLine2 : value.addressLine2.trim();
          value.city = (value.city === null || value.city ==undefined) ? value.city : value.city.trim();
          value.ownerName = (value.ownerName === null) ? value.ownerName : value.ownerName.trim();
          value.ownerTitle = (value.ownerTitle === null) ? value.ownerTitle : value.ownerTitle.trim();
          value.ownerEmail = (value.ownerEmail === null) ? value.ownerEmail : value.ownerEmail.trim();
          value.ownerPhone = (value.ownerPhone === null) ? value.ownerPhone : value.ownerPhone.trim();
          value.ownerAlternatePhone = (value.ownerAlternatePhone === null) ? value.ownerAlternatePhone : value.ownerAlternatePhone.trim();
          value.recruitingName = (value.recruitingName === null) ? value.recruitingName : value.recruitingName.trim();
          value.recruitingTitle = (value.recruitingTitle === null) ? value.recruitingTitle : value.recruitingTitle.trim();
          value.recruitingEmail = (value.recruitingEmail === null) ? value.recruitingEmail : value.recruitingEmail.trim();
          value.recruitingPhone = (value.recruitingPhone === null) ? value.recruitingPhone : value.recruitingPhone.trim();
          value.recruitingAlternatePhone = (value.recruitingAlternatePhone === null) ? value.recruitingAlternatePhone : value.recruitingAlternatePhone.trim();
          value.financialName = (value.financialName === null) ? value.financialName : value.financialName.trim();
          value.financialTitle = (value.financialTitle === null) ? value.financialTitle : value.financialTitle.trim();
          value.financialEmail = (value.financialEmail === null) ? value.financialEmail : value.financialEmail.trim();
          value.financialPhone = (value.financialPhone === null) ? value.financialPhone : value.financialPhone.trim();
          value.financialAlternatePhone = (value.financialAlternatePhone === null) ? value.financialAlternatePhone : value.financialAlternatePhone.trim();
          value.accountingName = (value.accountingName === null) ? value.accountingName : value.accountingName.trim();
          value.accountingTitle = (value.accountingTitle === null) ? value.accountingTitle : value.accountingTitle.trim();
          value.accountingEmail = (value.accountingEmail === null) ? value.accountingEmail : value.accountingEmail.trim();
          value.accountingPhone = (value.accountingPhone === null) ? value.accountingPhone : value.accountingPhone.trim();
          value.accountingAlternatePhone = (value.accountingAlternatePhone === null) ? value.accountingAlternatePhone : value.accountingAlternatePhone.trim();
          value.firstName = (value.firstName === null) ? value.firstName : value.firstName.trim();
          value.middleName = (value.middleName === null) ? value.middleName : value.middleName.trim();
          value.lastName = (value.lastName === null) ? value.lastName : value.lastName.trim();
          value.adminEmailId = (value.adminEmailId === null) ? value.adminEmailId : value.adminEmailId.trim();
          value.companyRevenueLastYear = (value.companyRevenueLastYear === null) ? value.companyRevenueLastYear : value.companyRevenueLastYear.trim();
          value.companyRevenueLastYear = this.lastYear + '-' + value.companyRevenueLastYear;
          value.companyRevenue2YearsBefore = (value.companyRevenue2YearsBefore === null) ? value.companyRevenue2YearsBefore : value.companyRevenue2YearsBefore.trim();
          value.companyRevenue2YearsBefore = this.last2YearBefore + '-' + value.companyRevenue2YearsBefore;
          value.companyRevenue3YearsBefore = (value.companyRevenue3YearsBefore === null) ? value.companyRevenue3YearsBefore : value.companyRevenue3YearsBefore.trim();
          value.companyRevenue3YearsBefore = this.last3YearBefore + '-' + value.companyRevenue3YearsBefore;
          value.comments = (value.comments === null) ? value.comments : value.comments.trim();
          //value.optTechnologyTrain = (value.optTechnologyTrain === null) ? value.optTechnologyTrain : value.optTechnologyTrain.trim(); 
          this.stateCount.push({ stateName: StateName['Alabama'], count: value.alabama });
          this.stateCount.push({ stateName: StateName['Alaska'], count: value.alaska });
          this.stateCount.push({ stateName: StateName['Arizona'], count: value.arizona });
          this.stateCount.push({ stateName: StateName['Arkansas'], count: value.arkansas });
          this.stateCount.push({ stateName: StateName['California'], count: value.california });
          this.stateCount.push({ stateName: StateName['Colorado'], count: value.colorado });
          this.stateCount.push({ stateName: StateName['Connecticut'], count: value.connecticut });
          this.stateCount.push({ stateName: StateName['Delaware'], count: value.delaware });
          this.stateCount.push({ stateName: StateName['Florida'], count: value.florida });
          this.stateCount.push({ stateName: StateName['Georgia'], count: value.georgia });
          this.stateCount.push({ stateName: StateName['Hawaii'], count: value.hawaii });
          this.stateCount.push({ stateName: StateName['Idaho'], count: value.idaho });
          this.stateCount.push({ stateName: StateName['Illinois'], count: value.illinois });
          this.stateCount.push({ stateName: StateName['Indiana'], count: value.indiana });
          this.stateCount.push({ stateName: StateName['Iowa'], count: value.iowa });
          this.stateCount.push({ stateName: StateName['Kansas'], count: value.kansas });
          this.stateCount.push({ stateName: StateName['Kentucky'], count: value.kentucky });
          this.stateCount.push({ stateName: StateName['Louisiana'], count: value.louisiana });
          this.stateCount.push({ stateName: StateName['Maine'], count: value.maine });
          this.stateCount.push({ stateName: StateName['Maryland'], count: value.maryland });
          this.stateCount.push({ stateName: StateName['Massachusetts'], count: value.massachusetts });
          this.stateCount.push({ stateName: StateName['Michigan'], count: value.michigan });
          this.stateCount.push({ stateName: StateName['Minnesota'], count: value.minnesota });
          this.stateCount.push({ stateName: StateName['Mississippi'], count: value.mississippi });
          this.stateCount.push({ stateName: StateName['Missouri'], count: value.missouri });
          this.stateCount.push({ stateName: StateName['Montana'], count: value.montana });
          this.stateCount.push({ stateName: StateName['Nebraska'], count: value.nebraska });
          this.stateCount.push({ stateName: StateName['Nevada'], count: value.nevada });
          this.stateCount.push({ stateName: StateName['NewHampshire'], count: value.newHampshire });
          this.stateCount.push({ stateName: StateName['NewJersey'], count: value.newJersey });
          this.stateCount.push({ stateName: StateName['NewMexico'], count: value.newMexico });
          this.stateCount.push({ stateName: StateName['NewYork'], count: value.newYork });
          this.stateCount.push({ stateName: StateName['NorthCarolina'], count: value.northCarolina });
          this.stateCount.push({ stateName: StateName['NorthDakota'], count: value.northDakota });
          this.stateCount.push({ stateName: StateName['Ohio'], count: value.ohio });
          this.stateCount.push({ stateName: StateName['Oklahoma'], count: value.oklahoma });
          this.stateCount.push({ stateName: StateName['Oregon'], count: value.oregon });
          this.stateCount.push({ stateName: StateName['Pennsylvania'], count: value.pennsylvania });
          this.stateCount.push({ stateName: StateName['RhodeIsland'], count: value.rhodeIsland });
          this.stateCount.push({ stateName: StateName['SouthCarolina'], count: value.southCarolina });
          this.stateCount.push({ stateName: StateName['SouthDakota'], count: value.southDakota });
          this.stateCount.push({ stateName: StateName['Tennessee'], count: value.tennessee });
          this.stateCount.push({ stateName: StateName['Texas'], count: value.texas });
          this.stateCount.push({ stateName: StateName['Utah'], count: value.utah });
          this.stateCount.push({ stateName: StateName['Vermont'], count: value.vermont });
          this.stateCount.push({ stateName: StateName['Virginia'], count: value.virginia });
          this.stateCount.push({ stateName: StateName['Washington'], count: value.washington });
          this.stateCount.push({ stateName: StateName['WestVirginia'], count: value.westVirginia });
          this.stateCount.push({ stateName: StateName['Wisconsin'], count: value.wisconsin });
          this.stateCount.push({ stateName: StateName['Wyoming'], count: value.wyoming });
          value.stateCount = this.stateCount;
          if (this.glEffectiveDate != null && value.glEffDate == this.glEffectiveDate) {
            var glEffDate =value.glEffDate.toDateString();
            let formatedglEffDate = new Date(glEffDate);
            var strformat = formatedglEffDate.toString();
            if(strformat.includes("India"))
            {
            formatedglEffDate.setDate(formatedglEffDate.getDate() + 1);
            }
            else
            {
              formatedglEffDate.setDate(formatedglEffDate.getDate());
            }
            value.glEffDate = (value.glEffDate === null) ? null : formatedglEffDate;
          }
          else {
            if(value.glEffDate!=null)
            {
            var glEffDate =value.glEffDate.toDateString();
            let formatedglEffDate = new Date(glEffDate);
            var strformat = formatedglEffDate.toString();
            if(strformat.includes("India"))
            {
            formatedglEffDate.setDate(formatedglEffDate.getDate() + 1);
            }
            else
            {
              formatedglEffDate.setDate(formatedglEffDate.getDate());
            }
            value.glEffDate = (value.glEffDate === null) ? null : formatedglEffDate;
            }
          }
          if (this.glExpiryDate != null && value.glExpDate == this.glExpiryDate) {
            var glExpDate =value.glExpDate.toDateString();
            let formatedglExpDate = new Date(glExpDate);
            var strformat = formatedglExpDate.toString();
            if(strformat.includes("India"))
            {
              formatedglExpDate.setDate(formatedglExpDate.getDate() + 1);
            }
            else
            {
              formatedglExpDate.setDate(formatedglExpDate.getDate());
            }
            value.glExpDate = (value.glExpDate === null) ? null : formatedglExpDate;
          }
          else {
              if(value.glExpDate!=null)
              {
                var glExpDate =value.glExpDate.toDateString();
                let formatedglExpDate = new Date(glExpDate);
                var strformat = formatedglExpDate.toString();
                if(strformat.includes("India"))
                {
                  formatedglExpDate.setDate(formatedglExpDate.getDate() + 1);
                }
                else
                {
                  formatedglExpDate.setDate(formatedglExpDate.getDate());
                }
                value.glExpDate = (value.glExpDate === null) ? null : formatedglExpDate;
              }
          }
          if (this.alEffectiveDate != null && value.alEffDate == this.alEffectiveDate) {
            var alEffDate =value.alEffDate.toDateString();
            let formatedalEffDate = new Date(alEffDate);
            var strformat = formatedalEffDate.toString();
            if(strformat.includes("India"))
            {
              formatedalEffDate.setDate(formatedalEffDate.getDate() + 1);
            }
            else
            {
              formatedalEffDate.setDate(formatedalEffDate.getDate());
            }
            value.alEffDate = (value.alEffDate === null) ? null : formatedalEffDate;
          }
          else {
            if(value.alEffDate!=null)
            {
            var alEffDate =value.alEffDate.toDateString();
            let formatedalEffDate = new Date(alEffDate);
            var strformat = formatedalEffDate.toString();
            if(strformat.includes("India"))
            {
              formatedalEffDate.setDate(formatedalEffDate.getDate() + 1);
            }
            else
            {
              formatedalEffDate.setDate(formatedalEffDate.getDate());
            }
            value.alEffDate = (value.alEffDate === null) ? null : formatedalEffDate;
            }
          }
          if (this.alExpiryDate != null && value.alExpDate == this.alExpiryDate) {
            var alExpDate =value.alExpDate.toDateString();
              let formatedalExpDate = new Date(alExpDate);
              var strformat = formatedalExpDate.toString();
              if(strformat.includes("India"))
              {
                formatedalExpDate.setDate(formatedalExpDate.getDate() + 1);
              }
              else
              {
                formatedalExpDate.setDate(formatedalExpDate.getDate());
              }
              value.alExpDate = (value.alExpDate === null) ? null : formatedalExpDate;
          }
          else {
            if(value.alExpDate != null)
            {
              var alExpDate =value.alExpDate.toDateString();
              let formatedalExpDate = new Date(alExpDate);
              var strformat = formatedalExpDate.toString();
              if(strformat.includes("India"))
              {
                formatedalExpDate.setDate(formatedalExpDate.getDate() + 1);
              }
              else
              {
                formatedalExpDate.setDate(formatedalExpDate.getDate());
              }
              value.alExpDate = (value.alExpDate === null) ? null : formatedalExpDate;
            }
          }
          if (this.ulEffectiveDate != null && value.ulEffDate == this.ulEffectiveDate) {
            var ulEffDate =value.ulEffDate.toDateString();
            let formatedulEffDate = new Date(ulEffDate);
            var strformat = formatedulEffDate.toString();
            if(strformat.includes("India"))
            {
              formatedulEffDate.setDate(formatedulEffDate.getDate() + 1);
            }
            else
            {
              formatedulEffDate.setDate(formatedulEffDate.getDate());
            }
            value.ulEffDate = (value.ulEffDate === null) ? null : formatedulEffDate;
          }
          else {
            if(value.ulEffDate!=null)
            {
            var ulEffDate =value.ulEffDate.toDateString();
            let formatedulEffDate = new Date(ulEffDate);
            var strformat = formatedulEffDate.toString();
            if(strformat.includes("India"))
            {
              formatedulEffDate.setDate(formatedulEffDate.getDate() + 1);
            }
            else
            {
              formatedulEffDate.setDate(formatedulEffDate.getDate());
            }
            value.ulEffDate = (value.ulEffDate === null) ? null : formatedulEffDate;
            }
          }
          if (this.ulExpiryDate != null && value.ulExpDate == this.ulExpiryDate) {
            var ulExpDate =value.ulExpDate.toDateString();
            let formatedulExpDate = new Date(ulExpDate);
            var strformat = formatedulExpDate.toString();
            if(strformat.includes("India"))
            {
              formatedulExpDate.setDate(formatedulExpDate.getDate() + 1);
            }
            else
            {
              formatedulExpDate.setDate(formatedulExpDate.getDate());
            }
            value.ulExpDate = (value.ulExpDate === null) ? null : formatedulExpDate;
          }
          else {
            if(value.ulExpDate != null)
            {
              var ulExpDate =value.ulExpDate.toDateString();
              let formatedulExpDate = new Date(ulExpDate);
              var strformat = formatedulExpDate.toString();
              if(strformat.includes("India"))
              {
                formatedulExpDate.setDate(formatedulExpDate.getDate() + 1);
              }
              else
              {
                formatedulExpDate.setDate(formatedulExpDate.getDate());
              }
              value.ulExpDate = (value.ulExpDate === null) ? null : formatedulExpDate;
            }
          }
          if (this.wcEffectiveDate != null && value.wcEffDate == this.wcEffectiveDate) {
            var wcEffDate =value.wcEffDate.toDateString();
            let formatedwcEffDate = new Date(wcEffDate);
            var strformat = formatedwcEffDate.toString();
            if(strformat.includes("India"))
            {
              formatedwcEffDate.setDate(formatedwcEffDate.getDate() + 1);
            }
            else
            {
              formatedwcEffDate.setDate(formatedwcEffDate.getDate());
            }
            value.wcEffDate = (value.wcEffDate === null) ? null : formatedwcEffDate;
          }
          else {
            if(value.wcEffDate!=null)
            {
            var wcEffDate =value.wcEffDate.toDateString();
            let formatedwcEffDate = new Date(wcEffDate);
            var strformat = formatedwcEffDate.toString();
            if(strformat.includes("India"))
            {
              formatedwcEffDate.setDate(formatedwcEffDate.getDate() + 1);
            }
            else
            {
              formatedwcEffDate.setDate(formatedwcEffDate.getDate());
            }
            value.wcEffDate = (value.wcEffDate === null) ? null : formatedwcEffDate;
            }
          }
          if (this.wcExpiryDate != null && value.wcExpDate == this.wcExpiryDate) {
            var wcExpDate =value.wcExpDate.toDateString();
            let formatedwcExpDate = new Date(wcExpDate);
            var strformat = formatedwcExpDate.toString();
            if(strformat.includes("India"))
            {
              formatedwcExpDate.setDate(formatedwcExpDate.getDate() + 1);
            }
            else
            {
              formatedwcExpDate.setDate(formatedwcExpDate.getDate());
            }
            value.wcExpDate = (value.wcExpDate === null) ? null : formatedwcExpDate;
          }
          else {
            if(value.wcExpDate != null)
            {
              var wcExpDate =value.wcExpDate.toDateString();
              let formatedwcExpDate = new Date(wcExpDate);
              var strformat = formatedwcExpDate.toString();
              if(strformat.includes("India"))
              {
                formatedwcExpDate.setDate(formatedwcExpDate.getDate() + 1);
              }
              else
              {
                formatedwcExpDate.setDate(formatedwcExpDate.getDate());
              }
              value.wcExpDate = (value.wcExpDate === null) ? null : formatedwcExpDate;
            }
          }
          if (this.plEffectiveDate != null && value.plEffDate == this.plEffectiveDate) {
            var plEffDate =value.plEffDate.toDateString();
            let formatedplEffDate = new Date(plEffDate);
            var strformat = formatedplEffDate.toString();
            if(strformat.includes("India"))
            {
              formatedplEffDate.setDate(formatedplEffDate.getDate() + 1);
            }
            else
            {
              formatedplEffDate.setDate(formatedplEffDate.getDate());
            }
            value.plEffDate = (value.plEffDate === null) ? null : formatedplEffDate;
          }
          else {
            if(value.plEffDate!=null)
            {
            var plEffDate =value.plEffDate.toDateString();
            let formatedplEffDate = new Date(plEffDate);
            var strformat = formatedplEffDate.toString();
            if(strformat.includes("India"))
            {
              formatedplEffDate.setDate(formatedplEffDate.getDate() + 1);
            }
            else
            {
              formatedplEffDate.setDate(formatedplEffDate.getDate());
            }
            value.plEffDate = (value.plEffDate === null) ? null : formatedplEffDate;
            }
          }
          if (this.plExpiryDate != null && value.plExpDate == this.plExpiryDate) {
            var plExpDate =value.plExpDate.toDateString();
            let formatedplExpDate = new Date(plExpDate);
            var strformat = formatedplExpDate.toString();
            if(strformat.includes("India"))
            {
              formatedplExpDate.setDate(formatedplExpDate.getDate() + 1);
            }
            else
            {
              formatedplExpDate.setDate(formatedplExpDate.getDate());
            }
            value.plExpDate = (value.plExpDate === null) ? null : formatedplExpDate;
          }
          else {
            if(value.plExpDate != null)
            {
              var plExpDate =value.plExpDate.toDateString();
              let formatedplExpDate = new Date(plExpDate);
              var strformat = formatedplExpDate.toString();
              if(strformat.includes("India"))
              {
                formatedplExpDate.setDate(formatedplExpDate.getDate() + 1);
              }
              else
              {
                formatedplExpDate.setDate(formatedplExpDate.getDate());
              }
              value.plExpDate = (value.plExpDate === null) ? null : formatedplExpDate;
            }
          }
          value.comments = (value.comments === null) ? null : value.comments;
          if (this.userName != undefined) {
            value.businessCertificationIds = this.businessCertificationEditIds;
          }
          else {
            value.businessCertificationIds = this.businessCertificationIds;
          }
          if (this.userName != undefined) {
            value.tNVisaCountries = this.selectedCountriesEditIds;
          }
          else {
            value.tNVisaCountries = this.selectedCountryIds;
          }
          if (this.userName != undefined) {
            value.clientIds = this.ClientEditIds;
          }
          else {
            value.clientIds = this.selectedClientIds;
          }
          value.isSubmitted = false;
          value.stateId = this.stateId;
          value.entityTypeId = this.entityTypeId;
          value.paymentTermsId = this.paymentTermsId;
          if (this.companyId != 0) {
            value.companyId = this.companyId;
            value.userId = this.userId;
          }
          value.clientIdOnRegistration = this.clientIdOnRegistration;
          this.registerService.registerProfile(value).subscribe((data: any) => {
            this.registerService.updateCompanyForAdmin(data).subscribe((result: any) => {
              if (this.splittedW9formUploadedPath != undefined && this.userName == undefined) {
                var folderName = data.companyId;
                this.registerService.saveW9formUrl(this.splittedW9formUploadedPath[2], folderName, data.companyId).subscribe((res) => {

                });
              }
              if (this.splittedDDUploadedPath != undefined && this.userName == undefined) {
                var folderName = data.companyId;
                this.registerService.saveDDformUrl(this.splittedDDUploadedPath[2], folderName, data.companyId).subscribe((res) => {

                });
              }
              if (this.splittedMSAUploadedPath != undefined && this.userName == undefined) {
                var folderName = data.companyId;
                this.registerService.saveMSAFileUrl(this.splittedMSAUploadedPath[2], folderName, data.companyId).subscribe((res) => {

                });
              }
              if (this.splittedInsuranceUploadedPath != undefined && this.userName == undefined) {
                var folderName = data.companyId;
                this.registerService.saveInsuranceFileUrl(this.splittedInsuranceUploadedPath[2], folderName, data.companyId).subscribe((res) => {

                });
              }
            });
            this.saveModal = true;

          });
        },
        reject: (type) => {
          switch (type) {
            case ConfirmEventType.REJECT:
              this.messageService.add({ severity: 'warn', summary: 'Cancelled', detail: 'You have cancelled' });
              break;
            case ConfirmEventType.CANCEL:
              this.messageService.add({ severity: 'warn', summary: 'Cancelled', detail: 'You have cancelled' });
              break;
          }
        }
      });
    }
    else {
      this.emailId = value.vendorEmailId;
      this.stateCount.splice(0, this.stateCount.length);
      if (value.onshoreFields.length >= 1) {
        this.removeEmpty = [];
        for (var i = 0; i <= value.onshoreFields.length - 1; i++) {
          if (value.onshoreFields[i].contactName == '' &&
            value.onshoreFields[i].phone == '' &&
            value.onshoreFields[i].officeCityState == '' &&
            value.onshoreFields[i].address == '')
            this.removeEmpty.push(i);
        }
        for (var i = 0; i <= this.removeEmpty.length - 1; i++) {
          value.onshoreFields.splice(this.removeEmpty[i], 1);
        }
      }

      if (value.onshoreFields.length >= 1) {
        for (var k = 0; k <= value.onshoreFields.length - 1; k++) {
          value.onshoreFields[k].contactName = (value.onshoreFields[k].contactName === null) ? value.onshoreFields[k].contactName : value.onshoreFields[k].contactName.trim();
          value.onshoreFields[k].phone = (value.onshoreFields[k].phone === null) ? value.onshoreFields[k].phone : value.onshoreFields[k].phone.trim();
          value.onshoreFields[k].officeCityState = (value.onshoreFields[k].officeCityState === null) ? value.onshoreFields[k].officeCityState : value.onshoreFields[k].officeCityState.trim();
          value.onshoreFields[k].address = (value.onshoreFields[k].address === null) ? value.onshoreFields[k].address : value.onshoreFields[k].address.trim();
        }
      }

      if (value.offshoreFields.length >= 1) {
        this.removeEmpty.splice(0, this.removeEmpty.length);
        for (var i = 0; i <= value.offshoreFields.length - 1; i++) {
          if (value.offshoreFields[i].address == '' &&
            value.offshoreFields[i].city == '' &&
            value.offshoreFields[i].state == '' &&
            value.offshoreFields[i].country == '')
            this.removeEmpty.push(i);
        }
        for (var i = this.removeEmpty.length - 1; i >= 0; i--) {
          value.offshoreFields.splice(this.removeEmpty[i], 1);
        }
      }

      if (value.offshoreFields.length >= 1) {
        for (var k = 0; k <= value.offshoreFields.length - 1; k++) {
          value.offshoreFields[k].address = (value.offshoreFields[k].address === null) ? value.offshoreFields[k].address : value.offshoreFields[k].address.trim();
          value.offshoreFields[k].city = (value.offshoreFields[k].city === null) ? value.offshoreFields[k].city : value.offshoreFields[k].city.trim();
          value.offshoreFields[k].state = (value.offshoreFields[k].state === null) ? value.offshoreFields[k].state : value.offshoreFields[k].state.trim();
          value.offshoreFields[k].country = (value.offshoreFields[k].country === null) ? value.offshoreFields[k].country : value.offshoreFields[k].country.trim();
        }
      }
      if (value.referenceFields.length >= 1) {
        this.removeEmpty = [];
        for (var i = 0; i <= value.referenceFields.length - 1; i++) {
          var vrefRevenue;
          if( value.referenceFields[i].refRevenue != null)
          {
            vrefRevenue= value.referenceFields[i].refRevenue.toString();
          }
          else
          {
            vrefRevenue= value.referenceFields[i].refRevenue;
          }
          if (value.referenceFields[i].refClientName == '' &&
            value.referenceFields[i].refContactName == '' &&
            value.referenceFields[i].refContactTitle == '' &&
            value.referenceFields[i].refContactEmail == '' &&
            value.referenceFields[i].refContactPhoneNumber == '' &&
            value.referenceFields[i].refIndustry == '' &&
            value.referenceFields[i].refDurationOfPartnership == '' &&
            value.referenceFields[i].refServicesProvided == '' &&
            vrefRevenue == '' || null) {
            vrefRevenue = undefined;
            this.removeEmpty.push(i);
          }
        }
        for (var i = 0; i <= this.removeEmpty.length - 1; i++) {
          value.referenceFields.splice(this.removeEmpty[i], 1);
        }
      }
      if (value.referenceFields.length >= 1) {
        for (var k = 0; k <= value.referenceFields.length - 1; k++) {
          value.referenceFields[k].refClientName = (value.referenceFields[k].refClientName === null || value.referenceFields[k].refClientName === '') ? value.referenceFields[k].refClientName : value.referenceFields[k].refClientName.trim();
          value.referenceFields[k].refContactName = (value.referenceFields[k].refContactName === null || value.referenceFields[k].refContactName === '') ? value.referenceFields[k].refContactName : value.referenceFields[k].refContactName.trim();
          value.referenceFields[k].refContactTitle = (value.referenceFields[k].refContactTitle === null || value.referenceFields[k].refContactTitle === '') ? value.referenceFields[k].refContactTitle : value.referenceFields[k].refContactTitle.trim();
          value.referenceFields[k].refContactEmail = (value.referenceFields[k].refContactEmail === null || value.referenceFields[k].refContactEmail === '') ? value.referenceFields[k].refContactEmail : value.referenceFields[k].refContactEmail.trim();
          value.referenceFields[k].refContactPhoneNumber = (value.referenceFields[k].refContactPhoneNumber === null || value.referenceFields[k].refContactPhoneNumber === '') ? value.referenceFields[k].refContactPhoneNumber : value.referenceFields[k].refContactPhoneNumber.trim();
          value.referenceFields[k].refIndustry = (value.referenceFields[k].refIndustry === null || value.referenceFields[k].refIndustry === '') ? value.referenceFields[k].refIndustry : value.referenceFields[k].refIndustry.trim();
          value.referenceFields[k].refDurationOfPartnership = (value.referenceFields[k].refDurationOfPartnership === null || value.referenceFields[k].refDurationOfPartnership === '') ? value.referenceFields[k].refDurationOfPartnership : value.referenceFields[k].refDurationOfPartnership.trim();
          value.referenceFields[k].refServicesProvided = (value.referenceFields[k].refServicesProvided === null || value.referenceFields[k].refServicesProvided === '') ? value.referenceFields[k].refServicesProvided : value.referenceFields[k].refServicesProvided.trim();
          //value.referenceFields[k].refServicesProvided = (value.referenceFields[k].refRevenue === null || value.referenceFields[k].refRevenue === undefined) ? value.referenceFields[k].refRevenue  : value.referenceFields[k].refRevenue.trim();
        }
      }
      value.vendorName = (value.vendorName === null) ? value.vendorName : value.vendorName.trim();
      value.verifyVendorName = (value.verifyVendorName === null) ? value.vendorName : value.verifyVendorName.trim();
      value.vendorShortName = (value.vendorShortName === null) ? value.vendorShortName : value.vendorShortName.trim();
      value.vendorEmailId = (value.vendorEmailId === null) ? value.vendorEmailId : value.vendorEmailId.trim();
      value.addressLine1 = (value.addressLine1 === null ||value.addressLine1 == undefined) ? value.addressLine1 : value.addressLine1.trim();
      value.addressLine2 = (value.addressLine2 === null ||value.addressLine2 == undefined) ? value.addressLine2 : value.addressLine2.trim();
      value.city = (value.city === null ||value.city ==undefined) ? value.city : value.city.trim();
      value.ownerName = (value.ownerName === null) ? value.ownerName : value.ownerName.trim();
      value.ownerTitle = (value.ownerTitle === null) ? value.ownerTitle : value.ownerTitle.trim();
      value.ownerEmail = (value.ownerEmail === null) ? value.ownerEmail : value.ownerEmail.trim();
      value.ownerPhone = (value.ownerPhone === null) ? value.ownerPhone : value.ownerPhone.trim();
      value.ownerAlternatePhone = (value.ownerAlternatePhone === null) ? value.ownerAlternatePhone : value.ownerAlternatePhone.trim();
      value.recruitingName = (value.recruitingName === null) ? value.recruitingName : value.recruitingName.trim();
      value.recruitingTitle = (value.recruitingTitle === null) ? value.recruitingTitle : value.recruitingTitle.trim();
      value.recruitingEmail = (value.recruitingEmail === null) ? value.recruitingEmail : value.recruitingEmail.trim();
      value.recruitingPhone = (value.recruitingPhone === null) ? value.recruitingPhone : value.recruitingPhone.trim();
      value.recruitingAlternatePhone = (value.recruitingAlternatePhone === null) ? value.recruitingAlternatePhone : value.recruitingAlternatePhone.trim();
      value.financialName = (value.financialName === null) ? value.financialName : value.financialName.trim();
      value.financialTitle = (value.financialTitle === null) ? value.financialTitle : value.financialTitle.trim();
      value.financialEmail = (value.financialEmail === null) ? value.financialEmail : value.financialEmail.trim();
      value.financialPhone = (value.financialPhone === null) ? value.financialPhone : value.financialPhone.trim();
      value.financialAlternatePhone = (value.financialAlternatePhone === null) ? value.financialAlternatePhone : value.financialAlternatePhone.trim();
      value.accountingName = (value.accountingName === null) ? value.accountingName : value.accountingName.trim();
      value.accountingTitle = (value.accountingTitle === null) ? value.accountingTitle : value.accountingTitle.trim();
      value.accountingEmail = (value.accountingEmail === null) ? value.accountingEmail : value.accountingEmail.trim();
      value.accountingPhone = (value.accountingPhone === null) ? value.accountingPhone : value.accountingPhone.trim();
      value.accountingAlternatePhone = (value.accountingAlternatePhone === null) ? value.accountingAlternatePhone : value.accountingAlternatePhone.trim();
      value.firstName = (value.firstName === null) ? value.firstName : value.firstName.trim();
      value.middleName = (value.middleName === null) ? value.middleName : value.middleName.trim();
      value.lastName = (value.lastName === null) ? value.lastName : value.lastName.trim();
      value.adminEmailId = (value.adminEmailId === null) ? value.adminEmailId : value.adminEmailId.trim();
      value.companyRevenueLastYear = (value.companyRevenueLastYear === null) ? value.companyRevenueLastYear : value.companyRevenueLastYear.trim();
      value.companyRevenueLastYear = this.lastYear + '-' + value.companyRevenueLastYear;
      value.companyRevenue2YearsBefore = (value.companyRevenue2YearsBefore === null) ? value.companyRevenue2YearsBefore : value.companyRevenue2YearsBefore.trim();
      value.companyRevenue2YearsBefore = this.last2YearBefore + '-' + value.companyRevenue2YearsBefore;
      value.companyRevenue3YearsBefore = (value.companyRevenue3YearsBefore === null) ? value.companyRevenue3YearsBefore : value.companyRevenue3YearsBefore.trim();
      value.companyRevenue3YearsBefore = this.last3YearBefore + '-' + value.companyRevenue3YearsBefore;
      value.comments = (value.comments === null) ? value.comments : value.comments.trim();
      //value.optTechnologyTrain = (value.optTechnologyTrain === null) ? value.optTechnologyTrain : value.optTechnologyTrain.trim(); 
      this.stateCount.push({ stateName: StateName['Alabama'], count: value.alabama });
      this.stateCount.push({ stateName: StateName['Alaska'], count: value.alaska });
      this.stateCount.push({ stateName: StateName['Arizona'], count: value.arizona });
      this.stateCount.push({ stateName: StateName['Arkansas'], count: value.arkansas });
      this.stateCount.push({ stateName: StateName['California'], count: value.california });
      this.stateCount.push({ stateName: StateName['Colorado'], count: value.colorado });
      this.stateCount.push({ stateName: StateName['Connecticut'], count: value.connecticut });
      this.stateCount.push({ stateName: StateName['Delaware'], count: value.delaware });
      this.stateCount.push({ stateName: StateName['Florida'], count: value.florida });
      this.stateCount.push({ stateName: StateName['Georgia'], count: value.georgia });
      this.stateCount.push({ stateName: StateName['Hawaii'], count: value.hawaii });
      this.stateCount.push({ stateName: StateName['Idaho'], count: value.idaho });
      this.stateCount.push({ stateName: StateName['Illinois'], count: value.illinois });
      this.stateCount.push({ stateName: StateName['Indiana'], count: value.indiana });
      this.stateCount.push({ stateName: StateName['Iowa'], count: value.iowa });
      this.stateCount.push({ stateName: StateName['Kansas'], count: value.kansas });
      this.stateCount.push({ stateName: StateName['Kentucky'], count: value.kentucky });
      this.stateCount.push({ stateName: StateName['Louisiana'], count: value.louisiana });
      this.stateCount.push({ stateName: StateName['Maine'], count: value.maine });
      this.stateCount.push({ stateName: StateName['Maryland'], count: value.maryland });
      this.stateCount.push({ stateName: StateName['Massachusetts'], count: value.massachusetts });
      this.stateCount.push({ stateName: StateName['Michigan'], count: value.michigan });
      this.stateCount.push({ stateName: StateName['Minnesota'], count: value.minnesota });
      this.stateCount.push({ stateName: StateName['Mississippi'], count: value.mississippi });
      this.stateCount.push({ stateName: StateName['Missouri'], count: value.missouri });
      this.stateCount.push({ stateName: StateName['Montana'], count: value.montana });
      this.stateCount.push({ stateName: StateName['Nebraska'], count: value.nebraska });
      this.stateCount.push({ stateName: StateName['Nevada'], count: value.nevada });
      this.stateCount.push({ stateName: StateName['NewHampshire'], count: value.newHampshire });
      this.stateCount.push({ stateName: StateName['NewJersey'], count: value.newJersey });
      this.stateCount.push({ stateName: StateName['NewMexico'], count: value.newMexico });
      this.stateCount.push({ stateName: StateName['NewYork'], count: value.newYork });
      this.stateCount.push({ stateName: StateName['NorthCarolina'], count: value.northCarolina });
      this.stateCount.push({ stateName: StateName['NorthDakota'], count: value.northDakota });
      this.stateCount.push({ stateName: StateName['Ohio'], count: value.ohio });
      this.stateCount.push({ stateName: StateName['Oklahoma'], count: value.oklahoma });
      this.stateCount.push({ stateName: StateName['Oregon'], count: value.oregon });
      this.stateCount.push({ stateName: StateName['Pennsylvania'], count: value.pennsylvania });
      this.stateCount.push({ stateName: StateName['RhodeIsland'], count: value.rhodeIsland });
      this.stateCount.push({ stateName: StateName['SouthCarolina'], count: value.southCarolina });
      this.stateCount.push({ stateName: StateName['SouthDakota'], count: value.southDakota });
      this.stateCount.push({ stateName: StateName['Tennessee'], count: value.tennessee });
      this.stateCount.push({ stateName: StateName['Texas'], count: value.texas });
      this.stateCount.push({ stateName: StateName['Utah'], count: value.utah });
      this.stateCount.push({ stateName: StateName['Vermont'], count: value.vermont });
      this.stateCount.push({ stateName: StateName['Virginia'], count: value.virginia });
      this.stateCount.push({ stateName: StateName['Washington'], count: value.washington });
      this.stateCount.push({ stateName: StateName['WestVirginia'], count: value.westVirginia });
      this.stateCount.push({ stateName: StateName['Wisconsin'], count: value.wisconsin });
      this.stateCount.push({ stateName: StateName['Wyoming'], count: value.wyoming });
      value.stateCount = this.stateCount;
      if (this.glEffectiveDate != null && value.glEffDate == this.glEffectiveDate) {
        var glEffDate =value.glEffDate.toDateString();
        let formatedglEffDate = new Date(glEffDate);
        var strformat = formatedglEffDate.toString();
        if(strformat.includes("India"))
        {
        formatedglEffDate.setDate(formatedglEffDate.getDate() + 1);
        }
        else
        {
          formatedglEffDate.setDate(formatedglEffDate.getDate());
        }
        value.glEffDate = (value.glEffDate === null) ? null : formatedglEffDate;
      }
      else {
        if(value.glEffDate!=null)
        {
        var glEffDate =value.glEffDate.toDateString();
        let formatedglEffDate = new Date(glEffDate);
        var strformat = formatedglEffDate.toString();
        if(strformat.includes("India"))
        {
        formatedglEffDate.setDate(formatedglEffDate.getDate() + 1);
        }
        else
        {
          formatedglEffDate.setDate(formatedglEffDate.getDate());
        }
        value.glEffDate = (value.glEffDate === null) ? null : formatedglEffDate;
        }
      }
      if (this.glExpiryDate != null && value.glExpDate == this.glExpiryDate) {
        var glExpDate =value.glExpDate.toDateString();
        let formatedglExpDate = new Date(glExpDate);
        var strformat = formatedglExpDate.toString();
        if(strformat.includes("India"))
        {
          formatedglExpDate.setDate(formatedglExpDate.getDate() + 1);
        }
        else
        {
          formatedglExpDate.setDate(formatedglExpDate.getDate());
        }
        value.glExpDate = (value.glExpDate === null) ? null : formatedglExpDate;
      }
      else {
          if(value.glExpDate!=null)
          {
            var glExpDate =value.glExpDate.toDateString();
            let formatedglExpDate = new Date(glExpDate);
            var strformat = formatedglExpDate.toString();
            if(strformat.includes("India"))
            {
              formatedglExpDate.setDate(formatedglExpDate.getDate() + 1);
            }
            else
            {
              formatedglExpDate.setDate(formatedglExpDate.getDate());
            }
            value.glExpDate = (value.glExpDate === null) ? null : formatedglExpDate;
          }
      }
      if (this.alEffectiveDate != null && value.alEffDate == this.alEffectiveDate) {
        var alEffDate =value.alEffDate.toDateString();
        let formatedalEffDate = new Date(alEffDate);
        var strformat = formatedalEffDate.toString();
        if(strformat.includes("India"))
        {
          formatedalEffDate.setDate(formatedalEffDate.getDate() + 1);
        }
        else
        {
          formatedalEffDate.setDate(formatedalEffDate.getDate());
        }
        value.alEffDate = (value.alEffDate === null) ? null : formatedalEffDate;
      }
      else {
        if(value.alEffDate!=null)
        {
        var alEffDate =value.alEffDate.toDateString();
        let formatedalEffDate = new Date(alEffDate);
        var strformat = formatedalEffDate.toString();
        if(strformat.includes("India"))
        {
          formatedalEffDate.setDate(formatedalEffDate.getDate() + 1);
        }
        else
        {
          formatedalEffDate.setDate(formatedalEffDate.getDate());
        }
        value.alEffDate = (value.alEffDate === null) ? null : formatedalEffDate;
        }
      }
      if (this.alExpiryDate != null && value.alExpDate == this.alExpiryDate) {
        var alExpDate =value.alExpDate.toDateString();
          let formatedalExpDate = new Date(alExpDate);
          var strformat = formatedalExpDate.toString();
          if(strformat.includes("India"))
          {
            formatedalExpDate.setDate(formatedalExpDate.getDate() + 1);
          }
          else
          {
            formatedalExpDate.setDate(formatedalExpDate.getDate());
          }
          value.alExpDate = (value.alExpDate === null) ? null : formatedalExpDate;
      }
      else {
        if(value.alExpDate != null)
        {
          var alExpDate =value.alExpDate.toDateString();
          let formatedalExpDate = new Date(alExpDate);
          var strformat = formatedalExpDate.toString();
          if(strformat.includes("India"))
          {
            formatedalExpDate.setDate(formatedalExpDate.getDate() + 1);
          }
          else
          {
            formatedalExpDate.setDate(formatedalExpDate.getDate());
          }
          value.alExpDate = (value.alExpDate === null) ? null : formatedalExpDate;
        }
      }
      if (this.ulEffectiveDate != null && value.ulEffDate == this.ulEffectiveDate) {
        var ulEffDate =value.ulEffDate.toDateString();
        let formatedulEffDate = new Date(ulEffDate);
        var strformat = formatedulEffDate.toString();
        if(strformat.includes("India"))
        {
          formatedulEffDate.setDate(formatedulEffDate.getDate() + 1);
        }
        else
        {
          formatedulEffDate.setDate(formatedulEffDate.getDate());
        }
        value.ulEffDate = (value.ulEffDate === null) ? null : formatedulEffDate;
      }
      else {
        if(value.ulEffDate!=null)
        {
        var ulEffDate =value.ulEffDate.toDateString();
        let formatedulEffDate = new Date(ulEffDate);
        var strformat = formatedulEffDate.toString();
        if(strformat.includes("India"))
        {
          formatedulEffDate.setDate(formatedulEffDate.getDate() + 1);
        }
        else
        {
          formatedulEffDate.setDate(formatedulEffDate.getDate());
        }
        value.ulEffDate = (value.ulEffDate === null) ? null : formatedulEffDate;
        }
      }
      if (this.ulExpiryDate != null && value.ulExpDate == this.ulExpiryDate) {
        var ulExpDate =value.ulExpDate.toDateString();
        let formatedulExpDate = new Date(ulExpDate);
        var strformat = formatedulExpDate.toString();
        if(strformat.includes("India"))
        {
          formatedulExpDate.setDate(formatedulExpDate.getDate() + 1);
        }
        else
        {
          formatedulExpDate.setDate(formatedulExpDate.getDate());
        }
        value.ulExpDate = (value.ulExpDate === null) ? null : formatedulExpDate;
      }
      else {
        if(value.ulExpDate != null)
        {
          var ulExpDate =value.ulExpDate.toDateString();
          let formatedulExpDate = new Date(ulExpDate);
          var strformat = formatedulExpDate.toString();
          if(strformat.includes("India"))
          {
            formatedulExpDate.setDate(formatedulExpDate.getDate() + 1);
          }
          else
          {
            formatedulExpDate.setDate(formatedulExpDate.getDate());
          }
          value.ulExpDate = (value.ulExpDate === null) ? null : formatedulExpDate;
        }
      }
      if (this.wcEffectiveDate != null && value.wcEffDate == this.wcEffectiveDate) {
        var wcEffDate =value.wcEffDate.toDateString();
        let formatedwcEffDate = new Date(wcEffDate);
        var strformat = formatedwcEffDate.toString();
        if(strformat.includes("India"))
        {
          formatedwcEffDate.setDate(formatedwcEffDate.getDate() + 1);
        }
        else
        {
          formatedwcEffDate.setDate(formatedwcEffDate.getDate());
        }
        value.wcEffDate = (value.wcEffDate === null) ? null : formatedwcEffDate;
      }
      else {
        if(value.wcEffDate!=null)
        {
        var wcEffDate =value.wcEffDate.toDateString();
        let formatedwcEffDate = new Date(wcEffDate);
        var strformat = formatedwcEffDate.toString();
        if(strformat.includes("India"))
        {
          formatedwcEffDate.setDate(formatedwcEffDate.getDate() + 1);
        }
        else
        {
          formatedwcEffDate.setDate(formatedwcEffDate.getDate());
        }
        value.wcEffDate = (value.wcEffDate === null) ? null : formatedwcEffDate;
        }
      }
      if (this.wcExpiryDate != null && value.wcExpDate == this.wcExpiryDate) {
        var wcExpDate =value.wcExpDate.toDateString();
        let formatedwcExpDate = new Date(wcExpDate);
        var strformat = formatedwcExpDate.toString();
        if(strformat.includes("India"))
        {
          formatedwcExpDate.setDate(formatedwcExpDate.getDate() + 1);
        }
        else
        {
          formatedwcExpDate.setDate(formatedwcExpDate.getDate());
        }
        value.wcExpDate = (value.wcExpDate === null) ? null : formatedwcExpDate;
      }
      else {
        if(value.wcExpDate != null)
        {
          var wcExpDate =value.wcExpDate.toDateString();
          let formatedwcExpDate = new Date(wcExpDate);
          var strformat = formatedwcExpDate.toString();
          if(strformat.includes("India"))
          {
            formatedwcExpDate.setDate(formatedwcExpDate.getDate() + 1);
          }
          else
          {
            formatedwcExpDate.setDate(formatedwcExpDate.getDate());
          }
          value.wcExpDate = (value.wcExpDate === null) ? null : formatedwcExpDate;
        }
      }
      if (this.plEffectiveDate != null && value.plEffDate == this.plEffectiveDate) {
        var plEffDate =value.plEffDate.toDateString();
        let formatedplEffDate = new Date(plEffDate);
        var strformat = formatedplEffDate.toString();
        if(strformat.includes("India"))
        {
          formatedplEffDate.setDate(formatedplEffDate.getDate() + 1);
        }
        else
        {
          formatedplEffDate.setDate(formatedplEffDate.getDate());
        }
        value.plEffDate = (value.plEffDate === null) ? null : formatedplEffDate;
      }
      else {
        if(value.plEffDate!=null)
        {
        var plEffDate =value.plEffDate.toDateString();
        let formatedplEffDate = new Date(plEffDate);
        var strformat = formatedplEffDate.toString();
        if(strformat.includes("India"))
        {
          formatedplEffDate.setDate(formatedplEffDate.getDate() + 1);
        }
        else
        {
          formatedplEffDate.setDate(formatedplEffDate.getDate());
        }
        value.plEffDate = (value.plEffDate === null) ? null : formatedplEffDate;
        }
      }
      if (this.plExpiryDate != null && value.plExpDate == this.plExpiryDate) {
        var plExpDate =value.plExpDate.toDateString();
        let formatedplExpDate = new Date(plExpDate);
        var strformat = formatedplExpDate.toString();
        if(strformat.includes("India"))
        {
          formatedplExpDate.setDate(formatedplExpDate.getDate() + 1);
        }
        else
        {
          formatedplExpDate.setDate(formatedplExpDate.getDate());
        }
        value.plExpDate = (value.plExpDate === null) ? null : formatedplExpDate;
      }
      else {
        if(value.plExpDate != null)
        {
          var plExpDate =value.plExpDate.toDateString();
          let formatedplExpDate = new Date(plExpDate);
          var strformat = formatedplExpDate.toString();
          if(strformat.includes("India"))
          {
            formatedplExpDate.setDate(formatedplExpDate.getDate() + 1);
          }
          else
          {
            formatedplExpDate.setDate(formatedplExpDate.getDate());
          }
          value.plExpDate = (value.plExpDate === null) ? null : formatedplExpDate;
        }
      }
      value.comments = (value.comments === null) ? null : value.comments;
      if (this.userName != undefined) {
        value.businessCertificationIds = this.businessCertificationEditIds;
      }
      else {
        value.businessCertificationIds = this.businessCertificationIds;
      }
      if (this.userName != undefined) {
        value.tNVisaCountries = this.selectedCountriesEditIds;
      }
      else {
        value.tNVisaCountries = this.selectedCountryIds;
      }
      if (this.userName != undefined) {
        value.clientIds = this.ClientEditIds;
      }
      else {
        value.clientIds = this.selectedClientIds;
      }
      value.isSubmitted = false;
      value.stateId = this.stateId;
      value.entityTypeId = this.entityTypeId;
      value.paymentTermsId = this.paymentTermsId;
      if (this.companyId != 0) {
        value.companyId = this.companyId;
        value.userId = this.userId;
      }
      value.clientIdOnRegistration = this.clientIdOnRegistration;
      this.registerService.registerProfile(value).subscribe((data: any) => {
        this.registerService.updateCompanyForAdmin(data).subscribe((result: any) => {
          if (this.splittedW9formUploadedPath != undefined && this.userName == undefined) {
            var folderName = data.companyId;
            this.registerService.saveW9formUrl(this.splittedW9formUploadedPath[2], folderName, data.companyId).subscribe((res) => {

            });
          }
          if (this.splittedDDUploadedPath != undefined && this.userName == undefined) {
            var folderName = data.companyId;
            this.registerService.saveDDformUrl(this.splittedDDUploadedPath[2], folderName, data.companyId).subscribe((res) => {

            });
          }
          if (this.splittedMSAUploadedPath != undefined && this.userName == undefined) {
            var folderName = data.companyId;
            this.registerService.saveMSAFileUrl(this.splittedMSAUploadedPath[2], folderName, data.companyId).subscribe((res) => {

            });
          }
          if (this.splittedInsuranceUploadedPath != undefined && this.userName == undefined) {
            var folderName = data.companyId;
            this.registerService.saveInsuranceFileUrl(this.splittedInsuranceUploadedPath[2], folderName, data.companyId).subscribe((res) => {

            });
          }
        });
        this.saveModal = true;

      });

    }
  }

  saveRedirect() {
    setTimeout(() => {
      this.spinner.show();
      setTimeout(() => {
        this.spinner.hide();
      }, 2000);
      this.router.navigate(['/login']);
    }, 1000);
  }
  onSubmitRegisterProfile({ value }: { value: IRegister }) {
    this.stateCount.splice(0, this.stateCount.length);
    this.showSubmitSuccess();
    if (value.onshoreFields.length >= 1) {
      this.removeEmpty = [];
      for (var i = 0; i <= value.onshoreFields.length - 1; i++) {
        if (value.onshoreFields[i].contactName == '' &&
          value.onshoreFields[i].phone == '' &&
          value.onshoreFields[i].officeCityState == '' &&
          value.onshoreFields[i].address == '')
          this.removeEmpty.push(i);
      }
      for (var i = 0; i <= this.removeEmpty.length - 1; i++) {
        value.onshoreFields.splice(this.removeEmpty[i], 1);
      }
    }
    if (value.onshoreFields.length >= 1) {
      for (var k = 0; k <= value.onshoreFields.length - 1; k++) {
        value.onshoreFields[k].contactName = (value.onshoreFields[k].contactName === null) ? value.onshoreFields[k].contactName : value.onshoreFields[k].contactName.trim();
        value.onshoreFields[k].phone = (value.onshoreFields[k].phone === null) ? value.onshoreFields[k].phone : value.onshoreFields[k].phone.trim();
        value.onshoreFields[k].officeCityState = (value.onshoreFields[k].officeCityState === null) ? value.onshoreFields[k].officeCityState : value.onshoreFields[k].officeCityState.trim();
        value.onshoreFields[k].address = (value.onshoreFields[k].address === null) ? value.onshoreFields[k].address : value.onshoreFields[k].address.trim();
      }
    }
    if (value.offshoreFields.length >= 1) {
      this.removeEmpty.splice(0, this.removeEmpty.length);
      for (var i = 0; i <= value.offshoreFields.length - 1; i++) {
        if (value.offshoreFields[i].address == '' &&
          value.offshoreFields[i].city == '' &&
          value.offshoreFields[i].state == '' &&
          value.offshoreFields[i].country == '')
          this.removeEmpty.push(i);
      }
      for (var i = this.removeEmpty.length - 1; i >= 0; i--) {
        value.offshoreFields.splice(this.removeEmpty[i], 1);
      }
    }
    if (value.offshoreFields.length >= 1) {
      for (var k = 0; k <= value.offshoreFields.length - 1; k++) {
        value.offshoreFields[k].address = (value.offshoreFields[k].address === null) ? value.offshoreFields[k].address : value.offshoreFields[k].address.trim();
        value.offshoreFields[k].city = (value.offshoreFields[k].city === null) ? value.offshoreFields[k].city : value.offshoreFields[k].city.trim();
        value.offshoreFields[k].state = (value.offshoreFields[k].state === null) ? value.offshoreFields[k].state : value.offshoreFields[k].state.trim();
        value.offshoreFields[k].country = (value.offshoreFields[k].country === null) ? value.offshoreFields[k].country : value.offshoreFields[k].country.trim();
      }
    }
    if (value.referenceFields.length >= 1) {
      this.removeEmpty = [];
      for (var i = 0; i <= value.referenceFields.length - 1; i++) {
        var vrefRevenue;
        if( value.referenceFields[i].refRevenue != null)
        {
          vrefRevenue= value.referenceFields[i].refRevenue.toString();
        }
        else
        {
          vrefRevenue= value.referenceFields[i].refRevenue;
        }
        if (value.referenceFields[i].refClientName == '' &&
          value.referenceFields[i].refContactName == '' &&
          value.referenceFields[i].refContactTitle == '' &&
          value.referenceFields[i].refContactEmail == '' &&
          value.referenceFields[i].refContactPhoneNumber == '' &&
          value.referenceFields[i].refIndustry == '' &&
          value.referenceFields[i].refDurationOfPartnership == '' &&
          value.referenceFields[i].refServicesProvided == '' &&
          vrefRevenue == '' || null ) {
          vrefRevenue = undefined;
          this.removeEmpty.push(i);
        }
      }
      for (var i = 0; i <= this.removeEmpty.length - 1; i++) {
        value.referenceFields.splice(this.removeEmpty[i], 1);
      }
    }
    if (value.referenceFields.length >= 1) {
      for (var k = 0; k <= value.referenceFields.length - 1; k++) {
        value.referenceFields[k].refClientName = (value.referenceFields[k].refClientName === null || value.referenceFields[k].refClientName === '') ? value.referenceFields[k].refClientName : value.referenceFields[k].refClientName.trim();
        value.referenceFields[k].refContactName = (value.referenceFields[k].refContactName === null || value.referenceFields[k].refContactName === '') ? value.referenceFields[k].refContactName : value.referenceFields[k].refContactName.trim();
        value.referenceFields[k].refContactTitle = (value.referenceFields[k].refContactTitle === null || value.referenceFields[k].refContactTitle === '') ? value.referenceFields[k].refContactTitle : value.referenceFields[k].refContactTitle.trim();
        value.referenceFields[k].refContactEmail = (value.referenceFields[k].refContactEmail === null || value.referenceFields[k].refContactEmail === '') ? value.referenceFields[k].refContactEmail : value.referenceFields[k].refContactEmail.trim();
        value.referenceFields[k].refContactPhoneNumber = (value.referenceFields[k].refContactPhoneNumber === null || value.referenceFields[k].refContactPhoneNumber === '') ? value.referenceFields[k].refContactPhoneNumber : value.referenceFields[k].refContactPhoneNumber.trim();
        value.referenceFields[k].refIndustry = (value.referenceFields[k].refIndustry === null || value.referenceFields[k].refIndustry === '') ? value.referenceFields[k].refIndustry : value.referenceFields[k].refIndustry.trim();
        value.referenceFields[k].refDurationOfPartnership = (value.referenceFields[k].refDurationOfPartnership === null || value.referenceFields[k].refDurationOfPartnership === '') ? value.referenceFields[k].refDurationOfPartnership : value.referenceFields[k].refDurationOfPartnership.trim();
        value.referenceFields[k].refServicesProvided = (value.referenceFields[k].refServicesProvided === null || value.referenceFields[k].refServicesProvided === '') ? value.referenceFields[k].refServicesProvided : value.referenceFields[k].refServicesProvided.trim();
      }
    }
    value.isSubmitted = true;
    value.stateId = this.stateId;
    value.vendorName = (value.vendorName === null) ? value.vendorName : value.vendorName.trim();
    value.verifyVendorName = (value.verifyVendorName === null) ? value.vendorName : value.verifyVendorName.trim();
    value.vendorShortName = (value.vendorShortName === null) ? value.vendorShortName : value.vendorShortName.trim();
    value.vendorEmailId = (value.vendorEmailId === null) ? value.vendorEmailId : value.vendorEmailId.trim();
    value.addressLine1 = (value.addressLine1 === null ||value.addressLine1 == undefined) ? value.addressLine1 : value.addressLine1.trim();
    value.addressLine2 = (value.addressLine2 === null) ? value.addressLine2 : value.addressLine2.trim();
    value.city = (value.city === null ||value.city ==undefined) ? value.city : value.city.trim();
    value.ownerName = (value.ownerName === null) ? value.ownerName : value.ownerName.trim();
    value.ownerTitle = (value.ownerTitle === null) ? value.ownerTitle : value.ownerTitle.trim();
    value.ownerEmail = (value.ownerEmail === null) ? value.ownerEmail : value.ownerEmail.trim();
    value.ownerPhone = (value.ownerPhone === null) ? value.ownerPhone : value.ownerPhone.trim();
    value.ownerAlternatePhone = (value.ownerAlternatePhone === null) ? value.ownerAlternatePhone : value.ownerAlternatePhone.trim();
    value.recruitingName = (value.recruitingName === null) ? value.recruitingName : value.recruitingName.trim();
    value.recruitingTitle = (value.recruitingTitle === null) ? value.recruitingTitle : value.recruitingTitle.trim();
    value.recruitingEmail = (value.recruitingEmail === null) ? value.recruitingEmail : value.recruitingEmail.trim();
    value.recruitingPhone = (value.recruitingPhone === null) ? value.recruitingPhone : value.recruitingPhone.trim();
    value.recruitingAlternatePhone = (value.recruitingAlternatePhone === null) ? value.recruitingAlternatePhone : value.recruitingAlternatePhone.trim();
    value.financialName = (value.financialName === null) ? value.financialName : value.financialName.trim();
    value.financialTitle = (value.financialTitle === null) ? value.financialTitle : value.financialTitle.trim();
    value.financialEmail = (value.financialEmail === null) ? value.financialEmail : value.financialEmail.trim();
    value.financialPhone = (value.financialPhone === null) ? value.financialPhone : value.financialPhone.trim();
    value.financialAlternatePhone = (value.financialAlternatePhone === null) ? value.financialAlternatePhone : value.financialAlternatePhone.trim();
    value.accountingName = (value.accountingName === null) ? value.accountingName : value.accountingName.trim();
    value.accountingTitle = (value.accountingTitle === null) ? value.accountingTitle : value.accountingTitle.trim();
    value.accountingEmail = (value.accountingEmail === null) ? value.accountingEmail : value.accountingEmail.trim();
    value.accountingPhone = (value.accountingPhone === null) ? value.accountingPhone : value.accountingPhone.trim();
    value.accountingAlternatePhone = (value.accountingAlternatePhone === null) ? value.accountingAlternatePhone : value.accountingAlternatePhone.trim();
    value.firstName = (value.firstName === null) ? value.firstName : value.firstName.trim();
    value.middleName = (value.middleName === null) ? value.middleName : value.middleName.trim();
    value.lastName = (value.lastName === null) ? value.lastName : value.lastName.trim();
    value.adminEmailId = (value.adminEmailId === null) ? value.adminEmailId : value.adminEmailId.trim();
    value.companyRevenueLastYear = (value.companyRevenueLastYear === null) ? value.companyRevenueLastYear : value.companyRevenueLastYear.trim();
    value.companyRevenueLastYear = this.lastYear + '-' + value.companyRevenueLastYear;
    value.companyRevenue2YearsBefore = (value.companyRevenue2YearsBefore === null) ? value.companyRevenue2YearsBefore : value.companyRevenue2YearsBefore.trim();
    value.companyRevenue2YearsBefore = this.last2YearBefore + '-' + value.companyRevenue2YearsBefore;
    value.companyRevenue3YearsBefore = (value.companyRevenue3YearsBefore === null) ? value.companyRevenue3YearsBefore : value.companyRevenue3YearsBefore.trim();
    value.companyRevenue3YearsBefore = this.last3YearBefore + '-' + value.companyRevenue3YearsBefore;
    value.comments = (value.comments === null) ? value.comments : value.comments.trim();
    //value.optTechnologyTrain = (value.optTechnologyTrain === null) ? value.optTechnologyTrain : value.optTechnologyTrain.trim(); 
    this.stateCount.push({ stateName: StateName['Alabama'], count: value.alabama });
    this.stateCount.push({ stateName: StateName['Alaska'], count: value.alaska });
    this.stateCount.push({ stateName: StateName['Arizona'], count: value.arizona });
    this.stateCount.push({ stateName: StateName['Arkansas'], count: value.arkansas });
    this.stateCount.push({ stateName: StateName['California'], count: value.california });
    this.stateCount.push({ stateName: StateName['Colorado'], count: value.colorado });
    this.stateCount.push({ stateName: StateName['Connecticut'], count: value.connecticut });
    this.stateCount.push({ stateName: StateName['Delaware'], count: value.delaware });
    this.stateCount.push({ stateName: StateName['Florida'], count: value.florida });
    this.stateCount.push({ stateName: StateName['Georgia'], count: value.georgia });
    this.stateCount.push({ stateName: StateName['Hawaii'], count: value.hawaii });
    this.stateCount.push({ stateName: StateName['Idaho'], count: value.idaho });
    this.stateCount.push({ stateName: StateName['Illinois'], count: value.illinois });
    this.stateCount.push({ stateName: StateName['Indiana'], count: value.indiana });
    this.stateCount.push({ stateName: StateName['Iowa'], count: value.iowa });
    this.stateCount.push({ stateName: StateName['Kansas'], count: value.kansas });
    this.stateCount.push({ stateName: StateName['Kentucky'], count: value.kentucky });
    this.stateCount.push({ stateName: StateName['Louisiana'], count: value.louisiana });
    this.stateCount.push({ stateName: StateName['Maine'], count: value.maine });
    this.stateCount.push({ stateName: StateName['Maryland'], count: value.maryland });
    this.stateCount.push({ stateName: StateName['Massachusetts'], count: value.massachusetts });
    this.stateCount.push({ stateName: StateName['Michigan'], count: value.michigan });
    this.stateCount.push({ stateName: StateName['Minnesota'], count: value.minnesota });
    this.stateCount.push({ stateName: StateName['Mississippi'], count: value.mississippi });
    this.stateCount.push({ stateName: StateName['Missouri'], count: value.missouri });
    this.stateCount.push({ stateName: StateName['Montana'], count: value.montana });
    this.stateCount.push({ stateName: StateName['Nebraska'], count: value.nebraska });
    this.stateCount.push({ stateName: StateName['Nevada'], count: value.nevada });
    this.stateCount.push({ stateName: StateName['NewHampshire'], count: value.newHampshire });
    this.stateCount.push({ stateName: StateName['NewJersey'], count: value.newJersey });
    this.stateCount.push({ stateName: StateName['NewMexico'], count: value.newMexico });
    this.stateCount.push({ stateName: StateName['NewYork'], count: value.newYork });
    this.stateCount.push({ stateName: StateName['NorthCarolina'], count: value.northCarolina });
    this.stateCount.push({ stateName: StateName['NorthDakota'], count: value.northDakota });
    this.stateCount.push({ stateName: StateName['Ohio'], count: value.ohio });
    this.stateCount.push({ stateName: StateName['Oklahoma'], count: value.oklahoma });
    this.stateCount.push({ stateName: StateName['Oregon'], count: value.oregon });
    this.stateCount.push({ stateName: StateName['Pennsylvania'], count: value.pennsylvania });
    this.stateCount.push({ stateName: StateName['RhodeIsland'], count: value.rhodeIsland });
    this.stateCount.push({ stateName: StateName['SouthCarolina'], count: value.southCarolina });
    this.stateCount.push({ stateName: StateName['SouthDakota'], count: value.southDakota });
    this.stateCount.push({ stateName: StateName['Tennessee'], count: value.tennessee });
    this.stateCount.push({ stateName: StateName['Texas'], count: value.texas });
    this.stateCount.push({ stateName: StateName['Utah'], count: value.utah });
    this.stateCount.push({ stateName: StateName['Vermont'], count: value.vermont });
    this.stateCount.push({ stateName: StateName['Virginia'], count: value.virginia });
    this.stateCount.push({ stateName: StateName['Washington'], count: value.washington });
    this.stateCount.push({ stateName: StateName['WestVirginia'], count: value.westVirginia });
    this.stateCount.push({ stateName: StateName['Wisconsin'], count: value.wisconsin });
    this.stateCount.push({ stateName: StateName['Wyoming'], count: value.wyoming });
    value.stateCount = this.stateCount;
    if (this.glEffectiveDate != null && value.glEffDate == this.glEffectiveDate) {
      var glEffDate =value.glEffDate.toDateString();
      let formatedglEffDate = new Date(glEffDate);
      var strformat = formatedglEffDate.toString();
      if(strformat.includes("India"))
      {
      formatedglEffDate.setDate(formatedglEffDate.getDate() + 1);
      }
      else
      {
        formatedglEffDate.setDate(formatedglEffDate.getDate());
      }
      value.glEffDate = (value.glEffDate === null) ? null : formatedglEffDate;
    }
    else {
      if(value.glEffDate!=null)
      {
      var glEffDate =value.glEffDate.toDateString();
      let formatedglEffDate = new Date(glEffDate);
      var strformat = formatedglEffDate.toString();
      if(strformat.includes("India"))
      {
      formatedglEffDate.setDate(formatedglEffDate.getDate() + 1);
      }
      else
      {
        formatedglEffDate.setDate(formatedglEffDate.getDate());
      }
      value.glEffDate = (value.glEffDate === null) ? null : formatedglEffDate;
      }
    }
    if (this.glExpiryDate != null && value.glExpDate == this.glExpiryDate) {
      var glExpDate =value.glExpDate.toDateString();
      let formatedglExpDate = new Date(glExpDate);
      var strformat = formatedglExpDate.toString();
      if(strformat.includes("India"))
      {
        formatedglExpDate.setDate(formatedglExpDate.getDate() + 1);
      }
      else
      {
        formatedglExpDate.setDate(formatedglExpDate.getDate());
      }
      value.glExpDate = (value.glExpDate === null) ? null : formatedglExpDate;
    }
    else {
        if(value.glExpDate!=null)
        {
          var glExpDate =value.glExpDate.toDateString();
          let formatedglExpDate = new Date(glExpDate);
          var strformat = formatedglExpDate.toString();
          if(strformat.includes("India"))
          {
            formatedglExpDate.setDate(formatedglExpDate.getDate() + 1);
          }
          else
          {
            formatedglExpDate.setDate(formatedglExpDate.getDate());
          }
          value.glExpDate = (value.glExpDate === null) ? null : formatedglExpDate;
        }
    }
    if (this.alEffectiveDate != null && value.alEffDate == this.alEffectiveDate) {
      var alEffDate =value.alEffDate.toDateString();
      let formatedalEffDate = new Date(alEffDate);
      var strformat = formatedalEffDate.toString();
      if(strformat.includes("India"))
      {
        formatedalEffDate.setDate(formatedalEffDate.getDate() + 1);
      }
      else
      {
        formatedalEffDate.setDate(formatedalEffDate.getDate());
      }
      value.alEffDate = (value.alEffDate === null) ? null : formatedalEffDate;
    }
    else {
      if(value.alEffDate!=null)
      {
      var alEffDate =value.alEffDate.toDateString();
      let formatedalEffDate = new Date(alEffDate);
      var strformat = formatedalEffDate.toString();
      if(strformat.includes("India"))
      {
        formatedalEffDate.setDate(formatedalEffDate.getDate() + 1);
      }
      else
      {
        formatedalEffDate.setDate(formatedalEffDate.getDate());
      }
      value.alEffDate = (value.alEffDate === null) ? null : formatedalEffDate;
      }
    }
    if (this.alExpiryDate != null && value.alExpDate == this.alExpiryDate) {
      var alExpDate =value.alExpDate.toDateString();
        let formatedalExpDate = new Date(alExpDate);
        var strformat = formatedalExpDate.toString();
        if(strformat.includes("India"))
        {
          formatedalExpDate.setDate(formatedalExpDate.getDate() + 1);
        }
        else
        {
          formatedalExpDate.setDate(formatedalExpDate.getDate());
        }
        value.alExpDate = (value.alExpDate === null) ? null : formatedalExpDate;
    }
    else {
      if(value.alExpDate != null)
      {
        var alExpDate =value.alExpDate.toDateString();
        let formatedalExpDate = new Date(alExpDate);
        var strformat = formatedalExpDate.toString();
        if(strformat.includes("India"))
        {
          formatedalExpDate.setDate(formatedalExpDate.getDate() + 1);
        }
        else
        {
          formatedalExpDate.setDate(formatedalExpDate.getDate());
        }
        value.alExpDate = (value.alExpDate === null) ? null : formatedalExpDate;
      }
    }
    if (this.ulEffectiveDate != null && value.ulEffDate == this.ulEffectiveDate) {
      var ulEffDate =value.ulEffDate.toDateString();
      let formatedulEffDate = new Date(ulEffDate);
      var strformat = formatedulEffDate.toString();
      if(strformat.includes("India"))
      {
        formatedulEffDate.setDate(formatedulEffDate.getDate() + 1);
      }
      else
      {
        formatedulEffDate.setDate(formatedulEffDate.getDate());
      }
      value.ulEffDate = (value.ulEffDate === null) ? null : formatedulEffDate;
    }
    else {
      if(value.ulEffDate!=null)
      {
      var ulEffDate =value.ulEffDate.toDateString();
      let formatedulEffDate = new Date(ulEffDate);
      var strformat = formatedulEffDate.toString();
      if(strformat.includes("India"))
      {
        formatedulEffDate.setDate(formatedulEffDate.getDate() + 1);
      }
      else
      {
        formatedulEffDate.setDate(formatedulEffDate.getDate());
      }
      value.ulEffDate = (value.ulEffDate === null) ? null : formatedulEffDate;
      }
    }
    if (this.ulExpiryDate != null && value.ulExpDate == this.ulExpiryDate) {
      var ulExpDate =value.ulExpDate.toDateString();
      let formatedulExpDate = new Date(ulExpDate);
      var strformat = formatedulExpDate.toString();
      if(strformat.includes("India"))
      {
        formatedulExpDate.setDate(formatedulExpDate.getDate() + 1);
      }
      else
      {
        formatedulExpDate.setDate(formatedulExpDate.getDate());
      }
      value.ulExpDate = (value.ulExpDate === null) ? null : formatedulExpDate;
    }
    else {
      if(value.ulExpDate != null)
      {
        var ulExpDate =value.ulExpDate.toDateString();
        let formatedulExpDate = new Date(ulExpDate);
        var strformat = formatedulExpDate.toString();
        if(strformat.includes("India"))
        {
          formatedulExpDate.setDate(formatedulExpDate.getDate() + 1);
        }
        else
        {
          formatedulExpDate.setDate(formatedulExpDate.getDate());
        }
        value.ulExpDate = (value.ulExpDate === null) ? null : formatedulExpDate;
      }
    }
    if (this.wcEffectiveDate != null && value.wcEffDate == this.wcEffectiveDate) {
      var wcEffDate =value.wcEffDate.toDateString();
      let formatedwcEffDate = new Date(wcEffDate);
      var strformat = formatedwcEffDate.toString();
      if(strformat.includes("India"))
      {
        formatedwcEffDate.setDate(formatedwcEffDate.getDate() + 1);
      }
      else
      {
        formatedwcEffDate.setDate(formatedwcEffDate.getDate());
      }
      value.wcEffDate = (value.wcEffDate === null) ? null : formatedwcEffDate;
    }
    else {
      if(value.wcEffDate!=null)
      {
      var wcEffDate =value.wcEffDate.toDateString();
      let formatedwcEffDate = new Date(wcEffDate);
      var strformat = formatedwcEffDate.toString();
      if(strformat.includes("India"))
      {
        formatedwcEffDate.setDate(formatedwcEffDate.getDate() + 1);
      }
      else
      {
        formatedwcEffDate.setDate(formatedwcEffDate.getDate());
      }
      value.wcEffDate = (value.wcEffDate === null) ? null : formatedwcEffDate;
      }
    }
    if (this.wcExpiryDate != null && value.wcExpDate == this.wcExpiryDate) {
      var wcExpDate =value.wcExpDate.toDateString();
      let formatedwcExpDate = new Date(wcExpDate);
      var strformat = formatedwcExpDate.toString();
      if(strformat.includes("India"))
      {
        formatedwcExpDate.setDate(formatedwcExpDate.getDate() + 1);
      }
      else
      {
        formatedwcExpDate.setDate(formatedwcExpDate.getDate());
      }
      value.wcExpDate = (value.wcExpDate === null) ? null : formatedwcExpDate;
    }
    else {
      if(value.wcExpDate != null)
      {
        var wcExpDate =value.wcExpDate.toDateString();
        let formatedwcExpDate = new Date(wcExpDate);
        var strformat = formatedwcExpDate.toString();
        if(strformat.includes("India"))
        {
          formatedwcExpDate.setDate(formatedwcExpDate.getDate() + 1);
        }
        else
        {
          formatedwcExpDate.setDate(formatedwcExpDate.getDate());
        }
        value.wcExpDate = (value.wcExpDate === null) ? null : formatedwcExpDate;
      }
    }
    if (this.plEffectiveDate != null && value.plEffDate == this.plEffectiveDate) {
      var plEffDate =value.plEffDate.toDateString();
      let formatedplEffDate = new Date(plEffDate);
      var strformat = formatedplEffDate.toString();
      if(strformat.includes("India"))
      {
        formatedplEffDate.setDate(formatedplEffDate.getDate() + 1);
      }
      else
      {
        formatedplEffDate.setDate(formatedplEffDate.getDate());
      }
      value.plEffDate = (value.plEffDate === null) ? null : formatedplEffDate;
    }
    else {
      if(value.plEffDate!=null)
      {
      var plEffDate =value.plEffDate.toDateString();
      let formatedplEffDate = new Date(plEffDate);
      var strformat = formatedplEffDate.toString();
      if(strformat.includes("India"))
      {
        formatedplEffDate.setDate(formatedplEffDate.getDate() + 1);
      }
      else
      {
        formatedplEffDate.setDate(formatedplEffDate.getDate());
      }
      value.plEffDate = (value.plEffDate === null) ? null : formatedplEffDate;
      }
    }
    if (this.plExpiryDate != null && value.plExpDate == this.plExpiryDate) {
      var plExpDate =value.plExpDate.toDateString();
      let formatedplExpDate = new Date(plExpDate);
      var strformat = formatedplExpDate.toString();
      if(strformat.includes("India"))
      {
        formatedplExpDate.setDate(formatedplExpDate.getDate() + 1);
      }
      else
      {
        formatedplExpDate.setDate(formatedplExpDate.getDate());
      }
      value.plExpDate = (value.plExpDate === null) ? null : formatedplExpDate;
    }
    else {
      if(value.plExpDate != null)
      {
        var plExpDate =value.plExpDate.toDateString();
        let formatedplExpDate = new Date(plExpDate);
        var strformat = formatedplExpDate.toString();
        if(strformat.includes("India"))
        {
          formatedplExpDate.setDate(formatedplExpDate.getDate() + 1);
        }
        else
        {
          formatedplExpDate.setDate(formatedplExpDate.getDate());
        }
        value.plExpDate = (value.plExpDate === null) ? null : formatedplExpDate;
      }
    }
    value.comments = (value.comments === null) ? null : value.comments;
    if (this.userName != undefined) {
      value.businessCertificationIds = this.businessCertificationEditIds;
    }
    else {
      value.businessCertificationIds = this.businessCertificationIds;
    }
    if (this.userName != undefined) {
      value.tNVisaCountries = this.selectedCountriesEditIds;
    }
    else {
      value.tNVisaCountries = this.selectedCountryIds;
    }
    if (this.userName != undefined) {
      value.clientIds = this.ClientEditIds;
    }
    else {
      value.clientIds = this.selectedClientIds;
    }
    if (this.companyId != 0) {
      value.companyId = this.companyId;
      value.userId = this.userId;
    }
    value.entityTypeId = this.entityTypeId;
    value.paymentTermsId = this.paymentTermsId;
    value.clientIdOnRegistration = this.clientIdOnRegistration;
    this.registerService.registerProfile(value).subscribe((data: any) => {
      this.registerService.updateCompanyForAdmin(data).subscribe((result: any) => {
        if (this.splittedW9formUploadedPath != undefined && this.userName == undefined) {
          var folderName = data.companyId;
          this.registerService.saveW9formUrl(this.splittedW9formUploadedPath[2], folderName, data.companyId).subscribe((res) => {

          });
        }
        if (this.splittedDDUploadedPath != undefined && this.userName == undefined) {
          var folderName = data.companyId;
          this.registerService.saveDDformUrl(this.splittedDDUploadedPath[2], folderName, data.companyId).subscribe((res) => {

          });
        }
        if (this.splittedMSAUploadedPath != undefined && this.userName == undefined) {
          var folderName = data.companyId;
          this.registerService.saveMSAFileUrl(this.splittedMSAUploadedPath[2], folderName, data.companyId).subscribe((res) => {

          });
        }
        if (this.splittedInsuranceUploadedPath != undefined && this.userName == undefined) {
          var folderName = data.companyId;
          this.registerService.saveInsuranceFileUrl(this.splittedInsuranceUploadedPath[2], folderName, data.companyId).subscribe((res) => {

          });
        }
      });
      this.submitModal = true;
    });
  }

  showSaveSuccess() {
    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Vendor Saved Successfully' });
  }
  showSubmitSuccess() {
    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Vendor Submitted Successfully' });
  }
  onVendorEmailAvailabilityCheck() {
    this.vendorEmail = this.registerProfileForm.controls['vendorEmailId'].value;
    if (this.vendorEmail != '') {
      this.vendorEmail = this.vendorEmail.trim();
      this.registerService.onVendorEmailCheck(this.vendorEmail).subscribe((data: any) => {
        this.vendorEmailAvail = data;
      });
    }
  }
  onAdminEmailAvailabilityCheck() {
    this.adminEmail = this.registerProfileForm.controls['adminEmailId'].value;
    if (this.companyId == 0 && this.adminEmail != '') {
      this.adminEmail = this.adminEmail.trim();
      this.registerService.onVendorEmailCheck(this.adminEmail).subscribe((data: any) => {
        this.adminEmailAvail = data;
      });
    }
    if (this.companyId != 0 && this.adminEmail != '') {
      this.adminEmail = this.adminEmail.trim();
      this.registerService.onAdminEmailCheck(this.companyId, this.adminEmail).subscribe((data: any) => {
        this.adminEmailAvail = data;
      });
    }
  }
  onCheckTaxIdNumber() {
    this.taxIdOnMSADoc = this.registerProfileForm.controls['taxIdNumber'].value;
    if ( this.taxIdOnMSADoc != null &&  this.taxIdOnMSADoc  != "")
        {
            var taxIdStart =  this.taxIdOnMSADoc.substring(0, 2);
            var taxIdEnd =  this.taxIdOnMSADoc.substring(2, 7);
            this.taxIdOnMSADoc = taxIdStart + "-" + taxIdEnd;
        }
    var taxIdNumber = this.registerProfileForm.controls['taxIdNumber'].value;
    var taxIdNumberLength = this.registerProfileForm.controls['taxIdNumber'].value.length;
    if (taxIdNumberLength == 9) {
      this.registerService.onTaxIdNumberCheck(taxIdNumber).subscribe((data: any) => {
        this.taxIdAvail = data;
      });
    }
  }
  onVendorAvailabilityCheck() {
    if (this.entityDescription == undefined) {
      this.entityDescription = this.entityTypeEdit;
    }
    this.taxIdNumber = this.registerProfileForm.controls['taxIdNumber'].value;
    this.vendorName = this.registerProfileForm.controls['vendorName'].value;
    this.taxIdNumberLength = this.registerProfileForm.controls['taxIdNumber'].value.length;
    if (this.vendorName != '' && (this.companyId == 0 || this.companyId == undefined)) {
      this.registerService.onVendorNameCheck(this.vendorName).subscribe((data: any) => {
        this.vendorNameAvail = data;
      });
    }
    if (this.entityDescription == 'Individual' && (this.companyId == 0 || this.companyId == undefined)) {
      if (this.vendorName != '' && this.stateId != 0) {
        this.registerService.onVendorAvailabilityCheck(this.vendorName, this.taxIdNumber, this.stateId).subscribe((data: any) => {

          if (data == true) {
            this.isVendorAvailability = false;
            this.messageService.add({ key: 'bc', severity: 'error', summary: 'Error', detail: 'Already company exists in this State with this TaxId' });
          }
          else {
            this.isVendorAvailability = true;
            this.isSaveAvailable = true;
          }

        });
      }
    }
    if (this.entityDescription != 'Individual') {
      if (this.taxIdNumberLength == 9 && this.taxIdNumber != '' && this.vendorName != '' && this.stateId != 0) {
        this.registerService.onVendorAvailabilityCheck(this.vendorName, this.taxIdNumber, this.stateId).subscribe((data: any) => {
          if (data == true) {
            this.isVendorAvailability = false;
            this.messageService.add({ key: 'bc', severity: 'error', summary: 'Error', detail: 'Already company exists in this State with this TaxId' });
          }
          else {
            this.isVendorAvailability = true;
            this.isSaveAvailable = true;
          }

        });
      }

      else if (this.entityDescription != 'Individual' && this.taxIdNumberLength < 9) {
        this.isSaveAvailable = false;
      }
    }

  }

  onCreateUser({ value }: { value: IUserDetails }): void {
    this.userService.createUser(value).subscribe((data: any) => {
    },
      () => {

      });
  }

  public errorHandling = (control: string, error: string) => {
    return this.registerProfileForm.controls[control].hasError(error);
  }
  get registerProfileFormControl() {
    return this.registerProfileForm.controls;
  }
  onCancelRegisterProfile() {
    this.router.navigate(['/login']);
  }

  enableZipCodeExt() {
    this.zipCode = this.registerProfileForm.controls['zipCode'].value;
    this.disabled = false;
    if (this.zipCode == '') {
      this.disabled = true;
      this.registerProfileForm.controls['zipCodeExt'].setValue = undefined;
    }
  }
  onW9FormSelect(event) {
    if(event.target.value != '')
    {
      this.w9FormFileExtension = event.target.value;
      this.w9FormFileExtension = this.w9FormFileExtension.split('\\').pop().split('/').pop();
      if (this.w9FormFileExtension.split('.').pop() == 'pdf' || this.w9FormFileExtension.split('.').pop() == 'docx' || this.w9FormFileExtension.split('.').pop() == 'doc' || this.w9FormFileExtension.split('.').pop() == 'xls' || this.w9FormFileExtension.split('.').pop() == 'xlsx' || this.w9FormFileExtension.split('.').pop() == 'Pdf' || this.w9FormFileExtension.split('.').pop() == 'PDF') {
        /*const pdfTatget: any = event.target;
        if (typeof FileReader !== 'undefined') {
          const reader = new FileReader();
          reader.onload = (e: any) => {
            this.pdfSrc = e.target.result;
          };
          reader.readAsArrayBuffer(pdfTatget.files[0]);
          this.showPreview = true;
          this.uploadW9FormFile();
          this.isw9fileShowsuccessmsg = true;
          this.w9FormValid = false;
          this.w9fileuploadmessage = "W9 Form successfully uploaded";
        }*/
        //this.showW9FormFilePreviewEnable=true;
        //this.showPreview = true;
        this.uploadW9FormFile();
  
        this.isw9fileShowsuccessmsg = true;
        this.w9FormValid = false;
        this.w9fileuploadmessage = this.w9FormFileExtension;
        //this.w9fileuploadmessage = "W9 uploaded successfully";
      }
      else {
        this.showW9FormFilePreviewEnable = false;
        this.w9FormValid = true;
        this.isw9fileShowsuccessmsg = false;
        this.w9fileuploadmessage = "Please select a valid file format (xls,xlsx,pdf,doc,docx)";
      }
    }
  }

  @ViewChild('W9FormUpload') w9FormfileInput;
  uploadW9FormFile(): void {
    this.messageService.add({key: 'w9',severity:'success', summary:'Confirmed', detail:'W9 uploaded successfully'});
    let fi = this.w9FormfileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      this.uploadedFile = fi.files[0];
      //this.companyService.getAllCompanyApprovalList
      if (this.userName == undefined) {
        this.registerService.uploadW9Form(this.uploadedFile).subscribe((res) => {
          this.W9formUploadedPath = res;

          this.splittedW9formUploadedPath = this.W9formUploadedPath.split("/");
          res = res.substring(1);
          this.w9FileDocUrl = VMSConstants.registrationDocumentBaseUrl + res;
          this.showW9FormFilePreview = false;
          // setTimeout(() => {
          //   this.showW9FormFilePreview = true;
          // }, 5000);
          // this.showW9FormFilePreview = false;
          this.showW9FormFilePreviewEnable = true;
          this.w9FormfileInput.nativeElement.value = '';
          const ref = this.dialogService.open(DocViewerDialogComponent, {
            data: {
              fileUrl: this.w9FileDocUrl,
              title: 'W9 Form',
              fileName: this.W9formUploadedPath,
            },
            width: '100%',
            height: '100%',
            baseZIndex: 10000,
            showHeader: false,
          });
        });
      }
      else {
        this.registerService.saveCompanyW9formUrl(this.companyId, this.uploadedFile).subscribe((res) => {
          this.W9formUploadedPath = res;
          this.splittedW9formUploadedPath = this.W9formUploadedPath.split("/");
          this.w9FileDocUrl = VMSConstants.registrationDocumentBaseUrl + res;
          this.showW9FormFilePreview = false;
          // setTimeout(() => {
          //   this.showW9FormFilePreview = true;
          // }, 5000);
          // this.showW9FormFilePreview = false;
          this.showW9FormFilePreviewEnable = true;
          const ref = this.dialogService.open(DocViewerDialogComponent, {
            data: {
              fileUrl: this.w9FileDocUrl,
              title: 'W9 Form',
              fileName: this.W9formUploadedPath,
            },
            width: '100%',
            height: '100%',
            baseZIndex: 10000,
            showHeader: false,
          });
        });
      }
    }
  }

  onDDAutorizationSelect(event) {
    if(event.target.value != '')
    {
      this.DDFileExtension = event.target.value;
      this.DDFileExtension = this.DDFileExtension.split('\\').pop().split('/').pop();
      if (this.DDFileExtension.split('.').pop() == 'pdf' || this.DDFileExtension.split('.').pop() == 'docx' || this.DDFileExtension.split('.').pop() == 'doc' || this.DDFileExtension.split('.').pop() == 'xls' || this.DDFileExtension.split('.').pop() == 'xlsx' || this.DDFileExtension.split('.').pop() == 'PDF' || this.DDFileExtension.split('.').pop() == 'Pdf') {
        /*const pdfTatget: any = event.target;
        if (typeof FileReader !== 'undefined') {
          const reader = new FileReader();
          reader.onload = (e: any) => {
            this.DDpdfSrc = e.target.result;
          };
          reader.readAsArrayBuffer(pdfTatget.files[0]);
          this.showDDPreview = true;
          this.uploadDDFile();
          this.isDDfileShowsuccessmsg = true;
          this.ddAuthorizationValid = false;
          this.DDfileuploadmessage = "DD Authorization letter successfully uploaded";
        }*/
        //this.showDDFormFilePreviewEnable=true;
        this.showDDPreview = true;
        this.uploadDDFile();
        this.isDDfileShowsuccessmsg = true;
        this.ddAuthorizationValid = false;
        this.DDfileuploadmessage = this.DDFileExtension;
        //this.DDfileuploadmessage = "DD authorization letter uploaded successfully ";
      }
      else {
        this.showDDFormFilePreviewEnable = false;
        this.ddAuthorizationValid = true;
        this.isDDfileShowsuccessmsg = false;
        this.DDfileuploadmessage = "Please select a valid file format (xls,xlsx,pdf,doc,docx)";
      }
    }
  }

  @ViewChild('DDAutorizationUpload') DDfileInput;
  uploadDDFile(): void {
    
    this.messageService.add({key: 'dd',severity:'success', summary:'Confirmed', detail:'DD authorization letter uploaded successfully'});
    let fi = this.DDfileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      this.uploadedDDFile = fi.files[0];
      if (this.userName == undefined) {
        this.registerService.uploadDDForm(this.uploadedDDFile).subscribe((res) => {
          this.DDUploadedPath = res;
          this.splittedDDUploadedPath = this.DDUploadedPath.split("/");
          res = res.substring(1);
          this.ddFileDocUrl = VMSConstants.registrationDocumentBaseUrl + res;
          this.showDDFormFilePreview = false;
          // setTimeout(() => {
          //   this.showDDFormFilePreview = true;
          // }, 5000);
          // this.showDDFormFilePreview = false;
          this.showDDFormFilePreviewEnable = true;
          this.DDfileInput.nativeElement.value = '';
          const ref = this.dialogService.open(DocViewerDialogComponent, {
            data: {
              fileUrl: this.ddFileDocUrl,
              title: 'DD Authorization',
              fileName: this.DDUploadedPath,
            },
            width: '100%',
            height: '100%',
            baseZIndex: 10000,
            showHeader: false,
          });
        });
      }
      else {
        this.registerService.saveCompanyDDUrl(this.companyId, this.uploadedDDFile).subscribe((res) => {
          this.DDUploadedPath = res;
          this.splittedDDUploadedPath = this.DDUploadedPath.split("/");
          this.ddFileDocUrl = VMSConstants.registrationDocumentBaseUrl + res;
          this.showDDFormFilePreview = false;
          // setTimeout(() => {
          //   this.showDDFormFilePreview = true;
          // }, 5000);
          // this.showDDFormFilePreview = false;
          this.showDDFormFilePreviewEnable = true;
          const ref = this.dialogService.open(DocViewerDialogComponent, {
            data: {
              fileUrl: this.ddFileDocUrl,
              title: 'DD Authorization',
              fileName: this.DDUploadedPath,
            },
            width: '100%',
            height: '100%',
            baseZIndex: 10000,
            showHeader: false,
          });
        });
      }
    }
  }

  onMSASelect(event) {
    if(event.target.value != '')
    {
      this.MSAFileExtension = event.target.value;
      this.MSAFileExtension = this.MSAFileExtension.split('\\').pop().split('/').pop();
      if (this.MSAFileExtension.split('.').pop() == 'pdf' || this.MSAFileExtension.split('.').pop() == 'docx' || this.MSAFileExtension.split('.').pop() == 'doc' || this.MSAFileExtension.split('.').pop() == 'xls' || this.MSAFileExtension.split('.').pop() == 'xlsx' || this.MSAFileExtension.split('.').pop() == 'PDF' || this.MSAFileExtension.split('.').pop() == 'Pdf') {
        /*const pdfTatget: any = event.target;
        if (typeof FileReader !== 'undefined') {
          const reader = new FileReader();
          reader.onload = (e: any) => {
            this.MSApdfSrc = e.target.result;
          };
          reader.readAsArrayBuffer(pdfTatget.files[0]);
          this.showMSAPreview = true;
          this.uploadMSAFile();
          this.isMSAfileShowsuccessmsg = true;
          this.msaValid = false;
          this.MSAfileuploadmessage = "MSA successfully uploaded";
        }*/
        //this.showMSAFormFilePreviewEnable=true;
        this.showMSAPreview = true;
        this.uploadMSAFile();
        this.isMSAfileShowsuccessmsg = true;
        this.msaValid = false;
        this.MSAfileuploadmessage = this.MSAFileExtension;
        //this.MSAfileuploadmessage = "MSA uploaded successfully";
      }
      else {
        this.showMSAFormFilePreviewEnable = false;
        this.msaValid = true;
        this.isMSAfileShowsuccessmsg = false;
        this.MSAfileuploadmessage = "Please select a valid file format (xls,xlsx,pdf,doc,docx)";
      }
    }
  }

  getEntityType() {
    this.categoryName = 'Entity Type'
    this.sharedService.getLookupCategory(this.categoryName).subscribe((data: any) => {
      this.entityTypes = data;
      this.entityTypes = data.filter(item => item.description !== 'Individual');
    });
  }

  emailValidator(entity): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      
    if(control.value != this.adminEmailId)
    {
      if (/^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/.test(control.value)) {
        var domainName = control.value.split('@')[1].split('.')[0];

        if (entity == 'Individual') {
          if (this.allowedEmailList.includes(domainName) == false) {
            return { 'emailEntityInvalid': true };
          }
        }

        if (entity == 'Others') {
          if (this.allowedEmailList.includes(domainName) == true) {
            this.confirmationService.confirm({
              key:'businessEmail',
             //message: '<center>Please verify the email entered on the company profile is</center><center>'+' '+this.emailId.bold()+'.</center><center> You cannot change this email address after the save.</center><center>Select <strong>YES</strong> to continue or <strong>NO </strong>to go back and edit the email address',
             message: '<center> You have entered free service email address, please provide a business/work email address if available. </center>',
             accept: () => {
               this.emailEntityInvalid = true;
               return { 'emailEntityInvalid': true };
             },
             reject:() =>{
               this.emailEntityInvalid = false;
             }});


          }
          else {
            this.emailEntityInvalid = false;
          }
        }
      }
    }
     
    }

  }
  vendorPhoneUniqueNumbers(event) {
    let avoidString: Array<string> = ['(000) 000-0000', '(111) 111-1111', '(222) 222-2222', '(222) 222-2222', '(333) 333-3333', '(444) 444-4444', '(555) 555-5555', '(666) 666-6666', '(777) 777-7777', '(888) 888-8888', '(999) 999-9999'];
    let name = event.target.value;
    if (name.length >= 1 && name.length < 14) {
      this.isVendorPhoneNumberValid = true;
    }
    else {
      this.isVendorPhoneNumberValid = false;
    }
    if (avoidString.includes(name)) {
      this.isVendorPhoneUniqueNumbers = true;
    }
    else {
      this.isVendorPhoneUniqueNumbers = false;
    }

    if (avoidString.includes(name) || name.length < 14) {
      this.vendorPhoneExtDisabled = true;
    }
    else {
      this.vendorPhoneExtDisabled = false;
    }
  }

  faxUniqueNumbers(event) {
    let avoidString: Array<string> = ['(000) 000-0000', '(111) 111-1111', '(222) 222-2222', '(222) 222-2222', '(333) 333-3333', '(444) 444-4444', '(555) 555-5555', '(666) 666-6666', '(777) 777-7777', '(888) 888-8888', '(999) 999-9999'];
    let name = event.target.value;
    if (name.length >= 1 && name.length < 14) {
      this.isFaxNumberValid = true;
    }
    else {
      this.isFaxNumberValid = false;
    }
    if (avoidString.includes(name)) {
      this.isFaxUniqueNumbers = true;
    }
    else {
      this.isFaxUniqueNumbers = false;
    }
  }


  userPhoneUniqueNumbers(event) {
    let avoidString: Array<string> = ['(000) 000-0000', '(111) 111-1111', '(222) 222-2222', '(222) 222-2222', '(333) 333-3333', '(444) 444-4444', '(555) 555-5555', '(666) 666-6666', '(777) 777-7777', '(888) 888-8888', '(999) 999-9999'];
    let name = event.target.value;
    if (name.length >= 1 && name.length < 14) {
      this.isUserPhoneNumberValid = true;
    }
    else {
      this.isUserPhoneNumberValid = false;
    }
    if (avoidString.includes(name)) {
      this.isUserPhoneUniqueNumbers = true;
    }
    else {
      this.isUserPhoneUniqueNumbers = false;
    }

    if (avoidString.includes(name) || name.length < 14) {
      this.phoneExtDisabled = true;
    }
    else {
      this.phoneExtDisabled = false;
    }
  }

  onshorePhoneUniqueNumbers(event, i) {
    let avoidString: Array<string> = ['(000) 000-0000', '(111) 111-1111', '(222) 222-2222', '(333) 333-3333', '(444) 444-4444', '(555) 555-5555', '(666) 666-6666', '(777) 777-7777', '(888) 888-8888', '(999) 999-9999'];
    let name = event.target.value;
    if(this.registerProfileForm.controls['onshoreFields']['controls'].length >0)
    {
      for(var k =0; k<this.registerProfileForm.controls['onshoreFields']['controls'].length;k++)
      {
        var onshorenum =this.registerProfileForm.controls['onshoreFields']['controls'][k]['controls']['phone'];
        console.log('ons',onshorenum.value);
        if(onshorenum.value.length >= 1 && onshorenum.value.length < 10)
         {
          this.isOnshorePhoneNumberValid = true;
         }
         else
         {
          this.isOnshorePhoneNumberValid = false;
         }

      }
    }
    const onshorePhone = this.registerProfileForm.controls['onshoreFields']['controls'][i]['controls']['phone'];

    if (name.length == 0) {
      onshorePhone.clearValidators();
    }
    else {

      if (name.length < 14) {
        onshorePhone.setValidators([Validators.pattern(VMSConstants.urlRegex)]);
      }
      else if (avoidString.includes(name)) {
        onshorePhone.setValidators([Validators.minLength(20)]);
      }
      else {
        onshorePhone.clearValidators();
      }
      onshorePhone.updateValueAndValidity();
    }
  }

  onreferencePhoneUniqueNumbers(event, i) {
    let avoidString: Array<string> = ['(000) 000-0000', '(111) 111-1111', '(222) 222-2222', '(333) 333-3333', '(444) 444-4444', '(555) 555-5555', '(666) 666-6666', '(777) 777-7777', '(888) 888-8888', '(999) 999-9999'];
    let name = event.target.value;
    if(this.registerProfileForm.controls['referenceFields']['controls'].length >0)
    {
      for(var k =0; k<this.registerProfileForm.controls['referenceFields']['controls'].length;k++)
      {
        var referphonenum =this.registerProfileForm.controls['referenceFields']['controls'][k]['controls']['refContactPhoneNumber'];
        if(referphonenum.value.length >= 1 && referphonenum.value.length < 10)
         {
          this.isReferencePhoneNumberValid = true;
         }
         else
         {
          this.isReferencePhoneNumberValid = false;
         }

      }
    }
    const referencePhone = this.registerProfileForm.controls['referenceFields']['controls'][i]['controls']['refContactPhoneNumber'];
    if (i == 0) {
      if (name.length == 0) {
        referencePhone.clearValidators();
      }
      else {
        if (name.length < 14) {
          referencePhone.setValidators([Validators.required, Validators.pattern(VMSConstants.urlRegex)]);
        }
        else if (avoidString.includes(name)) {
          referencePhone.setValidators([Validators.required, Validators.minLength(20)]);
        }
        else {
          referencePhone.clearValidators();
        }
        referencePhone.updateValueAndValidity();
      }
    }
    else {
      if (name.length == 0) {
        referencePhone.clearValidators();
      }
      else {
        if (name.length < 14) {
          referencePhone.setValidators([Validators.pattern(VMSConstants.urlRegex)]);
        }
        else if (avoidString.includes(name)) {
          referencePhone.setValidators([Validators.minLength(20)]);
        }
        else {
          referencePhone.clearValidators();
        }
        referencePhone.updateValueAndValidity();
      }
    }
  }

  referenceEmail(event, i) {
    const referenceEmail = this.registerProfileForm.controls['referenceFields']['controls'][i]['controls']['refContactEmail'];
    if (i == 0) {
      referenceEmail.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
    }
    else {
      referenceEmail.setValidators([Validators.pattern(VMSConstants.emailValidator)]);
    }
    referenceEmail.updateValueAndValidity();
  }

  ownerPhoneUniqueNumbers(event) {
    let avoidString: Array<string> = ['(000) 000-0000', '(111) 111-1111', '(222) 222-2222', '(222) 222-2222', '(333) 333-3333', '(444) 444-4444', '(555) 555-5555', '(666) 666-6666', '(777) 777-7777', '(888) 888-8888', '(999) 999-9999'];
    let name = event.target.value;
    if (name.length < 14) {
      this.isOwnerPhoneNumberValid = true;
    }
    else {
      this.isOwnerPhoneNumberValid = false;
    }
    if (avoidString.includes(name)) {
      this.isOwnerPhoneUniqueNumbers = true;
    }
    else {
      this.isOwnerPhoneUniqueNumbers = false;
    }

  }
  ownerAlternatePhoneUniqueNumbers(event) {
    let avoidString: Array<string> = ['(000) 000-0000', '(111) 111-1111', '(222) 222-2222', '(222) 222-2222', '(333) 333-3333', '(444) 444-4444', '(555) 555-5555', '(666) 666-6666', '(777) 777-7777', '(888) 888-8888', '(999) 999-9999'];
    let name = event.target.value;
    if (name.length < 14) {
      this.isOwnerAlternatePhoneNumberValid = true;
    }
    else {
      this.isOwnerAlternatePhoneNumberValid = false;
    }
    if (avoidString.includes(name)) {
      this.isOwnerAlternatePhoneUniqueNumbers = true;
    }
    else {
      this.isOwnerAlternatePhoneUniqueNumbers = false;
    }
  }
  recruitingPhoneUniqueNumbers(event) {
    let avoidString: Array<string> = ['(000) 000-0000', '(111) 111-1111', '(222) 222-2222', '(222) 222-2222', '(333) 333-3333', '(444) 444-4444', '(555) 555-5555', '(666) 666-6666', '(777) 777-7777', '(888) 888-8888', '(999) 999-9999'];
    let name = event.target.value;
    if (name.length < 14) {
      this.isRecruitingPhoneNumberValid = true;
    }
    else {
      this.isRecruitingPhoneNumberValid = false;
    }
    if (avoidString.includes(name)) {
      this.isRecruitingPhoneUniqueNumbers = true;
    }
    else {
      this.isRecruitingPhoneUniqueNumbers = false;
    }
  }
  recruitingAlternatePhoneUniqueNumbers(event) {
    let avoidString: Array<string> = ['(000) 000-0000', '(111) 111-1111', '(222) 222-2222', '(222) 222-2222', '(333) 333-3333', '(444) 444-4444', '(555) 555-5555', '(666) 666-6666', '(777) 777-7777', '(888) 888-8888', '(999) 999-9999'];
    let name = event.target.value;
    if (name.length < 14) {
      this.isRecruitingAlternatePhoneNumberValid = true;
    }
    else {
      this.isRecruitingAlternatePhoneNumberValid = false;
    }
    if (avoidString.includes(name)) {
      this.isRecruitingAlternatePhoneUniqueNumbers = true;
    }
    else {
      this.isRecruitingAlternatePhoneUniqueNumbers = false;
    }
  }
  financialPhoneUniqueNumbers(event) {
    let avoidString: Array<string> = ['(000) 000-0000', '(111) 111-1111', '(222) 222-2222', '(222) 222-2222', '(333) 333-3333', '(444) 444-4444', '(555) 555-5555', '(666) 666-6666', '(777) 777-7777', '(888) 888-8888', '(999) 999-9999'];
    let name = event.target.value;
    if (name.length < 14) {
      this.isFinancialPhoneNumberValid = true;
    }
    else {
      this.isFinancialPhoneNumberValid = false;
    }
    if (avoidString.includes(name)) {
      this.isFinancialPhoneUniqueNumbers = true;
    }
    else {
      this.isFinancialPhoneUniqueNumbers = false;
    }
  }
  financialAlternatePhoneUniqueNumbers(event) {
    let avoidString: Array<string> = ['(000) 000-0000', '(111) 111-1111', '(222) 222-2222', '(222) 222-2222', '(333) 333-3333', '(444) 444-4444', '(555) 555-5555', '(666) 666-6666', '(777) 777-7777', '(888) 888-8888', '(999) 999-9999'];
    let name = event.target.value;
    if (name.length < 14) {
      this.isFinancialAlternatePhoneNumberValid = true;
    }
    else {
      this.isFinancialAlternatePhoneNumberValid = false;
    }
    if (avoidString.includes(name)) {
      this.isFinancialAlternatePhoneUniqueNumbers = true;
    }
    else {
      this.isFinancialAlternatePhoneUniqueNumbers = false;
    }
  }
  accountingPhoneUniqueNumbers(event) {
    let avoidString: Array<string> = ['(000) 000-0000', '(111) 111-1111', '(222) 222-2222', '(222) 222-2222', '(333) 333-3333', '(444) 444-4444', '(555) 555-5555', '(666) 666-6666', '(777) 777-7777', '(888) 888-8888', '(999) 999-9999'];
    let name = event.target.value;
    if (name.length < 14) {
      this.isAccountingPhoneNumberValid = true;
    }
    else {
      this.isAccountingPhoneNumberValid = false;
    }
    if (avoidString.includes(name)) {
      this.isAccountingPhoneUniqueNumbers = true;
    }
    else {
      this.isAccountingPhoneUniqueNumbers = false;
    }
  }
  accountingAlternatePhoneUniqueNumbers(event) {
    let avoidString: Array<string> = ['(000) 000-0000', '(111) 111-1111', '(222) 222-2222', '(222) 222-2222', '(333) 333-3333', '(444) 444-4444', '(555) 555-5555', '(666) 666-6666', '(777) 777-7777', '(888) 888-8888', '(999) 999-9999'];
    let name = event.target.value;
    if (name.length < 14) {
      this.isAccountingAlternatePhoneNumberValid = true;
    }
    else {
      this.isAccountingAlternatePhoneNumberValid = false;
    }
    if (avoidString.includes(name)) {
      this.isAccountingAlternatePhoneUniqueNumbers = true;
    }
    else {
      this.isAccountingAlternatePhoneUniqueNumbers = false;
    }
  }

  getEntityTypeOnChange(event) {
    this.entityTypeId = event.value.lookupId;
    this.entityDescription = event.value.description;
    this.entityTypeEnable = false;
    this.onVendorAvailabilityCheck();
    const webAddress = this.registerProfileForm.get('webAddress');
    const address = this.registerProfileForm.get('addressLine1');
    const city = this.registerProfileForm.get('city');
    const firstName = this.registerProfileForm.get('firstName');
    const lastName = this.registerProfileForm.get('lastName');
    const vendorName = this.registerProfileForm.get('vendorName');
    const phoneNumber = this.registerProfileForm.get('phoneNumber');
    const vendorPhoneNumber = this.registerProfileForm.get('vendorPhoneNumber');
    const zipcode = this.registerProfileForm.get('zipCode');
    const taxIdNumber = this.registerProfileForm.get('taxIdNumber');
    const vendorEmailId = this.registerProfileForm.get('vendorEmailId');
    const adminEmailId = this.registerProfileForm.get('adminEmailId');

    const companyEstablishment = this.registerProfileForm.get('companyEstablishment');
    const companysKeyCapabilities = this.registerProfileForm.get('companysKeyCapabilities');
    const corporateHistory = this.registerProfileForm.get('corporateHistory');
    const awardsAndCertifications = this.registerProfileForm.get('awardsAndCertifications');
    const companyRevenueLastYear = this.registerProfileForm.get('companyRevenueLastYear');
    const companyRevenue2YearsBefore = this.registerProfileForm.get('companyRevenue2YearsBefore');
    const companyRevenue3YearsBefore = this.registerProfileForm.get('companyRevenue3YearsBefore');
    const noofW2Employees = this.registerProfileForm.get('noofW2Employees');
    const noofC2CConsultant = this.registerProfileForm.get('noofC2CConsultant');
    const noofOPTCandidatesAvailable = this.registerProfileForm.get('noofOPTCandidatesAvailable');
    const oPTTechnologyTrain = this.registerProfileForm.get('oPTTechnologyTrain');
    const noofTNVisaCandidates = this.registerProfileForm.get('noofTNVisaCandidates');
    const availableCandidateBench = this.registerProfileForm.get('availableCandidateBench');

    const ownerName = this.registerProfileForm.get('ownerName');
    const ownerTitle = this.registerProfileForm.get('ownerTitle');
    const ownerEmail = this.registerProfileForm.get('ownerEmail');
    const ownerPhone = this.registerProfileForm.get('ownerPhone');
    const ownerAlternatePhone = this.registerProfileForm.get('ownerAlternatePhone');

    const recruitingName = this.registerProfileForm.get('recruitingName');
    const recruitingTitle = this.registerProfileForm.get('recruitingTitle');
    const recruitingEmail = this.registerProfileForm.get('recruitingEmail');
    const recruitingPhone = this.registerProfileForm.get('recruitingPhone');
    const recruitingAlternatePhone = this.registerProfileForm.get('recruitingAlternatePhone');

    const financialName = this.registerProfileForm.get('financialName');
    const financialTitle = this.registerProfileForm.get('financialTitle');
    const financialEmail = this.registerProfileForm.get('financialEmail');
    const financialPhone = this.registerProfileForm.get('financialPhone');
    const financialAlternatePhone = this.registerProfileForm.get('financialAlternatePhone');

    const accountingName = this.registerProfileForm.get('accountingName');
    const accountingTitle = this.registerProfileForm.get('accountingTitle');
    const accountingEmail = this.registerProfileForm.get('accountingEmail');
    const accountingPhone = this.registerProfileForm.get('accountingPhone');
    const accountingAlternatePhone = this.registerProfileForm.get('accountingAlternatePhone');
    const refClientName = this.registerProfileForm.controls['referenceFields']['controls'][0]['controls']['refClientName'];

    const hbContactName = this.registerProfileFormControl['onshoreFields']['controls'][0]['controls']['contactName'];
    const hbPhone = this.registerProfileFormControl['onshoreFields']['controls'][0]['controls']['phone'];
    const hbOfficeCityState = this.registerProfileFormControl['onshoreFields']['controls'][0]['controls']['officeCityState'];
    const hbAddress = this.registerProfileFormControl['onshoreFields']['controls'][0]['controls']['address'];

    const refContactName = this.registerProfileForm.controls['referenceFields']['controls'][0]['controls']['refContactName'];
    const refContactTitle = this.registerProfileForm.controls['referenceFields']['controls'][0]['controls']['refContactTitle'];
    const refContactEmail = this.registerProfileForm.controls['referenceFields']['controls'][0]['controls']['refContactEmail'];
    const refContactPhoneNumber = this.registerProfileForm.controls['referenceFields']['controls'][0]['controls']['refContactPhoneNumber'];
    const refIndustry = this.registerProfileForm.controls['referenceFields']['controls'][0]['controls']['refIndustry'];
    const refDurationOfPartnership = this.registerProfileForm.controls['referenceFields']['controls'][0]['controls']['refDurationOfPartnership'];
    const refServicesProvided = this.registerProfileForm.controls['referenceFields']['controls'][0]['controls']['refServicesProvided'];
    const refRevenue = this.registerProfileForm.controls['referenceFields']['controls'][0]['controls']['refRevenue'];


    const glEffDate = this.registerProfileForm.get('glEffDate');
    const glExpDate = this.registerProfileForm.get('glExpDate');
    const alEffDate = this.registerProfileForm.get('alEffDate');
    const alExpDate = this.registerProfileForm.get('alExpDate');
    const ulEffDate = this.registerProfileForm.get('ulEffDate');
    const ulExpDate = this.registerProfileForm.get('ulExpDate');
    const wcEffDate = this.registerProfileForm.get('wcEffDate');
    const wcExpDate = this.registerProfileForm.get('wcExpDate');
    const plEffDate = this.registerProfileForm.get('plEffDate');
    const plExpDate = this.registerProfileForm.get('plExpDate');
    webAddress.clearValidators();
    address.clearValidators();
    city.clearValidators();
    phoneNumber.clearValidators();
    vendorPhoneNumber.clearValidators();
    zipcode.clearValidators();
    firstName.clearValidators();
    lastName.clearValidators();
    vendorName.clearValidators();
    taxIdNumber.clearValidators();
    companyEstablishment.clearValidators();
    companysKeyCapabilities.clearValidators();
    corporateHistory.clearValidators();
    awardsAndCertifications.clearValidators();
    companyRevenueLastYear.clearValidators();
    companyRevenue2YearsBefore.clearValidators();
    companyRevenue3YearsBefore.clearValidators();
    noofW2Employees.clearValidators();
    noofC2CConsultant.clearValidators();
    noofOPTCandidatesAvailable.clearValidators();
    oPTTechnologyTrain.clearValidators();
    noofTNVisaCandidates.clearValidators();
    availableCandidateBench.clearValidators();

    ownerName.clearValidators();
    ownerTitle.clearValidators();
    ownerEmail.clearValidators();
    ownerPhone.clearValidators();
    ownerAlternatePhone.clearValidators();

    recruitingName.clearValidators();
    recruitingTitle.clearValidators();
    recruitingEmail.clearValidators();
    recruitingPhone.clearValidators();
    recruitingAlternatePhone.clearValidators();

    financialName.clearValidators();
    financialTitle.clearValidators();
    financialEmail.clearValidators();
    financialPhone.clearValidators();
    financialAlternatePhone.clearValidators();

    accountingName.clearValidators();
    accountingTitle.clearValidators();
    accountingEmail.clearValidators();
    accountingPhone.clearValidators();
    accountingAlternatePhone.clearValidators();
    hbContactName.clearValidators();
    hbPhone.clearValidators();
    hbOfficeCityState.clearValidators();
    hbAddress.clearValidators();

    refClientName.clearValidators();
    refContactName.clearValidators();
    refContactTitle.clearValidators();
    refContactEmail.clearValidators();
    refContactPhoneNumber.clearValidators();
    refIndustry.clearValidators();
    refDurationOfPartnership.clearValidators();
    refServicesProvided.clearValidators();
    refRevenue.clearValidators();
    vendorEmailId.clearValidators();
    adminEmailId.clearValidators();
    glEffDate.clearValidators();
    glExpDate.clearValidators();
    alExpDate.clearValidators();
    ulEffDate.clearValidators();
    ulExpDate.clearValidators();
    wcEffDate.clearValidators();
    wcExpDate.clearValidators();
    plEffDate.clearValidators();
    plExpDate.clearValidators();

    if (event.value.description == 'Individual') {
      this.emailEntityInvalid = false;
      this.forIndividual = true;
      this.coiValid = false;
      this.msaValid = false;
      this.ddAuthorizationValid = false;
      this.w9FormValid = false;
      this.businessCertificationValid = false;
      this.selectedCountryValid = false;
      webAddress.setValidators([Validators.pattern(VMSConstants.urlRegex)]);
      taxIdNumber.clearValidators();
      companyEstablishment.clearValidators();
      companysKeyCapabilities.clearValidators();
      corporateHistory.clearValidators();
      awardsAndCertifications.clearValidators();
      companyRevenueLastYear.clearValidators();
      companyRevenue2YearsBefore.clearValidators();
      companyRevenue3YearsBefore.clearValidators();
      noofW2Employees.clearValidators();
      noofC2CConsultant.clearValidators();
      noofOPTCandidatesAvailable.clearValidators();
      oPTTechnologyTrain.clearValidators();
      noofTNVisaCandidates.clearValidators();
      availableCandidateBench.clearValidators();

      ownerName.clearValidators();
      ownerTitle.clearValidators();
      ownerEmail.setValidators([Validators.pattern(VMSConstants.emailValidator)]);
      ownerPhone.clearValidators();
      ownerAlternatePhone.clearValidators();

      recruitingName.clearValidators();
      recruitingTitle.clearValidators();
      recruitingEmail.setValidators([Validators.pattern(VMSConstants.emailValidator)]);
      recruitingPhone.clearValidators();
      recruitingAlternatePhone.clearValidators();

      financialName.clearValidators();
      financialTitle.clearValidators();
      financialEmail.setValidators([Validators.pattern(VMSConstants.emailValidator)]);
      financialPhone.clearValidators();
      financialAlternatePhone.clearValidators();

      accountingName.clearValidators();
      accountingTitle.clearValidators();
      accountingEmail.setValidators([Validators.pattern(VMSConstants.emailValidator)]);
      accountingPhone.clearValidators();
      accountingAlternatePhone.clearValidators();
      hbContactName.clearValidators();
      hbPhone.clearValidators();
      hbOfficeCityState.clearValidators();
      hbAddress.clearValidators();
      refClientName.clearValidators();
      refContactName.clearValidators();
      refContactTitle.clearValidators();
      refContactEmail.setValidators([Validators.pattern(VMSConstants.emailValidator)]);
      refContactPhoneNumber.clearValidators();
      refIndustry.clearValidators();
      refDurationOfPartnership.clearValidators();
      refServicesProvided.clearValidators();
      refRevenue.setValidators(Validators.pattern(VMSConstants.revenueValidator));
      address.setValidators([Validators.required]);
      city.setValidators([Validators.required]);
      firstName.setValidators([Validators.required]);
      lastName.setValidators([Validators.required]);
      vendorName.setValidators([Validators.required]);
      phoneNumber.setValidators([Validators.required]);
      vendorPhoneNumber.setValidators([Validators.required]);
      zipcode.setValidators([Validators.required, Validators.pattern(VMSConstants.zipcodeValidator)]);
      vendorEmailId.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
      adminEmailId.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
      glExpDate.clearValidators();
      alEffDate.clearValidators();
      alExpDate.clearValidators();
      ulEffDate.clearValidators();
      ulExpDate.clearValidators();
      wcEffDate.clearValidators();
      wcExpDate.clearValidators();
      plEffDate.clearValidators();
      plExpDate.clearValidators();
      companysKeyCapabilities.setValidators([this.editorMaxLength(10000)]);
      corporateHistory.setValidators([this.editorMaxLength(10000)]);
      awardsAndCertifications.setValidators([this.editorMaxLength(2000)]);
      availableCandidateBench.setValidators([this.editorMaxLength(1000)]);
    } else {
      this.forIndividual = false;
      webAddress.setValidators([Validators.pattern(VMSConstants.urlRegex)]);
      taxIdNumber.setValidators([Validators.required, Validators.minLength(9)]);
      companyEstablishment.setValidators([Validators.required]);
      companysKeyCapabilities.setValidators([Validators.required, this.editorMaxLength(10000)]);
      corporateHistory.setValidators([Validators.required, this.editorMaxLength(10000)]);
      awardsAndCertifications.setValidators([Validators.required, this.editorMaxLength(2000)]);
      companyRevenueLastYear.setValidators([Validators.required]);
      companyRevenue2YearsBefore.setValidators([Validators.required]);
      companyRevenue3YearsBefore.setValidators([Validators.required]);
      noofW2Employees.setValidators([Validators.required]);
      noofC2CConsultant.setValidators([Validators.required]);
      phoneNumber.setValidators([Validators.required]);
      vendorPhoneNumber.setValidators([Validators.required]);
      zipcode.setValidators([Validators.required, Validators.pattern(VMSConstants.zipcodeValidator)]);
      if (this.showOPT == true) {
        noofOPTCandidatesAvailable.setValidators([Validators.required]);
        oPTTechnologyTrain.setValidators([Validators.required]);
      }
      else if (this.showOPT == false) {
        noofOPTCandidatesAvailable.clearValidators();
        oPTTechnologyTrain.clearValidators();
      }
      if (this.showTNVisa == true) {
        noofTNVisaCandidates.setValidators([Validators.required]);
      }
      else if (this.showTNVisa == false) {
        noofTNVisaCandidates.clearValidators();
      }

      availableCandidateBench.setValidators([Validators.required, this.editorMaxLength(1000)]);

      ownerName.setValidators([Validators.required]);
      ownerTitle.setValidators([Validators.required]);
      ownerEmail.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
      ownerPhone.setValidators([Validators.required]);
      ownerAlternatePhone.setValidators([Validators.required]);

      recruitingName.setValidators([Validators.required]);
      recruitingTitle.setValidators([Validators.required]);
      recruitingEmail.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
      recruitingPhone.setValidators([Validators.required]);
      recruitingAlternatePhone.setValidators([Validators.required]);

      financialName.setValidators([Validators.required]);
      financialTitle.setValidators([Validators.required]);
      financialEmail.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
      financialPhone.setValidators([Validators.required]);
      financialAlternatePhone.setValidators([Validators.required]);

      accountingName.setValidators([Validators.required]);
      accountingTitle.setValidators([Validators.required]);
      accountingEmail.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
      accountingPhone.setValidators([Validators.required]);
      accountingAlternatePhone.setValidators([Validators.required]);

      hbContactName.setValidators([Validators.required]);
      hbPhone.setValidators([Validators.required]);
      hbOfficeCityState.setValidators([Validators.required]);
      hbAddress.setValidators([Validators.required]);

      refClientName.setValidators([Validators.required]);
      refContactName.setValidators([Validators.required]);
      refContactTitle.setValidators([Validators.required]);
      refContactEmail.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
      refContactPhoneNumber.setValidators([Validators.required]);
      refIndustry.setValidators([Validators.required]);
      refDurationOfPartnership.setValidators([Validators.required]);
      refServicesProvided.setValidators([Validators.required]);
      refRevenue.setValidators([Validators.required, Validators.pattern(VMSConstants.revenueValidator)])
      address.setValidators([Validators.required]);
      city.setValidators([Validators.required]);
      firstName.setValidators([Validators.required]);
      lastName.setValidators([Validators.required]);
      vendorName.setValidators([Validators.required]);
      vendorEmailId.setValidators([Validators.required, this.emailValidator("Others"),Validators.pattern(VMSConstants.emailValidator)]);
      adminEmailId.setValidators([Validators.required, this.emailValidator("Others"), Validators.pattern(VMSConstants.emailValidator)]);
      glEffDate.clearValidators();
      glExpDate.clearValidators();
      alEffDate.clearValidators();
      alExpDate.clearValidators();
      ulEffDate.clearValidators();
      ulExpDate.clearValidators();
      wcEffDate.clearValidators();
      wcExpDate.clearValidators();
      plEffDate.clearValidators();
      plExpDate.clearValidators();
      // glEffDate.setValidators([Validators.required]);
      // glExpDate.setValidators([Validators.required]);
      // alEffDate.setValidators([Validators.required]);
      // alExpDate.setValidators([Validators.required]);
      // ulEffDate.setValidators([Validators.required]);
      // ulExpDate.setValidators([Validators.required]);
      // wcEffDate.setValidators([Validators.required]);
      // wcExpDate.setValidators([Validators.required]);
      // plEffDate.setValidators([Validators.required]);
      // plExpDate.setValidators([Validators.required]);
    }
    webAddress.updateValueAndValidity();
    address.updateValueAndValidity();
    city.updateValueAndValidity();
    phoneNumber.updateValueAndValidity();
    vendorPhoneNumber.updateValueAndValidity();
    zipcode.updateValueAndValidity();
    firstName.updateValueAndValidity();
    lastName.updateValueAndValidity();
    vendorName.updateValueAndValidity();
    taxIdNumber.updateValueAndValidity();
    companyEstablishment.updateValueAndValidity();
    companysKeyCapabilities.updateValueAndValidity();
    corporateHistory.updateValueAndValidity();
    awardsAndCertifications.updateValueAndValidity();
    companyRevenueLastYear.updateValueAndValidity();
    companyRevenue2YearsBefore.updateValueAndValidity();
    companyRevenue3YearsBefore.updateValueAndValidity();
    noofW2Employees.updateValueAndValidity();
    noofC2CConsultant.updateValueAndValidity();
    noofOPTCandidatesAvailable.updateValueAndValidity();
    oPTTechnologyTrain.updateValueAndValidity();
    noofTNVisaCandidates.updateValueAndValidity();
    availableCandidateBench.updateValueAndValidity();

    ownerName.updateValueAndValidity();
    ownerTitle.updateValueAndValidity();
    ownerEmail.updateValueAndValidity();
    ownerPhone.updateValueAndValidity();
    ownerAlternatePhone.updateValueAndValidity();

    recruitingName.updateValueAndValidity();
    recruitingTitle.updateValueAndValidity();
    recruitingEmail.updateValueAndValidity();
    recruitingPhone.updateValueAndValidity();
    recruitingAlternatePhone.updateValueAndValidity();

    financialName.updateValueAndValidity();
    financialTitle.updateValueAndValidity();
    financialEmail.updateValueAndValidity();
    financialPhone.updateValueAndValidity();
    financialAlternatePhone.updateValueAndValidity();

    accountingName.updateValueAndValidity();
    accountingTitle.updateValueAndValidity();
    accountingEmail.updateValueAndValidity();
    accountingPhone.updateValueAndValidity();
    accountingAlternatePhone.updateValueAndValidity();
    hbContactName.updateValueAndValidity();
    hbPhone.updateValueAndValidity();
    hbOfficeCityState.updateValueAndValidity();
    hbAddress.updateValueAndValidity();

    refClientName.updateValueAndValidity();
    refContactName.updateValueAndValidity();
    refContactTitle.updateValueAndValidity();
    refContactEmail.updateValueAndValidity();
    refContactPhoneNumber.updateValueAndValidity();
    refIndustry.updateValueAndValidity();
    refDurationOfPartnership.updateValueAndValidity();
    refServicesProvided.updateValueAndValidity();
    refRevenue.updateValueAndValidity();
    vendorEmailId.updateValueAndValidity();
    adminEmailId.updateValueAndValidity();
    glEffDate.updateValueAndValidity();
    glExpDate.updateValueAndValidity();
    alExpDate.updateValueAndValidity();
    ulEffDate.updateValueAndValidity();
    ulExpDate.updateValueAndValidity();
    wcEffDate.updateValueAndValidity();
    wcExpDate.updateValueAndValidity();
    plEffDate.updateValueAndValidity();
    plExpDate.updateValueAndValidity();

  }

  getEntityTypeOnChangeEdit() {
    this.entityTypeEnable = false;
    const webAddress = this.registerProfileForm.get('webAddress');
    const address = this.registerProfileForm.get('addressLine1');
    const city = this.registerProfileForm.get('city');
    const firstName = this.registerProfileForm.get('firstName');
    const lastName = this.registerProfileForm.get('lastName');
    const phoneNumber = this.registerProfileForm.get('phoneNumber');
    const vendorPhoneNumber = this.registerProfileForm.get('vendorPhoneNumber');
    const zipcode = this.registerProfileForm.get('zipCode');
    const taxIdNumber = this.registerProfileForm.get('taxIdNumber');
    const vendorEmailId = this.registerProfileForm.get('vendorEmailId');
    const adminEmailId = this.registerProfileForm.get('adminEmailId');

    const companyEstablishment = this.registerProfileForm.get('companyEstablishment');
    const companysKeyCapabilities = this.registerProfileForm.get('companysKeyCapabilities');
    const corporateHistory = this.registerProfileForm.get('corporateHistory');
    const awardsAndCertifications = this.registerProfileForm.get('awardsAndCertifications');
    const companyRevenueLastYear = this.registerProfileForm.get('companyRevenueLastYear');
    const companyRevenue2YearsBefore = this.registerProfileForm.get('companyRevenue2YearsBefore');
    const companyRevenue3YearsBefore = this.registerProfileForm.get('companyRevenue3YearsBefore');
    const noofW2Employees = this.registerProfileForm.get('noofW2Employees');
    const noofC2CConsultant = this.registerProfileForm.get('noofC2CConsultant');
    const noofOPTCandidatesAvailable = this.registerProfileForm.get('noofOPTCandidatesAvailable');
    const oPTTechnologyTrain = this.registerProfileForm.get('oPTTechnologyTrain');
    const noofTNVisaCandidates = this.registerProfileForm.get('noofTNVisaCandidates');
    const availableCandidateBench = this.registerProfileForm.get('availableCandidateBench');

    const ownerName = this.registerProfileForm.get('ownerName');
    const ownerTitle = this.registerProfileForm.get('ownerTitle');
    const ownerEmail = this.registerProfileForm.get('ownerEmail');
    const ownerPhone = this.registerProfileForm.get('ownerPhone');
    const ownerAlternatePhone = this.registerProfileForm.get('ownerAlternatePhone');

    const recruitingName = this.registerProfileForm.get('recruitingName');
    const recruitingTitle = this.registerProfileForm.get('recruitingTitle');
    const recruitingEmail = this.registerProfileForm.get('recruitingEmail');
    const recruitingPhone = this.registerProfileForm.get('recruitingPhone');
    const recruitingAlternatePhone = this.registerProfileForm.get('recruitingAlternatePhone');

    const financialName = this.registerProfileForm.get('financialName');
    const financialTitle = this.registerProfileForm.get('financialTitle');
    const financialEmail = this.registerProfileForm.get('financialEmail');
    const financialPhone = this.registerProfileForm.get('financialPhone');
    const financialAlternatePhone = this.registerProfileForm.get('financialAlternatePhone');

    const accountingName = this.registerProfileForm.get('accountingName');
    const accountingTitle = this.registerProfileForm.get('accountingTitle');
    const accountingEmail = this.registerProfileForm.get('accountingEmail');
    const accountingPhone = this.registerProfileForm.get('accountingPhone');
    const accountingAlternatePhone = this.registerProfileForm.get('accountingAlternatePhone');
    const hbContactName = this.registerProfileFormControl['onshoreFields']['controls'][0]['controls']['contactName'];
    const hbPhone = this.registerProfileFormControl['onshoreFields']['controls'][0]['controls']['phone'];
    const hbOfficeCityState = this.registerProfileFormControl['onshoreFields']['controls'][0]['controls']['officeCityState'];
    const hbAddress = this.registerProfileFormControl['onshoreFields']['controls'][0]['controls']['address'];

    const refClientName = this.registerProfileForm.controls['referenceFields']['controls'][0]['controls']['refClientName'];
    const refContactName = this.registerProfileForm.controls['referenceFields']['controls'][0]['controls']['refContactName'];
    const refContactTitle = this.registerProfileForm.controls['referenceFields']['controls'][0]['controls']['refContactTitle'];
    const refContactEmail = this.registerProfileForm.controls['referenceFields']['controls'][0]['controls']['refContactEmail'];
    const refContactPhoneNumber = this.registerProfileForm.controls['referenceFields']['controls'][0]['controls']['refContactPhoneNumber'];
    const refIndustry = this.registerProfileForm.controls['referenceFields']['controls'][0]['controls']['refIndustry'];
    const refDurationOfPartnership = this.registerProfileForm.controls['referenceFields']['controls'][0]['controls']['refDurationOfPartnership'];
    const refServicesProvided = this.registerProfileForm.controls['referenceFields']['controls'][0]['controls']['refServicesProvided'];
    const refRevenue = this.registerProfileForm.controls['referenceFields']['controls'][0]['controls']['refRevenue'];


    const glEffDate = this.registerProfileForm.get('glEffDate');
    const glExpDate = this.registerProfileForm.get('glExpDate');
    const alEffDate = this.registerProfileForm.get('alEffDate');
    const alExpDate = this.registerProfileForm.get('alExpDate');
    const ulEffDate = this.registerProfileForm.get('ulEffDate');
    const ulExpDate = this.registerProfileForm.get('ulExpDate');
    const wcEffDate = this.registerProfileForm.get('wcEffDate');
    const wcExpDate = this.registerProfileForm.get('wcExpDate');
    const plEffDate = this.registerProfileForm.get('plEffDate');
    const plExpDate = this.registerProfileForm.get('plExpDate');

    if (this.entityTypeEdit == 'Individual') {
      this.forIndividual = true;
      this.coiValid = false;
      this.msaValid = false;
      this.ddAuthorizationValid = false;
      this.w9FormValid = false;
      this.businessCertificationValid = false;
      this.selectedCountryValid = false;
      webAddress.setValidators([Validators.pattern(VMSConstants.urlRegex)]);
      taxIdNumber.clearValidators();
      companyEstablishment.clearValidators();
      companysKeyCapabilities.clearValidators();
      corporateHistory.clearValidators();
      awardsAndCertifications.clearValidators();
      companyRevenueLastYear.clearValidators();
      companyRevenue2YearsBefore.clearValidators();
      companyRevenue3YearsBefore.clearValidators();
      noofW2Employees.clearValidators();
      noofC2CConsultant.clearValidators();
      noofOPTCandidatesAvailable.clearValidators();
      oPTTechnologyTrain.clearValidators();
      noofTNVisaCandidates.clearValidators();
      availableCandidateBench.clearValidators();

      ownerName.clearValidators();
      ownerTitle.clearValidators();
      ownerEmail.setValidators([Validators.pattern(VMSConstants.emailValidator)]);
      ownerPhone.clearValidators();
      ownerAlternatePhone.clearValidators();

      recruitingName.clearValidators();
      recruitingTitle.clearValidators();
      recruitingEmail.setValidators([Validators.pattern(VMSConstants.emailValidator)]);
      recruitingPhone.clearValidators();
      recruitingAlternatePhone.clearValidators();

      financialName.clearValidators();
      financialTitle.clearValidators();
      financialEmail.setValidators([Validators.pattern(VMSConstants.emailValidator)]);
      financialPhone.clearValidators();
      financialAlternatePhone.clearValidators();

      accountingName.clearValidators();
      accountingTitle.clearValidators();
      accountingEmail.setValidators([Validators.pattern(VMSConstants.emailValidator)]);
      accountingPhone.clearValidators();
      accountingAlternatePhone.clearValidators();

      hbContactName.clearValidators();
      hbPhone.clearValidators();
      hbOfficeCityState.clearValidators();
      hbAddress.clearValidators();

      refClientName.clearValidators();
      refContactName.clearValidators();
      refContactTitle.clearValidators();
      refContactEmail.clearValidators();
      refContactPhoneNumber.clearValidators();
      refIndustry.clearValidators();
      refDurationOfPartnership.clearValidators();
      refServicesProvided.clearValidators();
      refRevenue.setValidators(Validators.pattern(VMSConstants.revenueValidator));
      address.setValidators([Validators.required]);
      city.setValidators([Validators.required]);
      firstName.setValidators([Validators.required]);
      lastName.setValidators([Validators.required]);
      phoneNumber.setValidators([Validators.required]);
      vendorPhoneNumber.setValidators([Validators.required]);
      zipcode.setValidators([Validators.required, Validators.pattern(VMSConstants.zipcodeValidator)]);
      vendorEmailId.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
      adminEmailId.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
      glEffDate.clearValidators();
      glExpDate.clearValidators();
      alEffDate.clearValidators();
      alExpDate.clearValidators();
      ulEffDate.clearValidators();
      ulExpDate.clearValidators();
      wcEffDate.clearValidators();
      wcExpDate.clearValidators();
      plEffDate.clearValidators();
      plExpDate.clearValidators();
      companysKeyCapabilities.setValidators([this.editorMaxLength(10000)]);
      corporateHistory.setValidators([this.editorMaxLength(10000)]);
      awardsAndCertifications.setValidators([this.editorMaxLength(2000)]);
      availableCandidateBench.setValidators([this.editorMaxLength(1000)]);

    } else {
      this.forIndividual = false;
      webAddress.setValidators([ Validators.pattern(VMSConstants.urlRegex)]);
      taxIdNumber.setValidators([Validators.required]);
      companyEstablishment.setValidators([Validators.required]);
      companysKeyCapabilities.setValidators([Validators.required, this.editorMaxLength(10000)]);
      corporateHistory.setValidators([Validators.required, this.editorMaxLength(10000)]);
      awardsAndCertifications.setValidators([Validators.required, this.editorMaxLength(5000)]);
      companyRevenueLastYear.setValidators([Validators.required]);
      companyRevenue2YearsBefore.setValidators([Validators.required]);
      companyRevenue3YearsBefore.setValidators([Validators.required]);
      noofW2Employees.setValidators([Validators.required]);
      noofC2CConsultant.setValidators([Validators.required]);
      if (this.showOPT == true) {
        noofOPTCandidatesAvailable.setValidators([Validators.required]);
        oPTTechnologyTrain.setValidators([Validators.required]);
      }
      else if (this.showOPT == false) {
        noofOPTCandidatesAvailable.clearValidators();
        oPTTechnologyTrain.clearValidators();
      }
      if (this.showTNVisa == true) {
        noofTNVisaCandidates.setValidators([Validators.required]);
      }
      else if (this.showTNVisa == false) {
        noofTNVisaCandidates.clearValidators();
      }

      availableCandidateBench.setValidators([Validators.required, this.editorMaxLength(1000)]);

      ownerName.setValidators([Validators.required]);
      ownerTitle.setValidators([Validators.required]);
      ownerEmail.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
      ownerPhone.setValidators([Validators.required]);
      ownerAlternatePhone.setValidators([Validators.required]);

      recruitingName.setValidators([Validators.required]);
      recruitingTitle.setValidators([Validators.required]);
      recruitingEmail.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
      recruitingPhone.setValidators([Validators.required]);
      recruitingAlternatePhone.setValidators([Validators.required]);

      financialName.setValidators([Validators.required]);
      financialTitle.setValidators([Validators.required]);
      financialEmail.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
      financialPhone.setValidators([Validators.required]);
      financialAlternatePhone.setValidators([Validators.required]);

      accountingName.setValidators([Validators.required]);
      accountingTitle.setValidators([Validators.required]);
      accountingEmail.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
      accountingPhone.setValidators([Validators.required]);
      accountingAlternatePhone.setValidators([Validators.required]);

      hbContactName.setValidators([Validators.required]);
      hbPhone.setValidators([Validators.required]);
      hbOfficeCityState.setValidators([Validators.required]);
      hbAddress.setValidators([Validators.required]);

      refClientName.setValidators([Validators.required]);
      refContactName.setValidators([Validators.required]);
      refContactTitle.setValidators([Validators.required]);
      refContactEmail.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
      refContactPhoneNumber.setValidators([Validators.required]);
      refIndustry.setValidators([Validators.required]);
      refDurationOfPartnership.setValidators([Validators.required]);
      refServicesProvided.setValidators([Validators.required]);
      refRevenue.setValidators([Validators.required, Validators.pattern(VMSConstants.revenueValidator)]);
      address.setValidators([Validators.required]);
      city.setValidators([Validators.required]);
      firstName.setValidators([Validators.required]);
      lastName.setValidators([Validators.required]);
      phoneNumber.setValidators([Validators.required]);
      vendorPhoneNumber.setValidators([Validators.required]);
      zipcode.setValidators([Validators.required, Validators.pattern(VMSConstants.zipcodeValidator)]);
      vendorEmailId.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
      adminEmailId.setValidators([Validators.required,  this.emailValidator("Others"),Validators.pattern(VMSConstants.emailValidator)]);
      glEffDate.clearValidators();
      glExpDate.clearValidators();
      alEffDate.clearValidators();
      alExpDate.clearValidators();
      ulEffDate.clearValidators();
      ulExpDate.clearValidators();
      wcEffDate.clearValidators();
      wcExpDate.clearValidators();
      plEffDate.clearValidators();
      plExpDate.clearValidators();
      // glEffDate.setValidators([Validators.required]);
      // glExpDate.setValidators([Validators.required]);
      // alEffDate.setValidators([Validators.required]);
      // alExpDate.setValidators([Validators.required]);
      // ulEffDate.setValidators([Validators.required]);
      // ulExpDate.setValidators([Validators.required]);
      // wcEffDate.setValidators([Validators.required]);
      // wcExpDate.setValidators([Validators.required]);
      // plEffDate.setValidators([Validators.required]);
      // plExpDate.setValidators([Validators.required]);
    }
    webAddress.updateValueAndValidity();
    address.updateValueAndValidity();
    city.updateValueAndValidity();
    phoneNumber.updateValueAndValidity();
    vendorPhoneNumber.updateValueAndValidity();
    zipcode.updateValueAndValidity();
    firstName.updateValueAndValidity();
    lastName.updateValueAndValidity();
    taxIdNumber.updateValueAndValidity();
    companyEstablishment.updateValueAndValidity();
    companysKeyCapabilities.updateValueAndValidity();
    corporateHistory.updateValueAndValidity();
    awardsAndCertifications.updateValueAndValidity();
    companyRevenueLastYear.updateValueAndValidity();
    companyRevenue2YearsBefore.updateValueAndValidity();
    companyRevenue3YearsBefore.updateValueAndValidity();
    noofW2Employees.updateValueAndValidity();
    noofC2CConsultant.updateValueAndValidity();
    noofOPTCandidatesAvailable.updateValueAndValidity();
    oPTTechnologyTrain.updateValueAndValidity();
    noofTNVisaCandidates.updateValueAndValidity();
    availableCandidateBench.updateValueAndValidity();

    ownerName.updateValueAndValidity();
    ownerTitle.updateValueAndValidity();
    ownerEmail.updateValueAndValidity();
    ownerPhone.updateValueAndValidity();
    ownerAlternatePhone.updateValueAndValidity();

    recruitingName.updateValueAndValidity();
    recruitingTitle.updateValueAndValidity();
    recruitingEmail.updateValueAndValidity();
    recruitingPhone.updateValueAndValidity();
    recruitingAlternatePhone.updateValueAndValidity();

    financialName.updateValueAndValidity();
    financialTitle.updateValueAndValidity();
    financialEmail.updateValueAndValidity();
    financialPhone.updateValueAndValidity();
    financialAlternatePhone.updateValueAndValidity();

    accountingName.updateValueAndValidity();
    accountingTitle.updateValueAndValidity();
    accountingEmail.updateValueAndValidity();
    accountingPhone.updateValueAndValidity();
    accountingAlternatePhone.updateValueAndValidity();

    hbContactName.updateValueAndValidity();
    hbPhone.updateValueAndValidity();
    hbOfficeCityState.updateValueAndValidity();
    hbAddress.updateValueAndValidity();

    refClientName.updateValueAndValidity();
    refContactName.updateValueAndValidity();
    refContactTitle.updateValueAndValidity();
    refContactEmail.updateValueAndValidity();
    refContactPhoneNumber.updateValueAndValidity();
    refIndustry.updateValueAndValidity();
    refDurationOfPartnership.updateValueAndValidity();
    refServicesProvided.updateValueAndValidity();
    refRevenue.updateValueAndValidity();
    vendorEmailId.updateValueAndValidity();
    adminEmailId.updateValueAndValidity();
    glEffDate.updateValueAndValidity();
    glExpDate.updateValueAndValidity();
    alExpDate.updateValueAndValidity();
    ulEffDate.updateValueAndValidity();
    ulExpDate.updateValueAndValidity();
    wcEffDate.updateValueAndValidity();
    wcExpDate.updateValueAndValidity();
    plEffDate.updateValueAndValidity();
    plExpDate.updateValueAndValidity();

  }

  @ViewChild('MSAUpload') MSAfileInput;
  uploadMSAFile(): void {
    this.messageService.add({key: 'msa',severity:'success', summary:'Confirmed', detail:'MSA successfully uploaded'});
    let fi = this.MSAfileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      this.uploadedMSAFile = fi.files[0];
      if (this.userName == undefined) {
        this.registerService.uploadMSAFile(this.uploadedMSAFile).subscribe((res) => {
          this.MSAUploadedPath = res;
          this.splittedMSAUploadedPath = this.MSAUploadedPath.split("/");
          res = res.substring(1);
          this.msaFileDocUrl = VMSConstants.registrationDocumentBaseUrl + res;
          this.showMSAFormFilePreview = false;
          setTimeout(() => {
            this.showMSAFormFilePreview = true;
          }, 5000);
          this.showMSAFormFilePreview = false;
          this.showMSAFormFilePreviewEnable = true;
          this.MSAfileInput.nativeElement.value ='';
        });
      }
      else {
        this.registerService.saveCompanyMSAUrl(this.companyId, this.uploadedMSAFile).subscribe((res) => {
          this.MSAUploadedPath = res;
          this.splittedMSAUploadedPath = this.MSAUploadedPath.split("/");
          this.msaFileDocUrl = VMSConstants.registrationDocumentBaseUrl + res;
          this.showMSAFormFilePreview = false;
          setTimeout(() => {
            this.showMSAFormFilePreview = true;
          }, 5000);
          this.showMSAFormFilePreview = false;
          this.showMSAFormFilePreviewEnable = true;
        });
      }
    }
  }

  onEnableOffshoreFields(event) {
    if (event.checked == true) {
      this.showOffShoreFields = true;
    }
    else if (event.checked == false) {
      this.showOffShoreFields = false;
    }
  }

  onEnableOPT(event) {
    if (event.checked == true) {
      this.showOPT = true;
      const noofOPTCandidatesAvailable = this.registerProfileForm.get('noofOPTCandidatesAvailable');
      const oPTTechnologyTrain = this.registerProfileForm.get('oPTTechnologyTrain');
      noofOPTCandidatesAvailable.clearValidators();
      oPTTechnologyTrain.clearValidators();
      noofOPTCandidatesAvailable.setValidators([Validators.required]);
      oPTTechnologyTrain.setValidators([Validators.required]);
      noofOPTCandidatesAvailable.updateValueAndValidity();
      oPTTechnologyTrain.updateValueAndValidity();
    }
    else if (event.checked == false) {
      this.showOPT = false;
      const noofOPTCandidatesAvailable = this.registerProfileForm.get('noofOPTCandidatesAvailable');
      const oPTTechnologyTrain = this.registerProfileForm.get('oPTTechnologyTrain');
      noofOPTCandidatesAvailable.clearValidators();
      oPTTechnologyTrain.clearValidators();
      noofOPTCandidatesAvailable.updateValueAndValidity();
      oPTTechnologyTrain.updateValueAndValidity();
    }
  }
  onEnableTNVisa(event) {
    if (event.checked == true) {
      this.showTNVisa = true;
      this.selectedCountryValid = true;
      const noofTNVisaCandidates = this.registerProfileForm.get('noofTNVisaCandidates');
      noofTNVisaCandidates.clearValidators();
      noofTNVisaCandidates.setValidators([Validators.required]);
      noofTNVisaCandidates.updateValueAndValidity();
    }
    else if (event.checked == false) {
      this.showTNVisa = false;
      this.selectedCountryValid = false;
      const noofTNVisaCandidates = this.registerProfileForm.get('noofTNVisaCandidates');
      noofTNVisaCandidates.clearValidators();
      noofTNVisaCandidates.updateValueAndValidity();
    }
  }
  onInsuranceSelect(event) {
    if(event.target.value != '')
    {
      this.InsuranceFileExtension = event.target.value;
      this.InsuranceFileExtension = this.InsuranceFileExtension.split('\\').pop().split('/').pop();
      if (this.InsuranceFileExtension.split('.').pop() == 'pdf' || this.InsuranceFileExtension.split('.').pop() == 'docx' || this.InsuranceFileExtension.split('.').pop() == 'doc' || this.InsuranceFileExtension.split('.').pop() == 'xls' || this.InsuranceFileExtension.split('.').pop() == 'xlsx' || this.InsuranceFileExtension.split('.').pop() == 'PDF' || this.InsuranceFileExtension.split('.').pop() == 'Pdf') {
        /*const pdfTatget: any = event.target;
        if (typeof FileReader !== 'undefined') {
          const reader = new FileReader();
          reader.onload = (e: any) => {
            this.InsurancepdfSrc = e.target.result;
          };
          reader.readAsArrayBuffer(pdfTatget.files[0]);
          this.showInsurancePreview = true;
          this.uploadInsuranceFile();
          this.isInsurancefileShowsuccessmsg = true;
          this.coiValid = false;
          this.Insurancefileuploadmessage = "COI successfully uploaded";
        }*/
  
        this.showInsurancePreview = true;
        this.uploadInsuranceFile();
        this.isInsurancefileShowsuccessmsg = true;
        this.coiValid = false;
        //this.Insurancefileuploadmessage = "COI uploaded successfully";
        this.Insurancefileuploadmessage  = this.InsuranceFileExtension;
      }
      else {
        this.showCOIFormFilePreviewEnable = false;
        this.coiValid = true;
        this.isInsurancefileShowsuccessmsg = false;
        this.Insurancefileuploadmessage = "Please select a valid file format (xls,xlsx,pdf,doc,docx)";
      }
    }
  }

  @ViewChild('InsuranceUpload') InsurancefileInput;
  uploadInsuranceFile(): void {
    this.messageService.add({key: 'coi',severity:'success', summary:'Confirmed', detail:'COI uploaded successfully'});
    let fi = this.InsurancefileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      this.uploadedInsuranceFile = fi.files[0];
      if (this.userName == undefined) {
        this.registerService.uploadInsuranceFile(this.uploadedInsuranceFile).subscribe((res) => {
          this.InsuranceUploadedPath = res;
          this.splittedInsuranceUploadedPath = this.InsuranceUploadedPath.split("/");
          res = res.substring(1);
          this.coiFileDocUrl = VMSConstants.registrationDocumentBaseUrl + res;
          this.showCOIFormFilePreview = false;
          // setTimeout(() => {
          //   this.showCOIFormFilePreview = true;
          // }, 5000);
          // this.showCOIFormFilePreview = false;
          this.showCOIFormFilePreviewEnable = true;
          this.InsurancefileInput.nativeElement.value = '';
          const ref = this.dialogService.open(DocViewerDialogComponent, {
            data: {
              fileUrl: this.coiFileDocUrl,
              title: 'COI',
              fileName: this.InsuranceUploadedPath,
            },
            width: '100%',
            height: '100%',
            baseZIndex: 10000,
            showHeader: false,
          });
        });
      }
      else {
        this.registerService.saveCompanyInsuranceUrl(this.companyId, this.uploadedInsuranceFile).subscribe((res) => {
          this.InsuranceUploadedPath = res;
          this.splittedInsuranceUploadedPath = this.InsuranceUploadedPath.split("/");
          this.coiFileDocUrl = VMSConstants.registrationDocumentBaseUrl + res;
          this.showCOIFormFilePreview = false;
          // setTimeout(() => {
          //   this.showCOIFormFilePreview = true;
          // }, 5000);
          // this.showCOIFormFilePreview = false;
          this.showCOIFormFilePreviewEnable = true;
          const ref = this.dialogService.open(DocViewerDialogComponent, {
            data: {
              fileUrl: this.coiFileDocUrl,
              title: 'COI',
              fileName: this.InsuranceUploadedPath,
            },
            width: '100%',
            height: '100%',
            baseZIndex: 10000,
            showHeader: false,
          });
        });
      }
    }
  }


  getW9FormFile() {
    /*this.registerService.GetW9FormUrl(this.w9FormFileName).subscribe(data => {
      var blob = new Blob([data.body], { type: data.body.type });
      const reader = new FileReader();
      reader.readAsArrayBuffer(blob);
      reader.addEventListener("load", () => {
        this.pdfSrc = reader.result;
      }, false);

    }, error => {
      console.log(error);
    });*/

    this.w9FileDocUrl = VMSConstants.registrationDocumentBaseUrl + this.w9FormFileName;
  }

  getDDAuthorizationFile() {
    /*this.registerService.GetDDAuthorizationFileUrl(this.ddAuthorizationFileName).subscribe(data => {
      var blob = new Blob([data.body], { type: data.body.type });
      const reader = new FileReader();
      reader.readAsArrayBuffer(blob);
      reader.addEventListener("load", () => {
        this.DDpdfSrc = reader.result;
      }, false);

    }, error => {
      console.log(error);
    });*/

    this.ddFileDocUrl = VMSConstants.registrationDocumentBaseUrl + this.ddAuthorizationFileName;
  }

  getMSAFile() {
    /*this.registerService.GetMSAFileUrl(this.msaFileName).subscribe(data => {
      var blob = new Blob([data.body], { type: data.body.type });
      const reader = new FileReader();
      reader.readAsArrayBuffer(blob);
      reader.addEventListener("load", () => {
        this.MSApdfSrc = reader.result;
      }, false);

    }, error => {
      console.log(error);
    });*/

    this.msaFileDocUrl = VMSConstants.registrationDocumentBaseUrl + this.msaFileName;
  }

  getInsuranceFile() {
    /*this.registerService.GetInsuranceFileUrl(this.insuranceFileName).subscribe(data => {
      var blob = new Blob([data.body], { type: data.body.type });
      const reader = new FileReader();
      reader.readAsArrayBuffer(blob);
      reader.addEventListener("load", () => {
        this.InsurancepdfSrc = reader.result;
      }, false);

    }, error => {
      console.log(error);
    });*/
    this.coiFileDocUrl = VMSConstants.registrationDocumentBaseUrl + this.insuranceFileName;
  }

  Showw9UploadedFile() {
    // this.showW9FormFilePreview = false;
    // setTimeout(() => {
    //   this.showW9FormFilePreview = true;
    // }, 5000);
    // this.showW9FormFilePreview = false;
    //this.showPreview = true;
    console.log(this.w9FormFileName);
    //this.w9FormDownload = this.w9FormFileName;
    const ref = this.dialogService.open(DocViewerDialogComponent, {
      data: {
        fileUrl: this.w9FileDocUrl,
        title: 'W9 Form',
        fileName: this.w9FileDocUrl,
      },
      width: '100%',
      height: '100%',
      baseZIndex: 10000,
      showHeader: false,
    });
  }

  ShowDDAuthorizationUploadedFile() {
    // this.showDDFormFilePreview = false;
    // setTimeout(() => {
    //   this.showDDFormFilePreview = true;
    // }, 5000);
    // this.showDDFormFilePreview = false;
    // this.showDDPreview = true;
    console.log(this.ddFileDocUrl);
    const ref = this.dialogService.open(DocViewerDialogComponent, {
      data: {
        fileUrl: this.ddFileDocUrl,
        title: 'DD Authorization',
        fileName: this.ddFileDocUrl,
      },
      width: '100%',
      height: '100%',
      baseZIndex: 10000,
      showHeader: false,
    });
  }

  ShowMSAUploadedFile() {
    // this.showMSAFormFilePreview = false;
    // setTimeout(() => {
    //   this.showMSAFormFilePreview = true;
    // }, 5000);
    // this.showMSAFormFilePreview = false;
    // this.showMSAPreview = true;
    console.log(this.msaFileDocUrl);
    const ref = this.dialogService.open(DocViewerDialogComponent, {
      data: {
        fileUrl: this.msaFileDocUrl,
        title: 'MSA',
        fileName: this.msaFileDocUrl,
      },
      width: '100%',
      height: '100%',
      baseZIndex: 10000,
      showHeader: false,
    });
  }

  ShowInsuranceUploadedFile() {
    // this.showCOIFormFilePreview = false;
    // setTimeout(() => {
    //   this.showCOIFormFilePreview = true;
    // }, 5000);
    // this.showCOIFormFilePreview = false;
    // this.showInsurancePreview = true;
    console.log(this.coiFileDocUrl);
    const ref = this.dialogService.open(DocViewerDialogComponent, {
      data: {
        fileUrl: this.coiFileDocUrl,
        title: 'COI',
        fileName: this.coiFileDocUrl,
      },
      width: '100%',
      height: '100%',
      baseZIndex: 10000,
      showHeader: false,
    });
  }

  editorMaxLength(maxlength): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      var regex = /(<([^>]+)>)/ig;
      var value = control.value;
      if (value == null) {
        return null;
      }
      var result = value.replace(regex, "");
      if (result.length > maxlength) {
        return { 'maxlengthError': true };
      } else {
        return null;
      }
    }
  }

  getClientListForRegistration() {
    this.categoryName = 'Client List For Registration';
    this.sharedService.getLookupCategory(this.categoryName).subscribe((data: any) => {
      this.clientListForRegistration = data;
    });
  }

  getClientListForRegistrationOnChange(event) {
    this.clientIdOnRegistration = event.value.lookupOrder;
    this.selectedClientValidOnRegistration = false;
  }

  getPaymentTerms() {
    this.categoryName = 'Payment Terms';
      this.sharedService.getLookupMasterByCategoryId(LookupCategory.PaymentTerms).subscribe((data: any) => {
      this.paymentTerms = data;
      this.paymentTerms  =data.filter(item => item.lookupOrder>= 1).filter(item=>item.lookupOrder<= 2);
    });
  }
  getPaymentTermsOnChange(event) {
    this.paymentTermsId = event.value.lookupOrder;
    this.paymentTermsIdOnMSADoc = event.value.lookupOrder;
    if(event.value.lookupOrder ==1)
    {
      this.net30WithFeeOnMSADoc = 'No';
      this.net45WithoutFeeOnMSADoc ='Yes';
      this.net30WithFee = false;
      this.net45WithoutFee = true;
    }
    else if(event.value.lookupOrder ==2)
    {
       this.net45WithoutFeeOnMSADoc = 'No';
       this.net30WithFeeOnMSADoc ='Yes';
       this.net30WithFee = true;
       this.net45WithoutFee = false;
    }
    this.isPaymentTermsEnable = false;
  }

getIpAddress()  
{  
  this.sharedService.getIPAddress().subscribe((res:any)=>{  
    this.ipAddress=res.ip;  
    console.log(res.ip);
  });  
} 
 /////msa signing//////////start///////////////

 
 pdf() {
  this.getTemplate();
  if(this.isSignatureTab == true || this.isTextTab == true || this.isImageUploadTab == true)
  {
    if(this.isSignatureTab == true)
    {
      if(this.sig.isEmpty() == true)
      {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please sign the document' });
      }
    }
    if(this.isTextTab == true)
    {
      if(this.signForm.controls['signText'].value == '')
      {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please add text' });
            this.showGenerateButton = true;
      }
    }
    if(this.isImageUploadTab == true)
    {
      if(this.imgBase64Path == undefined)
      {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please upload image' });
            this.showGenerateButton = true;
      }
    }
	
   
  if(this.sig.isEmpty() == false || this.signForm.controls['signText'].value !== '' || this.imgBase64Path !== undefined)
	{
	  setTimeout(() => {
		 let form = this.signForm.value;
         let sign = this.sig.toDataURL();
		if(this.msaTemplate !==undefined)
      {
        this.msaTemplate= this.msaTemplate.replace("{{dateOnDoc}}",this.dateOnDoc);
        this.msaTemplate= this.msaTemplate.replace("{{vendorNameOnMSADoc}}",this.vendorNameOnMSADoc);
        this.msaTemplate= this.msaTemplate.replace("{{taxIdOnMSADoc}}",this.taxIdOnMSADoc);
        this.msaTemplate= this.msaTemplate.replace("{{addressOnMSADoc}}",this.addressOnMSADoc);
        this.msaTemplate= this.msaTemplate.replace("{{cityOnMSADoc}}",this.cityOnMSADoc);
        this.msaTemplate= this.msaTemplate.replace("{{stateOnMSADoc}}",this.stateOnMSADoc);
        this.msaTemplate= this.msaTemplate.replace("{{zipCodeOnMSADoc}}",this.zipCodeOnMSADoc);
      }
      if(this.paymentTermsIdOnMSADoc ==1)
      {
        this.msaTemplate =this.msaTemplate.replace("<p><b>{{net30WithFeeOnMSADoc}} within thirty (30) days of DevCare Solutions' receipt of invoice and client approved timesheets from the Contractor.This payment option is subject to a charge of two percent (2%) of the invoice amount to be retained by DevCare Solutions.</b><br />"," ");
        this.msaTemplate =this.msaTemplate.replace("{{net45WithoutFeeOnMSADoc}}", "Yes");
      }
      else if(this.paymentTermsIdOnMSADoc ==2)
      {
        this.msaTemplate =this.msaTemplate.replace("{{net30WithFeeOnMSADoc}}", "Yes");
        this.msaTemplate =this.msaTemplate.replace("<p><b>{{net45WithoutFeeOnMSADoc}} within forty-five (45) days of DevCare Solutions' receipt of invoice and client approved timesheets from the Contractor.</b><br />", " ");
      }
      else{
        this.msaTemplate =this.msaTemplate.replace("<p><b>{{net30WithFeeOnMSADoc}} within thirty (30) days of DevCare Solutions' receipt of invoice and client approved timesheets from the Contractor.This payment option is subject to a charge of two percent (2%) of the invoice amount to be retained by DevCare Solutions.</b><br />", " ");
        this.msaTemplate =this.msaTemplate.replace("<p><b>{{net45WithoutFeeOnMSADoc}} within forty-five (45) days of DevCare Solutions' receipt of invoice and client approved timesheets from the Contractor.</b><br />", "</p><p>");
      }
      if(this.address2OnMSADoc == undefined || this.address2OnMSADoc == null)
      {
        this.msaTemplate= this.msaTemplate.replace("{{address2OnMSADoc}},",'');
      }
      else if(this.address2OnMSADoc.trim() == '')
      {
        this.msaTemplate= this.msaTemplate.replace("{{address2OnMSADoc}},",'');
      }
      else{
        this.msaTemplate= this.msaTemplate.replace("{{address2OnMSADoc}}",this.address2OnMSADoc);
      }
      var html = htmlToPdfmake(this.msaTemplate, {removeExtraBlanks:true});
      var ct: any = [];
      ct.push(' ');
      ct.push(' ');
      ct.push({
        columns: [
          {
            width: '50%',
            text: 'Devcare Solutions',
            bold: true,
            fontSize: 9,
            margin: 0
          },
          {
            width: '50%',
            text: form.vendorName,
            bold: true,
            fontSize: 9,
            margin: 0
          },
        ],
        columnGap: 180
      })
      ct.push(' ');
      ct.push({
        columns: [

          {
            width: '50%',
            text: 'Janakiram Ramakrishnan',
            bold: true,
            fontSize: 11
          },
          {
            width: '50%',
            text: form.name,
            bold: true,
            fontSize: 11,
          },

        ],
        columnGap: 180
      })

      ct.push(
        { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
        { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
      )
      ct.push({
        columns: [

          {
            width: '50%',
            text: 'Name (Print)',
            fontSize: 8,
            margin: [0, 2, 0, 0]
          },
          {
            width: '50%',
            text: 'Name (Print)',
            fontSize: 8,
            margin: [0, 2, 0, 0]
          },

        ],
        columnGap: 180
      })
      ct.push(' ');
      // ct.push(' ');
      ct.push({
        columns: [

          {
            width: '50%',
            text: 'HR Manager',
            bold: true,
            fontSize: 11
          },
          {
            width: '50%',
            text: form.title,
            bold: true,
            fontSize: 11
          },

        ],
        columnGap: 180
      })

      ct.push(
        { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
        { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
      )

      ct.push({
        columns: [

          {
            width: '50%',
            text: 'Title',
            fontSize: 8,
            margin: [0, 2, 0, 0]
          },
          {
            width: '50%',
            text: 'Title',
            fontSize: 8,
            margin: [0, 2, 0, 0]
          },

        ],
        columnGap: 180
      })
      ct.push(' ');
      // ct.push(' ');

    if(this.isSignatureTab == true)
	{
		    ct.push({
        table: {
          widths: [150, 180, 150],
          body: [
            [
              {
                image: 'hrsignImage',
                width: '120'
              },
              {

              },
              {
                image: 'userSignImage',
                width: '120'
              },
            ],
            [
              {
                text:  this.datePipe.transform(new Date(), "MM/dd/yyyy"),
              },
              {

              },
              {
                text:  this.datePipe.transform(new Date(), "MM/dd/yyyy"),
              },
            ],
          ]
        },
        layout: 'noBorders'
      })
	}
	 if (this.isTextTab == true)
	 {
		  ct.push({
        table: {
          widths: [150, 180, 150],
          body: [
            [
              {
                image: 'hrsignImage',
                width: '120'
              },
              {

              },
              {
                text: this.signForm.controls['signText'].value,
                font: 'cedarvillecursiveFont',
                fontSize: 15,
              },
            ],
            [
              {
                text: this.datePipe.transform(new Date(), "MM/dd/yyyy"),
              },
              {

              },
              {
                text: this.datePipe.transform(new Date(), "MM/dd/yyyy"),
              },
            ],
          ]
        },
        layout: 'noBorders'
      })
	 }
	 if(this.isImageUploadTab == true)
	 {
		  ct.push({
          table: {
            widths: [150, 180, 150],
            body: [
              [
                {
                  image: 'hrsignImage',
                  width: '120'
                },
                {

                },
                {
                   image: 'userSignImageBase64Path',
                  width: '120'
                },
              ],
              [
                {
                  text: this.datePipe.transform(new Date(), "MM/dd/yyyy"),
                },
                {

                },
                {
                  text: this.datePipe.transform(new Date(), "MM/dd/yyyy"),
                },
              ],
            ]
          },
          layout: 'noBorders'
        })
	 }
  



      ct.push(
        { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
        { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
      )

      ct.push({
        columns: [

          {
            width: '50%',
            text: 'Sign',
            fontSize: 8,
            margin: [0, 2, 0, 0]
          },
          {
            width: '50%',
            text: 'Sign',
            fontSize: 8,
            margin: [0, 2, 0, 0]
          },

        ],
        columnGap: 180
      })
      ct.push({

      });
      //let value = html.concat(html, ct)
      let value = html;
      for (let i = 0; i < ct.length; i++) {
        value.push(ct[i])
      }
      
      if(this.isSignatureTab ==true)
      {
        var docDefinition: any = {
          header: {
            image: 'logoImage',
            width: '100',
            margin: [40, 20, 40, 60],
          },
          pageMargins: [40, 60, 40, 60],
          footer: function (currentPage: any, pageCount: any) {
            return {
              table: {
                widths: '*',
                body: [
                  [
                    { text: 'Devcare Solutions, Ltd.', alignment: 'left', style: 'normalText', margin: [30, 20,50, 0], aligment: 'right' },
                    { text: 'Page ' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'normalText', margin: [0, 20, 50, 0], aligment: 'left' }
                  ]
                ]
              },
              layout: 'noBorders'
            };
          },
          permissions: {
            printing: 'highResolution',
            modifying: false,
            copying: false
          },
          content: value,
          defaultStyle: {
            fontSize: 9,
            alignment: 'justify'
          },
          images: {
            hrsignImage: this.hrSign,
            userSignImage: sign,
            logoImage: this.logoOnMSA
          }
        };
      }
      if(this.isTextTab ==true)
      {
        var docDefinition: any = {
          header: {
            image: 'logoImage',
            width: '100',
            margin: [40, 20, 40, 60],
          },
          pageMargins: [40, 60, 40, 60],
          footer: function (currentPage: any, pageCount: any) {
            return {
              table: {
                widths: '*',
                body: [
                  [
                    { text: 'Devcare Solutions, Ltd.', alignment: 'left', style: 'normalText', margin: [30, 20,50, 0], aligment: 'right' },
                    { text: 'Page ' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'normalText', margin: [0, 20, 50, 0], aligment: 'left' }
                  ]
                ]
              },
              layout: 'noBorders'
            };
          },
          permissions: {
            printing: 'highResolution',
            modifying: false,
            copying: false
          },
          content: value,
          defaultStyle: {
            fontSize: 9,
            alignment: 'justify'
          },
          images: {
            hrsignImage: this.hrSign,
            userSignImage: sign,
            logoImage: this.logoOnMSA
          }
        };
      }
      if(this.isImageUploadTab ==true)
      {
        var docDefinition: any = {
          header: {
            image: 'logoImage',
            width: '100',
            margin: [40, 20, 40, 60],
          },
          pageMargins: [40, 60, 40, 60],
          footer: function (currentPage: any, pageCount: any) {
            return {
              table: {
                widths: '*',
                body: [
                  [
                    { text: 'Devcare Solutions, Ltd.', alignment: 'left', style: 'normalText', margin: [30, 20,50, 0], aligment: 'right' },
                    { text: 'Page ' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'normalText', margin: [0, 20, 50, 0], aligment: 'left' }
                  ]
                ]
              },
              layout: 'noBorders'
            };
          },
          permissions: {
            printing: 'highResolution',
            modifying: false,
            copying: false
          },
          content: value,
          defaultStyle: {
            fontSize: 9,
            alignment: 'justify'
          },
          images: {
            hrsignImage: this.hrSign,
            userSignImageBase64Path: this.imgBase64Path,
            logoImage: this.logoOnMSA
          }
        };
      }
      
      
      const pdfDocGenerator = pdfMake.createPdf(docDefinition);
      pdfDocGenerator.getBlob((blob) => {
        this.blobFile = blob;
        //const url = URL.createObjectURL(blob);
        //window.open(url, '_blank');
        const file = new File([this.blobFile], "DEVCAREMSA.pdf", { type: 'application/pdf' });
        if (this.userName == undefined) {
          this.registerService.uploadMSAFile(file).subscribe((res) => {
            this.MSAUploadedPath = res;
            this.splittedMSAUploadedPath = this.MSAUploadedPath.split("/");
            res = res.substring(1);
            this.msaFileDocUrl = VMSConstants.registrationDocumentBaseUrl + res;
            this.showMSAFormFilePreview = false;
            setTimeout(() => {
              this.showMSAFormFilePreview = true;
            }, 5000);
            this.showMSAFormFilePreview = false;
            this.showMSAFormFilePreviewEnable = true;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'MSA uploaded successfully' });
          });
        }
        else {
          this.registerService.saveCompanyMSAUrl(this.companyId, file).subscribe((res) => {
            this.MSAUploadedPath = res;
            this.splittedMSAUploadedPath = this.MSAUploadedPath.split("/");
            this.msaFileDocUrl = VMSConstants.registrationDocumentBaseUrl + res;
            this.showMSAFormFilePreview = false;
            setTimeout(() => {
              this.showMSAFormFilePreview = true;
            }, 5000);
            this.showMSAFormFilePreview = false;
            this.showMSAFormFilePreviewEnable = true;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'MSA uploaded successfully' });
          });
        }
     this.msaValid = false;
      });
	}, 5000);
    }
  }
 }
pdfGen(pdf: any, text: any, x: number, y: number) {
  if (y > 250) {
    pdf.addPage();
    this.yPosition = 20
  }
  pdf.text(text, x, this.yPosition, { maxWidth: 175, align: 'justify' });
}

pdfImage(pdf: any, sign: any, x: number, y: number){
  if (y > 250) {
    pdf.addPage();
    this.yPosition = 20
  }
  pdf.addImage(sign, 'JPEG', x, this.yPosition, 45, 10)
}


setBoldAndNormalText(pdf: any, text: any, x: number, y: number) {
  if (y > 250) {
    pdf.addPage();
    this.yPosition = 20
  }
  let textMap = pdf.splitTextToSize(text, 180);
  let boldOpen = false
  let startX = x;
  let startY = this.yPosition;
  let startXCached = 15

  textMap.map((text: any, i: number) => {
    if (text) {
      const arrayOfNormalAndBoldText = text.split('**');
      const boldStr = 'bold';
      const normalOr = 'normal';
      arrayOfNormalAndBoldText.map((textItems: any, j: number) => {
        pdf.setFont('helvetica', boldOpen ? normalOr : boldStr);
        if (j % 2 === 0) {
          pdf.setFont('helvetica', boldOpen ? boldStr : normalOr);
        }
        pdf.text(textItems, startX, startY);
        startX = startX + pdf.getTextWidth(textItems) + 1;
      })
      boldOpen = this.isBoldOpen(arrayOfNormalAndBoldText.length, boldOpen);
      startX = startXCached;
      startY += 4;
    }
  })
}
setBoldAndNormalTextForName(pdf: any, text: any, x: number, y: number) {
  if (y > 250) {
    pdf.addPage();
    this.yPosition = 20
  }
  let textMap = pdf.splitTextToSize(text, 50);
  let boldOpen = false
  let startX = x;
  let startY = this.yPosition;
  let startXCached = 150
  this.nameOnDocLength = textMap.length;
  textMap.map((text: any, i: number) => {
    if (text) {
      const arrayOfNormalAndBoldText = text.split('**');
      const boldStr = 'bold';
      const normalOr = 'normal';
      arrayOfNormalAndBoldText.map((textItems: any, j: number) => {
        pdf.setFont('helvetica', boldOpen ? normalOr : boldStr);
        if (j % 2 === 0) {
          pdf.setFont('helvetica', boldOpen ? boldStr : normalOr);
        }
        pdf.text(textItems, startX, startY);
        startX = startX + pdf.getTextWidth(textItems) + 1;
      })
      boldOpen = this.isBoldOpen(arrayOfNormalAndBoldText.length, boldOpen);
      startX = startXCached;
      startY += 4;
    }
  })
}
 isBoldOpen = (arrayLength: any, valueBefore = false) => {
  const isEven = arrayLength % 2 === 0;
  const result = valueBefore !== isEven;

  return result;
}
clear() {
  this.sig.clear();
}

undo() {
  var data = this.sig.toData();
  if (data) {
    data.pop(); // remove the last dot or line
    this.sig.fromData(data);
  }
}
// openSignatureTab()
// {
//   this.isSignatureTab = true;
//   this.isTextTab = false;
//   this.isImageUploadTab = false;
// }
// openTextTab()
// {
//   this.isTextTab = true;
//   this.isSignatureTab = false;
//   this.isImageUploadTab = false;
// }
// openImageUploadTab()
// {
//   this.isTextTab = false;
//   this.isSignatureTab = false;
//   this.isImageUploadTab = true;

// }
onImageSelect(event, file: FileList) {
  this.imageFile = event.target.value;
  this.imageFile = this.imageFile.split('\\').pop().split('/').pop();
  if (this.imageFile.split('.').pop() == 'png' || this.imageFile.split('.').pop() == 'jpg' || this.imageFile.split('.').pop() == 'jpeg') {
    this.fileToUpload = file.item(0);
    //For Image Preview
    let reader = new FileReader();
    reader.onload = (event: any) => {
      this.imageUrl = event.target.result;
    }
    //console.log(this.fileToUpload);
    reader.readAsDataURL(this.fileToUpload);
    this.uploadImageFile();
    this.defaultImage = "";
  }
  else {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select valid file format (png,jpg,jpeg)' });
  }
}

@ViewChild('imageUpload') imagefileInput;
uploadImageFile(): void {
  let fi = this.imagefileInput.nativeElement;
  if (fi.files && fi.files[0]) {
    this.uploadedFileMSA = fi.files[0];
    if(this.uploadedFileMSA .size> 1e+6)
    {
        //alert('1');
    }
    else{
      //alert('2');
    }
    var reader = new FileReader();
    reader.onload = (event:any) => 
    {
        this.imgBase64Path = event.target.result;
    }
    reader.readAsDataURL(fi.files[0]);
  }
}


/////msa signing//////////end///////////////

isEnable()
{
  
  if((this.addressOnMSADoc== undefined || this.addressOnMSADoc== null|| this.addressOnMSADoc=="") ||
    (this.cityOnMSADoc == undefined || this.cityOnMSADoc== null|| this.cityOnMSADoc=="")||
    (this.stateOnMSADoc == undefined|| this.stateOnMSADoc== null|| this.stateOnMSADoc=="") ||
    (this.zipCodeOnMSADoc== undefined|| this.zipCodeOnMSADoc== null|| this.zipCodeOnMSADoc== ""))
  {
    var showGenerateButton = "true";
   return eval(showGenerateButton);
   //this.showGenerateButton = false;
  }
  else{
    var showGenerateButton = "false";
    return eval(showGenerateButton);
    //this.showGenerateButton = true;
  }
}

handleChange(e){
  if(e.index == 0){
    this.isSignatureTab = true;
    this.isTextTab = false;
    this.isImageUploadTab = false;
  }
  if(e.index == 1){
    this.isTextTab = true;
    this.isSignatureTab = false;
    this.isImageUploadTab = false;
  }
  if(e.index == 2){
    this.isTextTab = false;
    this.isSignatureTab = false;
    this.isImageUploadTab = true;
  }
}
}